// VENDAS DO VENDEDOR
import React  from 'react';
//import Modal from 'react-responsive-modal';
import PropTypes from 'prop-types';
import TextField from "material-ui/TextField";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import Dialog from "material-ui/Dialog";
import CircularProgress from 'material-ui/CircularProgress';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import pdfResumoPropostaPF from '../../relatorio/resumo_proposta_pf';
import {Colors, Styles} from '../../../../src/styles/theme';

import { Alert, Container, Col, Row, Form,  Button } from 'reactstrap';
import ReactToPrint from 'react-to-print';
import Cards from "react-credit-cards";
import '../../../assets/css/cards.css';
import axios from 'axios';
import InputMask from 'react-input-mask';
import urlBase from '../../../url-base';
import { MoipValidator } from 'moip-sdk-js';//validação de cartões de crédito
import {Link} from 'react-router';
import moment from 'moment';
import CurrencyInput from 'react-currency-input';
import {
  Step,
  Stepper,
  StepLabel,
} from 'material-ui/Stepper';
import '../../../assets/css/panel_form.css';
import '../../../assets/css/checkout.css';
import '../../../assets/css/print.css';


class FormPlan extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      IdBairro:"",
      nomeBairro:"",
      municipio:"",
      estado:"",
      planoSelecionado:"",
      phasesForm: 1,
      documentType: "rg",
      requiredField:{
        financialManager: {
          firstName: "REQUIRED", susNumber: "", email: "REQUIRED", homePhone: "",
          cellPhone: "REQUIRED", cellPhone2: "", motherName: "REQUIRED", cpf: "REQUIRED", rg: "", rgEmitter: "", dateOfBirth: "REQUIRED",
          maritalStatus: "REQUIRED", gender: "REQUIRED", cep: "REQUIRED", addressType: "REQUIRED", address: "REQUIRED",
          addressNumber: "REQUIRED", addressComplement: "", district: "REQUIRED", city: "REQUIRED", state: "REQUIRED"
        },
        holder: {
          firstName: "REQUIRED", susNumber: "", motherName: "REQUIRED", cpf: "REQUIRED", dateOfBirth: "REQUIRED",
          maritalStatus: "REQUIRED", gender: "REQUIRED"
        },
        dependent: {
          firstName: "REQUIRED", susNumber: "", motherName: "REQUIRED", cpf: "REQUIRED", dateOfBirth: "REQUIRED",
          maritalStatus: "REQUIRED", gender: "REQUIRED", parentage: "REQUIRED", portability: "REQUIRED"
        },
        paymentCreditCard:{
          cardCreditNumber:"REQUIRED", cardExpiring:"REQUIRED", cardHolderName: "REQUIRED"
        },
        paymentSlip:{

        },
        others:{
          dateSignatureContract: "REQUIRED",
          formHolder: "REQUIRED",
        }

      },
      financialManager: {
        firstName: "", susNumber: "", email: "", homePhone: "",
        cellPhone: "", cellPhone2: "", motherName: "", cpf: "", cpfCard:"", rg: "", rgEmitter: "", dateOfBirth: "",
        maritalStatus: "", gender: "", cep: "", addressType: "", address: "",
        addressNumber: 0, addressComplement: "", district: "", city: "", state: "", lastName:"", matServidor:"", codOrgao: ""
      },
      holder: {
        firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
        maritalStatus: "", gender: "", isHolder: "", lastName:"", portability:""
      },
      titular: {
        habilita: true, situacao : ''

      },
      depIndex:0,
      dependent: [
        {
          firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
          maritalStatus: "", gender: "", parentage: "", isHolder: "", portability: "", plansId: ""
        }
      ],
      paymentCreditCard:{
        cardCreditNumber:"", cardExpiring:"", cardInvoiceExpiration:"", cardHolderName: "",
        flagCardPayment:"", cardNumberFourFinal:"",
      },
      paymentSlip:{

      },
      others:{
        dateSignatureContract: "",
        formHolder: null,
      },
      financialManagerError: {
        firstName: "", susNumber: "", email: "", homePhone: "",
        cellPhone: "", cellPhone2: "", motherName: "", cpf: "", cpfCard:"", rg: "", rgEmitter: "", dateOfBirth: "",
        maritalStatus: "", gender: "", cep: "", addressType: "", address: "",
        addressNumber: "", addressComplement: "", district: "", city: "", state: "", lastName:"", matServidor:"", codOrgao:""
      },
      holderError: {
        firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
        maritalStatus: "", gender: "", lastName:"", portability: ""
      },
      dependentError: {
        firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
        maritalStatus: "", gender: "", parentage: "", portability:""
      },
      paymentCreditCardError:{
        cardCreditNumber:"", cardExpiring:"", cardInvoiceExpiration:"", cardHolderName: "",
        flagCardPayment:"", cardNumberFourFinal:"",
      },
      paymentSlipError:{

      },
      othersError:{
        dateSignatureContract: "", formHolder: "",
      },
      financialManagerValidation: {
        firstName: null, susNumber: null, email: null, homePhone: null,
        cellPhone: null, cellPhone2: null, motherName: null, cpf: null, rg: null, rgEmitter: null, dateOfBirth: null,
        maritalStatus: null, gender: null, cep: null, addressType: null, address: null,
        addressNumber: null, addressComplement: null, district: null, city: null, state: null, lastName:null
      },
      holderValidation: {
        firstName: null, susNumber: null, motherName: null, cpf: null, dateOfBirth: null,
        maritalStatus: null, gender: null, lastName:null, portability: null
      },
      dependentValidation: {
        firstName: null, susNumber: null, motherName: null, cpf: null, dateOfBirth: null,
        maritalStatus: null, gender: null, parentage: null, portability: null
      },
      paymentCreditCardValidation:{
        cardCreditNumber:null, cardExpiring:null, cardInvoiceExpiration:null, cardHolderName: null,
        flagCardPayment:null, cardNumberFourFinal:null,
      },
      paymentSlipValidation:{

      },
      othersValidation:{
        dateSignatureContract: null, formHolder: null,
      },
      isEditFinancialManagerName: true,
      isEditFinancialManagerMotherName: true,
      isEditFinancialManagerDateOfBirth: true,

      isEditDependentName: true,
      isEditDependentMotherName: true,
      isEditDependentDateOfBirth: true,      

      isEditHolderName: true,
      isEditHolderMotherName: true,
      isEditHolderDateOfBirth: true,      


      //lista de dependentes
      dependentsList: [],
      //lista endereco
      stateList: [],
      cityList: [],
      districtList: [],
      addressTypeList: [],
      planos_correlacionadoss: [],
      //informações
      nameSalesman:"",
      nameBroker:"",
      salesmanPagSeguroEmail:"",
      salesmanPagSeguroToken:"",
      salesmanPaypalId:"",
      value_plan :"",
      value_total :"",
      codeS4_plan :"",
      objectPlan: {},
      unitary_value:"",
      unitary_value2:"",
      valueDescontIndividual: '',
      valueDescontTotal : '0,00',
      totalNoDescont:'0,00',
      valueIndividualPlan: "",
      cobertura :{
        linha_1 :'',
        linha_2 :'',
        urgencia : '',
        dentistica:'',
        periodontia : '',
        endodontia : '',
        cirurgias : '',
        coroa : '180 DIAS'     
      },

			broker : {
				name : ''
			},
			dadosImpressao: {
				financialManager: '',
				holder: '',
				dependents : '' ,
				validity : '',				
			},

      //docs
      imagesDocs: {
        cpf: "",
        rg: "",
        autorizacaoAverbacao: "",
        cnh: "",
        rg2: "",
        address: "",
        cardCredit: "",
        physicalContract: "",
        adtive: "",
        declarationPortability: "",
        others: ""
      },
      //outros
      daysCardInvoiceExpiration:[
        1,2,3,4,5,6,7,8,9,10,11,12,13,14,15
        ,16,17,18,19,20,21,22,23,24,25,26,
        27,28,29,30,31
      ],
      currentTimeServer: null,
      maturityDate: "",
      effectiveDate: "",
      editFinancialManagerId: '',
      editImagesDocId: '',
      editSalesId: '',
      habilitaCpfCartao:'',

      //modais
      modalError:false,
      modalNoDependents:false,
      modalDependentsNext:false,
      modalHiperMaster:false,
      modalPriorizarCadastro:false,      
      hiperMarter: "",
      modalSuccess:false,
      modalResume:false,
      confirmationForm:'EMAIL',
      btnFinishDisabled: false,
      portability: false,
      alertCardAvaliable:false,
      prepaidCard: false,
      messagesErrorCard: [],

      cvc: '',
      expiry: '',
      focus: '',
      name: '',
      number: '',
      
      btnFinishSales: 'enable',

      planSLZ: ["DENTAL SUPER SLZ TPC03", "DENTAL CLÍNICO SLZ VIP", "DENTAL DIGITAL SLZ"],
      planPB: ["DENTAL DIGITAL", "DENTAL VIP", "DENTAL ORTO PF TPC04 ( VIP )", "DENTAL SUPER TPC03", "DENTAL ORTO PF TPC05", "SPO PARCERIA MEI PB"],
      stateMASLZ: false,     
      stateJPA: false,
      planAvaliable: true,
      planName:''
    };
    //this.downloadPDF = this.downloadPDF.bind(this);
    this.openPDF = this.openPDF.bind(this);	    
    this.lidarComMudancaCampos = this.lidarComMudancaCampos.bind(this);    
    this.styles = {
      modal: {
        width: '85%',
        maxWidth: 'none',
      }
    };
  }

  componentWillMount() {

    const planosSalvos = localStorage.getItem("planos_correlacionados");
    console.log("Dados crus do localStorage:", planosSalvos); // Verifica se veio algo
    
    if (planosSalvos) {
      try {
        const planosArray = JSON.parse(planosSalvos);
        console.log("Array convertido:", planosArray); // Verifica o array formatado

        this.setState({ planos_correlacionados: planosArray }, () => {
          // Este console.log roda APÓS o estado ser atualizado de fato
          console.log("Estado atualizado:", this.state.planos_correlacionados);
        });
      } catch (error) {
        console.error("Erro ao fazer parse dos planos do localStorage:", error);
      }
    }

    // Pegar relação de código com Ju
    const codigosEmpresasExcluir = ["0000", "0000"];

    this.setState({ isServidor: (localStorage.getItem('isServidor') === "true" ? true : false) })
    this.state.btnFinishSales = 'enable';    
    this.setState({type_plan : localStorage.getItem("type_plan") })

    if (this.state.type_plan == 'digital') {
      let state = this.state;
      state.confirmationForm = 'EMAIL';
      this.setState(state);
    }

    this.getDataInfo();// Pega características do salesman broker
    //this.getDataInfoPlans();// Pega características do plano
    this.getStates();// Pega a lista de estados
    this.getCurrentTimeServer();// Pega a data atual do servidor
    this.getAddressType();// Pega a lista de tipos de endereço
    
    this.getListaEmpresasPublicas().then((empresas) => {
        const empresasFiltradas = empresas.filter(
            (empresa) => !codigosEmpresasExcluir.includes(empresa.codigo)
        );      

        this.setState({ empresasPublicas : empresasFiltradas })
    });   
    this.selecionarPlano();  
  }  

  // NOVOS MÉTODOS PARA TRATAR O CONTRATO DE VÁRIOS PLANOS
  // Retorna um array com os objetos de todos os planos únicos utilizados na proposta (Titular + Dependentes)
  getPlanosUnicosNaProposta() {
    let planosMap = {};
    
    // Adiciona o plano principal (do titular)
    if (this.state.planoSelecionado) {
      let idPrincipal = this.state.planoSelecionado.id || this.state.planoSelecionado.codeS4;
      if (idPrincipal) {
        planosMap[idPrincipal] = this.state.planoSelecionado;
      }
    }

    // Adiciona os planos específicos dos dependentes da lista
    if (this.state.dependentsList && this.state.dependentsList.length > 0) {
      this.state.dependentsList.forEach((item, index) => {
        if (index > 0 && item.plansId && this.state.planos_correlacionados) {
          let encontrado = this.state.planos_correlacionados.find(
            p => (p.id === item.plansId || p.codeS4 === item.plansId)
          );
          if (encontrado) {
            let idDep = encontrado.id || encontrado.codeS4;
            planosMap[idDep] = encontrado;
          }
        }
      });
    }

    return Object.values(planosMap);
  }
  // FIM DOS NOVOS MÉTODOS

  portabilityOn() {
		let state = this.state;
		state.portability = true;
    
    // Se já houver um titular na lista, atualiza o campo dele também
    if (state.dependentsList.length > 0 && state.dependentsList[0]) {
      state.dependentsList[0].portability = true;
    }
    state.holder.portability = true;

		this.setState(state);
	}

	portabilityOff() {
		let state = this.state;
		state.portability = false;

    // Se já houver um titular na lista, atualiza o campo dele também
    if (state.dependentsList.length > 0 && state.dependentsList[0]) {
      state.dependentsList[0].portability = false;
    }
    state.holder.portability = false;

		this.setState(state);
	}

  lidarComMudancaCampos (event)  {
    const { id, value } = event.target;
    // Se for o campo de busca da empresa, precisamos da lógica do find
    if (id === "busca-empresa") {
      this.setState({ nomeEmpresa: value });

      const empresaEncontrada = this.state.empresasPublicas.find(
        (empresa) => empresa.nome_fantasia === value
      );

      this.setState((prevState) => ({
        financialManager: {
          ...prevState.financialManager,
          codOrgao: empresaEncontrada ? empresaEncontrada.codigo : ''
        }
      }));
      this.setState(prevState => ({
        financialManagerError: {
          ...prevState.financialManagerError,
          codOrgao: '' // Limpa o erro dinamicamente
        }
      }));      
    } 
    
    // Se for o campo de matrícula, atualiza direto usando o ID do input de forma dinâmica
  if (id === "matricula-servidor") {
      this.setState((prevState) => ({
        financialManager: {
          ...prevState.financialManager,
          matServidor: value
        }
      }));
      this.setState(prevState => ({
        financialManagerError: {
          ...prevState.financialManagerError,
          matServidor: '' // Limpa o erro dinamicamente
        }
      }));      
    }
  } 
	openPDF()  {

    var dataNascHolder = this.state.holder.dateOfBirth.substring(6,10) + "-" + this.state.holder.dateOfBirth.substring(3,5) + "-" + this.state.holder.dateOfBirth.substring(0,2);
    //var nascimentoHolder = moment(dataNascHolder);
    let salesman = {
      user : {
        name : this.state.nameSalesman
      },
      codeS4 : ''
    }
   
    let broker = {
      name : this.state.nameBroker
    };
    let paymentType =  (this.state.isServidor ? "server" : (this.state.payment_plan === 'false' ? "ticket" : "card"));
    let sales = {
      status : '',
      planServer : this.state.isServidor,
      paymentType : paymentType
    }
    let dependentes =  this.state.dependentsList ? this.state.dependentsList.slice(1) : []
		this.state.dadosImpressao = {
			financialManager: this.state.financialManager,
			holder: this.state.holder,
			dependents: dependentes,
			validity : this.state.effectiveDate,
			salesman : salesman,
			broker :  broker,
			imagesDoc : this.state.imagesDocs,
			sales : sales,
      plan : this.state.planoSelecionado
		};		

    this.state.dadosImpressao.financialManager.cardValidity = this.state.paymentCreditCard.cardExpiring;
    this.state.dadosImpressao.holder.valuePlan = this.state.valueIndividualPlan;
    if (this.state.financialManager.cpfCard === undefined)
      this.state.dadosImpressao.financialManager.cpfCard = '';
		this.state.dadosImpressao.financialManager.bairro = this.state.nomeBairro;
		this.state.dadosImpressao.financialManager.municipio = this.state.municipio;
		this.state.dadosImpressao.financialManager.estado = this.state.estado;
		this.state.dadosImpressao.financialManager.proposalNumber = '';
		this.state.dadosImpressao.financialManager.dateSignatureContract = this.state.others.dateSignatureContract;
		this.state.dadosImpressao.financialManager.responsibility = this.state.value_total;
		this.state.dadosImpressao.financialManager.cardNumber =  this.state.paymentCreditCard.cardCreditNumber; //" XXXX.XXXX.XXXX." + this.state.cardNumberFourFinal;
    let dia =  this.state.financialManager.dateOfBirth;
    let mes = this.state.financialManager.dateOfBirth;
    let ano = this.state.financialManager.dateOfBirth;
    var data =  "";
    data = ano.substring(6,10) + "-" + mes.substring(3,5) + "-" + dia.substring(0,2);
    this.state.dadosImpressao.financialManager.dateOfBirth = data;
    this.state.dadosImpressao.holder.dateOfBirth = dataNascHolder;

		//this.state.dadosImpressao.financialManager.cardHolderName = document.getElementById('cardHolderName').value;
		this.state.dadosImpressao.financialManager.cardFlag = this.state.paymentCreditCard.flagCardPayment;
		pdfResumoPropostaPF(this.state.dadosImpressao,"visualizar");
	}  

  formCardQuestionS(){
    let state = this.state;
    state.habilitaCpfCartao = false;
    state.financialManager.cpfCard = ""
    document.getElementById("alert_questionUsuarioCpfCard").style.display="none";

    this.setState(state);
   // this.validatecardQuestion();

  }

  formCardQuestionN(){
    let state = this.state;
    state.habilitaCpfCartao  = true;
    document.getElementById("alert_questionUsuarioCpfCard").style.display="none";
    this.setState(state);

    //this.validatecardQuestion();

  }

  validatecardQuestion(){// valida cardQuestion titular
    // Caso a pergunta do titular do cartao nao esteja respondida e o usuário tente avançar
    if (this.state.habilitaCpfCartao == '') {
      //dispara o alerta na pergunta do titular do cartão
      document.getElementById("alert_questionUsuarioCpfCard").style.display="block";
    }else{
      document.getElementById("alert_questionUsuarioCpfCard").style.display="none";
    }
  }  
  validateCheckbox(id){
    let state = this.state,
        checked = document.getElementById(id).checked;
    state.habilitaCpfCartao = checked;
    if(checked == true){
      state.financialManager.cpfCard = ""
      
    }else{
     // state.resultValidateForm.push(true);
    }
    this.setState(state);
  }

  openModalHiper() {
    let state = this.state;
    state.openModalHiper = true;
    state.hiperMarter = "";
    this.setState(state);
  }
  
  closeModalHiper() {
    let state = this.state;
    state.openModalHiper = false;
    state.hiperMarter = "";
    this.setState(state);
  }
  selectHiperMasterNao(){
    let state = this.state;
    this.dateValidityCredtCard(null);
    state.openModalHiper = false;
    this.setState(state);

  }

  inicilizaDependente() {
    let state = this.state;

    state.dependent = [
      {
        firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
        maritalStatus: "", gender: "", parentage: "", isHolder: ""
      }
    ];
    this.setState(state);

  }  
  inicilizaHolder() {
    let state = this.state;

    state.holder = {
      firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
      maritalStatus: "", gender: "", isHolder: "", lastName:""
    };
    this.setState(state);

  }
  inicilizaFinancialManager() {
    let state = this.state;

    state.financialManager = {
      firstName: "", susNumber: "", email: "", homePhone: "",
      cellPhone: "", cellPhone2: "", motherName: "", cpf: "", rg: "", rgEmitter: "", dateOfBirth: "",
      maritalStatus: "", gender: "", cep: "", addressType: "", address: "",
      addressNumber: 0, addressComplement: "", district: "", city: "", state: "", lastName:""
    };  

    this.setState(state);
  }

  /**
   * Verifica se o cartão Mastercard é Hiper
   */
  selectHiperMasterSim(){

    let chosenDate = '';
    let state = this.state;
    state.openModalHiper = false;
    state.hiperMarter = "HIPERCARD";
    this.setState(state);
    
    let date = this.state.others.dateSignatureContract;
    date = date.split('/');

    var dia = date[0];      
                
    moment.locale('pt-BR');
    chosenDate = dia;
    this.state.paymentCreditCard.flagCardPayment = 'HIPERCARD';

    let dataSubmit = {
      city: sessionStorage.getItem("select_cities"),
      dayInclusion: chosenDate,
      type: 'CARTÃO',
      flag: 'HIPERCARD'
    };

    if (dataSubmit.dayInclusion != null) {
      axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
      .then((response) => {
        let state = this.state;
        // Seta as características da forma de pagameto no state para ser enviado posteriormente
        state.financialManager.formOfPaymentId = response.data.id;
       
        state.financialManager.contractNumberS4 = response.data.codeS4;
        // retirar
       // state.financialManager.cardDayExpiration = this.state.paymentCreditCard.cardInvoiceExpiration;
        state.financialManager.cardDayExpiration = response.data.validity
        // Início da vigência:
        state.effectiveDate = this.state.others.dateSignatureContract;
        // Calcula data de vencimento: dia escolhido + 1 mês

        /* Regra dos 25 dias */
        let cartao = '';
        let cartaoMes = state.paymentCreditCard.cardExpiring.substring(0,2);
        let cartaoAno = state.paymentCreditCard.cardExpiring.substring(3,7);

        // Cálculo do mês do cartão
        cartaoMes = parseInt(cartaoMes)-1;
        if (cartaoMes < 10)
          cartaoMes = '0'+cartaoMes;

        let partDate = state.others.dateSignatureContract.split('/');
        let adesao = moment(partDate[2]+'-'+partDate[1]+'-'+partDate[0]);

        cartao = moment(new Date(cartaoAno, cartaoMes, '01'));

        if (cartao.diff(adesao, 'days') >= 25) {
          state.maturityDate = moment(state.currentTimeServer.year+'-'+
            state.currentTimeServer.month + '-' +
            response.data.validity
          ).add(1, 'M').format('DD/MM/YYYY');
        }
        else {
          state.maturityDate = moment(state.currentTimeServer.year+'-'+
            state.currentTimeServer.month + '-' +
            response.data.validity
          ).add(2, 'M').format('DD/MM/YYYY');
        }

        this.setState(state);
      })
      .catch(function () {
        alert('Erro ao buscar Forma de Pagamento');
      });
    }



  } 

  validarCartaoCreditoCardBin() {
    let state = this.state;
   // let cardNumber =  document.getElementById('numeroCartao').value.replace(/\D/g, '').substring(0,6);

    let numberCard = state.paymentCreditCard.cardCreditNumber;

    let cardNumber = numberCard.replace(/\D/g, '').substring(0,6);
    let header = {
      headers : {
      'Content-Type': 'application/json',
      'MerchantId' : 'a7c2650a-5852-4444-a83a-f4435b1813f0',
      'MerchantKey' : 'qbwnD2t4nhEGEgOYC42HkL8UdhEVNRUvtgqBdkHl'
      }
    }
    // axios.get("https://apiquerysandbox.cieloecommerce.cielo.com.br/1/cardBin/444458",
   axios.get("https://apiquery.cieloecommerce.cielo.com.br/1/cardBin/"+cardNumber,
      header
    )
    .then((response) => {
      let state = this.state;
      state.messagesErrorCard = [];
      //Prepaid
      state.prepaidCard = response.data.Prepaid;
      if (response.data.CardType == "Débito") {
          this.setState({ alertCardAvaliable:true});
          state.alertCardAvaliable = true;
          this.setField("paymentCreditCard.cardCreditNumber", "Cartão inválido", false, numberCard);
            
          state.messagesErrorCard = "A forma de pagamento débido não é aceita! Tente novamente utilizando um cartão de crédito ou entre em contato com a Dental Center.";
          this.setState(state);        

      } else {
          //if (state.prepaidCard && response.data.Provider != 'VISA')  {
          if (state.prepaidCard )  {            
            this.setState({ alertCardAvaliable:true});
            state.alertCardAvaliable = true;
            this.setField("paymentCreditCard.cardCreditNumber", "Cartão inválido", false, numberCard);
              
            state.messagesErrorCard = "A forma de pagamento pré-pago não é aceita! Tente novamente utilizando um cartão de crédito ou entre em contato com a Dental Center.";
            this.setState(state);
          } else {
            state.alertCardAvaliable = false;
            this.setState(state);
          }        

      }


    })
    .catch((error) => {
      let state = this.state;
      state.alertCardAvaliable = false;
      console.log(error)
      /* Voltar depois da validação do token 
      state.messagesErrorCard = [];
      state.alertCardAvaliable = true;
      state.prepaidCard = true;
      state.messagesErrorCard.push("Erro na validação do cartão: ");
      state.messagesErrorCard.push("\n ");
      let mensagens = [];
      mensagens.push(error.response.data[0].Message); 

      this.state.messagesErrorCard.push(mensagens.map(msg =>
        <li>{msg}</li>
      )); 
      */
      this.setState(state);
    });

  }  
  onCloseModalValidateCard(){
    this.setState({ alertCardAvaliable:false});
  }
  onOpenModalValidateCard(){
    this.setState({ alertCardAvaliable:true});
  }  
  /**
   * Busca as empresas públicas
   * @returns 
   */
  getListaEmpresasPublicas() {
        return axios.get(urlBase.loopBack + 'APIS4s/empresas-publicas')
            .then((result) => {
                return result.data; 
            })
            .catch(function (erro) {
                alert('Erro ao buscar empresas públicas: ' + erro);
                throw erro; 
            });    
  }  
  /*
  componentDidUpdate(prevProps) {
    console.log(localStorage.getItem('isServidor'))
    if (this.state.isServidor !== localStorage.getItem('isServidor')) {       
        this.setState({ isServidor: localStorage.getItem('isServidor') }, () => {
          // Recarrega os planos caso a mudança de servidor influencie a busca da API
         // this.carregarPlanos(this.props.isServidor)         
        });
      }
  }  
      */

  /**
   * Carrega o plano selecionado
   */
  selecionarPlano ()  {
    axios.get(urlBase.loopBack + 'Plans/' + localStorage.getItem("dental_plan"))
      .then((result) => {

        // 1. Sua lógica para definir qual tabela usar
        let tabelaPreco = {};
        if (this.state.isServidor) {
          tabelaPreco = result.data.serverTable;
        } else if (localStorage.getItem("payment_plan") === "false") {
          tabelaPreco = result.data.ticketTable; 
        } else {
          tabelaPreco = result.data.familyTable;
        }

        // 2. Criamos o novo objeto plano copiando o original e injetando a tabela escolhida
        var plano = {
          ...result.data,         // Copia todos os campos originais (name, value, etc.)
          tabelaPreco: tabelaPreco // Adiciona a tabela filtrada em uma propriedade nova
        };

        // 4. Atualiza o estado
        this.setState({ planoSelecionado: plano });
        this.setState({value_total : plano.tabelaPreco.value2 })
        this.setState({payment_plan : localStorage.getItem("payment_plan") })

      })
      .catch((erro) => {
        console.error(erro);
        alert("Ocorreu um erro ao selecionar o plano."); 
      });
  }
  obterValorPorDependentes() {
    var qtd = this.state.dependentsList.length;
    var tabela = this.state.planoSelecionado.tabelaPreco;

    if (qtd === 1) return tabela.value2;
    if (qtd < 3)  return tabela.value3;
    return tabela.value4;
  }  
  /************************ CAMPOS DO FORMULARIO ************************************/
  //seta campos do formulario validation  error value
  setField(id, error, validation, value){
    let state = this.state;
    id = id.split('.');
    state[id[0]+"Error"][id[1]] = error;
    state[id[0]+"Validation"][id[1]] = validation;
    state[id[0]][id[1]] = value;
    this.setState(state);
  }
  //seta campos do dependente
  setFieldDependents(id, error, validation, value){
    let state = this.state;
    id = id.split('.');
    state[id[0]+"Error"][id[1]] = error;
    state[id[0]+"Validation"][id[1]] = validation;
    state[id[0]][this.state.depIndex][id[1]] = value;//depIndex mostra a posicao que deve ser salvo o dependente
    this.setState(state);
  }
  //mensagens de erro, campos obrigátorios
setError(type, prop) {
  let state = this.state;
  state[type + "Error"][prop] = "Campo Obrigatório";
  state[type + "Validation"][prop] = false; // 👈 Adicionado para garantir o estado inválido
  this.setState(state);
}  
  /*
  setError(type, prop){
    let state = this.state;
    state[type+"Error"][prop] = "Campo Obrigatório";
    this.setState(state);
  }
  */
  //limpeza dos campos, recebe o tipo q deve ser limpo
  clearField(type, value){//type: financialManager, holder, dependent, others...
    let state = this.state, prop;
    for (prop in this.state[type]) {
      state[type][prop] = value;
    }
    this.setState(state);
  }
  /***** ONCHANGE DAS FUNÇOES, SALVA DADOS DOS CAMPOS NO STATE E CHAMA ALGUMAS VALIDAÇOES **************/
  handleChangeSelectField(id, event, index, value){
    let state = this.state;
    //responsavel financeiro
    if(id === "fm_maritalStatus"){
      if(state.requiredField.financialManager.maritalStatus === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("financialManager.maritalStatus", "Escolha uma opção", false, value);
        else
          this.setField("financialManager.maritalStatus", null, true, value);
      }else
        this.setField("financialManager.maritalStatus", null, true, value);
    }
    if(id === "fm_gender"){
      if(state.requiredField.financialManager.gender === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("financialManager.gender", "Escolha uma opção", false, value);
        else
          this.setField("financialManager.gender", null, true, value);
      }else
        this.setField("financialManager.gender", null, true, value);
    }
    //endereço
    if(id === "fm_addressType"){
      if(state.requiredField.financialManager.addressType === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("financialManager.addressType", "Escolha uma opção", false, value);
        else
          this.setField("financialManager.addressType", null, true, value);
      }else
        this.setField("financialManager.addressType", null, true, value);
    }
    if(id === "fm_state"){
      if(state.requiredField.financialManager.state === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("financialManager.state", "Escolha uma opção", false, value);
        else{
          this.setField("financialManager.state", null, true, value);
          this.setField("financialManager.city", "Escolha uma opção", false, "NULL");
          this.setField("financialManager.district", "Escolha uma opção", false, "NULL");
          this.state.districtList = [];
          this.getCity(value);
        }
      }else{
        this.setField("financialManager.state", null, true, value);
        this.setField("financialManager.city", "Escolha uma opção", false, "NULL");
        this.setField("financialManager.district", "Escolha uma opção", false, "NULL");
        this.getCity(value);
      }
    }
    if(id === "fm_city"){
      if(state.requiredField.financialManager.city === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("financialManager.city", "Escolha uma opção", false, value);
        else{
          this.setField("financialManager.city", null, true, value);
          this.setField("financialManager.district", "Escolha uma opção", false, "NULL");
          this.getDistrict(value);
        }
      }else{
        this.setField("financialManager.city", null, true, value);
        this.setField("financialManager.district", "Escolha uma opção", false, "NULL");
        this.getDistrict(value);
      }
    }
    if(id === "fm_district"){
      if(state.requiredField.financialManager.district === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("financialManager.district", "Escolha uma opção", false, value);
        else {
          this.state.IdBairro = value;
          this.state.nomeBairro =  this.state.districtList[index-1].Nome;
          this.setField("financialManager.district", null, true, value);          
        }
          
      }else {
        this.state.IdBairro = value;
        this.state.nomeBairro =  this.state.districtList[index-1].Nome;
        this.setField("financialManager.district", null, true, value);          
      }
    }
    //titular
    if(id === "hd_maritalStatus"){
      if(state.requiredField.holder.maritalStatus === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("holder.maritalStatus", "Escolha uma opção", false, value);
        else
          this.setField("holder.maritalStatus", null, true, value);
      }else
        this.setField("holder.maritalStatus", null, true, value);
    }
    if(id === "hd_gender"){
      if(state.requiredField.holder.gender === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("holder.gender", "Escolha uma opção", false, value);
        else
          this.setField("holder.gender", null, true, value);
      }else
        this.setField("holder.gender", null, true, value);
    }
    //dependente
    if(id === "dp_maritalStatus"){
      if(state.requiredField.dependent.maritalStatus === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setFieldDependents("dependent.maritalStatus", "Escolha uma opção", false, value);
        else
          this.setFieldDependents("dependent.maritalStatus", null, true, value);
      }else
        this.setFieldDependents("dependent.maritalStatus", null, true, value);
    }
    
    if(id === "dp_portability"){
      if(state.requiredField.dependent.portability === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setFieldDependents("dependent.portability", "Escolha uma opção", false, value);
        else
          this.setFieldDependents("dependent.portability", null, true, value);
      }else
        this.setFieldDependents("dependent.portability", null, true, value);
    }

    if(id === "dp_plansId"){
      if(state.requiredField.dependent.plansId === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setFieldDependents("dependent.plansId", "Escolha uma opção", false, value);
        else
          this.setFieldDependents("dependent.plansId", null, true, value);
      }else
        this.setFieldDependents("dependent.plansId", null, true, value);
    }

    if(id === "dp_gender"){
      if(state.requiredField.dependent.gender === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setFieldDependents("dependent.gender", "Escolha uma opção", false, value);
        else
          this.setFieldDependents("dependent.gender", null, true, value);
      }else
        this.setFieldDependents("dependent.gender", null, true, value);
    }
    if(id === "dp_parentage"){
      if(state.requiredField.dependent.parentage === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setFieldDependents("dependent.parentage", "Escolha uma opção", false, value);
        else
          this.setFieldDependents("dependent.parentage", null, true, value);
      }else
        this.setFieldDependents("dependent.parentage", null, true, value);
    }
    //formas de pagamento
    if(id === "pay_cardInvoiceExpiration"){
      if(state.requiredField.paymentCreditCard.cardInvoiceExpiration === "REQUIRED"){//campo obrigatorio
        if(value === "NULL" || value === "")
          this.setField("paymentCreditCard.cardInvoiceExpiration", "Escolha uma opção", false, value);
        else{
          this.setField("paymentCreditCard.cardInvoiceExpiration", null, true, value);
          this.dateValidityCredtCard(value);//maturityDate e effectiveDate
        }
      }else{
        this.setField("paymentCreditCard.cardInvoiceExpiration", null, true, value);
        // Paulo = 
        this.dateValidityCredtCard(value);//maturityDate e effectiveDate
      }
    }
  }

  validaCPFOnblur(e) {
    
    if(e.target.name === "card_cpf"){
      if(this.validateCpf(e.target.value) == false){
        let error = "CPF Inválido";  
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          error = "Informe o CPF";
        this.setField("financialManager.cpfCard", error, false, e.target.value);
      }      
    }    
    if(e.target.name === "fm_cpf"){
      if(this.validateCpf(e.target.value) == false){
        let error = "CPF Inválido";  
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          error = "Informe o CPF";
        this.setField("financialManager.cpf", error, false, e.target.value);
      }      
    }
    if(e.target.name === "hd_cpf"){
      if(this.validateCpf(e.target.value) == false){
        let error = "CPF Inválido";
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          error = "Informe o CPF";
        this.setField("holder.cpf", error, false, e.target.value);
      }      
    }    

    if(e.target.name === "dp_cpf"){
      if(this.validateCpf(e.target.value) == false){
        let error = "CPF inválido";
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          error = "CPF OBRIGATÓRIO";
        this.setField("dependent.cpf", error, false, e.target.value);
      }      
    }      

  }
  handleChange(e, maskedvalue, floatvalue){
    let state = this.state;
    //responsavel financeiro
    if(e.target.name === "fm_firstName"){
      if(state.requiredField.financialManager.firstName === "REQUIRED"){//campo obrigatorio
        if(this.validateLetters(e.target.value) == false){
          let error = "Informe apenas letras";
          if(e.target.value == "")
            error = "Informe o nome completo";
          this.setField("financialManager.firstName", error, false, e.target.value.toUpperCase());
        }else{
          this.setField("financialManager.firstName", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value == "")
          this.setField("financialManager.firstName", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateLetters(e.target.value) == false)
            this.setField("financialManager.firstName", "Informe apenas letras", false, e.target.value.toUpperCase());
          else
            this.setField("financialManager.firstName", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "card_cpf"){
      this.state.financialManager.cpfCard = e.target.value;
      let error = "";

      if (e.target.value.replace(/[^\d]+/g,"").length == 11) {
        if(this.validateCpf(e.target.value) == false){
          error = "CPF Inválido";
          if(e.target.value.replace(/[^\d]+/g,"") === "")
            error = "Informe o CPF";
          this.setField("financialManager.cpfCard", error, false, e.target.value);
        }else{
          this.state.financialManagerError.cpfCard = "";

  
        }
      } 
      else {
        this.state.financialManagerError.cpfCard = error;
      }      

    }    
    if(e.target.name === "fm_cpf"){
      this.state.financialManager.cpf = e.target.value;
      if(state.requiredField.financialManager.cpf === "REQUIRED"){//campo obrigatorio
        let error = "";
        if (e.target.value.replace(/[^\d]+/g,"").length == 11) {
          if(this.validateCpf(e.target.value) == false){
            error = "CPF Inválido";
            if(e.target.value.replace(/[^\d]+/g,"") === "")
              error = "Informe o CPF";
            this.setField("financialManager.cpf", error, false, e.target.value);
          }else{
            this.state.financialManagerError.cpf = "";
            document.getElementById('loading_fm_cpf').style.display = 'inline-block';
            this.impededCpf(e.target.name,e.target.value);

          // this.setField("financialManager.cpf", error, true, e.target.value);
    
          }
        } 
        else {
          this.state.financialManagerError.cpf = error;
        }

      }else{
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          this.setField("financialManager.cpf", null, true, e.target.value);
        else{
          if(this.validateCpf(e.target.value) == false)
            this.setField("financialManager.cpf", "CPF inválido", false, e.target.value);
          else
            this.setField("financialManager.cpf", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "fm_email"){
      if(state.requiredField.financialManager.email === "REQUIRED"){//campo obrigatorio
        if(this.validateEmail(e.target.value) == false){
          let error = "Email inválido";
          if(e.target.value === "")
            error = "Informe o email";
          this.setField("financialManager.email", error, false, e.target.value.toUpperCase());
        }else{
          this.setField("financialManager.email", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value === "")
          this.setField("financialManager.email", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateEmail(e.target.value) == false)
            this.setField("financialManager.email", "Email inválido", false, e.target.value.toUpperCase());
          else
            this.setField("financialManager.email", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "fm_homePhone"){
      if(state.requiredField.financialManager.homePhone === "REQUIRED"){//campo obrigatorio
        if(e.target.value.replace(/[^0-9]/g,'') === "")
          this.setField("financialManager.homePhone", "Informe o telefone", true, e.target.value);
        else{
          if(this.validateTel(e.target.value) == false)
            this.setField("financialManager.homePhone", "Telefone inválido", false, e.target.value);
          else
            this.setField("financialManager.homePhone", null, true, e.target.value);
        }
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') === "")
          this.setField("financialManager.homePhone", null, true, e.target.value);
        else{
          if(this.validateTel(e.target.value) == false)
            this.setField("financialManager.homePhone", "Telefone inválido", false, e.target.value);
          else
            this.setField("financialManager.homePhone", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "fm_cellPhone"){
      if(state.requiredField.financialManager.cellPhone === "REQUIRED"){//campo obrigatorio
        if(this.validateCell(e.target.value) == false){
          let error = "Celular inválido";
          if(e.target.value.replace(/[^\d]+/g,"") === "")
            error = "Informe o celular";
          this.setField("financialManager.cellPhone", error, false, e.target.value);
        }else{
          this.setField("financialManager.cellPhone", null, true, e.target.value);
        }
      }else{
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          this.setField("financialManager.cellPhone", null, true, e.target.value);
        else{
          if(this.validateCell(e.target.value) == false)
            this.setField("financialManager.cellPhone", "Celular inválido", false, e.target.value);
          else
            this.setField("financialManager.cellPhone", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "fm_cellPhone2"){
      if(state.requiredField.financialManager.cellPhone2 === "REQUIRED"){//campo obrigatorio
        if(this.validateCell(e.target.value) == false){
          let error = "Celular 2 inválido";
          if(e.target.value.replace(/[^\d]+/g,"") === "")
            error = "Informe o celular 2";
          this.setField("financialManager.cellPhone2", error, false, e.target.value);
        }else{
          this.setField("financialManager.cellPhone2", null, true, e.target.value);
        }
      }else{
        if(e.target.value.replace(/[^\d]+/g,"") === ""){
          this.setField("financialManager.cellPhone2", null, true, e.target.value);
        }
        else{
          if(this.validateCell(e.target.value) == false)
            this.setField("financialManager.cellPhone2", "Celular 2 inválido", false, e.target.value);
          else
            this.setField("financialManager.cellPhone2", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "fm_rg"){
      if(state.requiredField.financialManager.rg === "REQUIRED"){//campo obrigatorio
        if(this.validateNumber(e.target.value) == false){
          let error = "RG inválido";
          if(e.target.value === "")
            error = "Informe seu RG";
          this.setField("financialManager.rg", error, false, e.target.value);
        }else{
          this.setField("financialManager.rg", null, true, e.target.value);
        }
      }else{
        if(e.target.value === ""){
          this.setField("financialManager.rg", null, true, e.target.value);
        }
        else{
          if(this.validateNumber(e.target.value) == false)
            this.setField("financialManager.rg", "RG inválido", false, e.target.value);
          else
            this.setField("financialManager.rg", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "fm_rgEmitter"){
      if(state.requiredField.financialManager.rgEmitter === "REQUIRED"){//campo obrigatorio
        if(e.target.value == "")
          this.setField("financialManager.rgEmitter", "Informe o orgão expedidor", false, e.target.value.toUpperCase());
        else
          this.setField("financialManager.rgEmitter", null, true, e.target.value.toUpperCase());
      }else
        this.setField("financialManager.rgEmitter", null, true, e.target.value.toUpperCase());
    }
    if(e.target.name === "fm_dateOfBirth"){
      if(state.requiredField.financialManager.dateOfBirth === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateDate(e.target.value) == false){
          error = "Data inválida";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error="Informe a data de nascimento";
          this.setField("financialManager.dateOfBirth", error, false, e.target.value);
        }else
          this.setField("financialManager.dateOfBirth", null, true, e.target.value);
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') == "")
          this.setField("financialManager.dateOfBirth", null, true, e.target.value);
        else{
          if(this.validateDate(e.target.value) == false)
            this.setField("financialManager.dateOfBirth", "Data inválida", false, e.target.value);
          else
            this.setField("financialManager.dateOfBirth", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "fm_motherName"){
      if(state.requiredField.financialManager.motherName === "REQUIRED"){//campo obrigatorio
        if(this.validateLetters(e.target.value) == false){
          let error = "Informe apenas letras";
          if(e.target.value == "")
            error = "Informe o nome completo";
          this.setField("financialManager.motherName", error, false, e.target.value.toUpperCase());
        }else{
          this.setField("financialManager.motherName", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value == "")
          this.setField("financialManager.motherName", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateLetters(e.target.value) == false)
            this.setField("financialManager.motherName", "Informe apenas letras", false, e.target.value.toUpperCase());
          else
            this.setField("financialManager.motherName", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "fm_susNumber"){
      if(state.requiredField.financialManager.susNumber === "REQUIRED"){//campo obrigatorio
        if(e.target.value == "")
          this.setField("financialManager.susNumber", "Número do cartão do SUS obrigatório", true, e.target.value);
        else{
          if(this.validateNumber(e.target.value) == false ){
            this.setField("financialManager.susNumber", "Informe apenas números", false, e.target.value);
          }else{
            if(this.validateSus(e.target.value) == false)
              this.setField("financialManager.susNumber", "Número do SUS tem 15 dígitos", true, e.target.value);
            else
              this.setField("financialManager.susNumber", null, true, e.target.value);
          }
        }
      }else{
        if(e.target.value == "")
          this.setField("financialManager.susNumber", null, true, e.target.value);
        else{
          if(this.validateNumber(e.target.value) == false ){
            this.setField("financialManager.susNumber", "Informe apenas números", false, e.target.value);
          }else{
            if(this.validateSus(e.target.value) == false){
              this.setField("financialManager.susNumber", "Número do SUS tem 15 dígitos", false, e.target.value);
            }else
              this.setField("financialManager.susNumber", null, true, e.target.value);
          }
        }
      }
    }
    //endereço
    if(e.target.name === "fm_cep"){
      if(state.requiredField.financialManager.cep === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateCep(e.target.value) == false){
          error = "CEP Inválido";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error = "Informe o CEP";
          this.setField("financialManager.cep", error, false, e.target.value);
        }else{
          this.setField("financialManager.cep", null, true, e.target.value);
          //get s4 cep
          this.getAddress(e.target.value);
        }
      }else{
        let error = "";
        if(e.target.value.replace(/[^0-9]/g,'') == ""){
          this.setField("financialManager.cep", null, true, e.target.value);
        }else{
          if(this.validateCep(e.target.value) == false){
            error = "CEP Inválido";
            this.setField("financialManager.cep", error, false, e.target.value);
          }else{
            this.setField("financialManager.cep", null, true, e.target.value);
            //get s4 cep
            this.getAddress(e.target.value);
          }
        }
      }
    }
    if(e.target.name === "fm_address"){
      if(state.requiredField.financialManager.address === "REQUIRED"){//campo obrigatorio
        let error ="";
        if(e.target.value == ""){
          error = "Informe o nome";
          this.setField("financialManager.address", error, false, e.target.value.toUpperCase());
        }else
          this.setField("financialManager.address", null, true, e.target.value.toUpperCase());
      }else
        this.setField("financialManager.address", null, true, e.target.value.toUpperCase());
    }
    if(e.target.name === "fm_district"){
      if(state.requiredField.financialManager.district === "REQUIRED"){//campo obrigatorio
        let error ="";
        if(e.target.value == ""){
          error = "Informe o nome";
          this.setField("financialManager.district", error, false, e.target.value.toUpperCase());
        }else
          this.setField("financialManager.district", null, true, e.target.value.toUpperCase());
      }else
        this.setField("financialManager.district", null, true, e.target.value.toUpperCase());
    }
    if(e.target.name === "fm_addressNumber"){
      if(state.requiredField.financialManager.addressNumber === "REQUIRED"){//campo obrigatorio
        let error ="";
        if(e.target.value == ""){
          error = "Informe o número";
          this.setField("financialManager.addressNumber", error, false, floatvalue);
        }else
          this.setField("financialManager.addressNumber", "", true, floatvalue);
      }else
        this.setField("financialManager.addressNumber", "", true, floatvalue);
    }
    if(e.target.name === "fm_addressComplement"){
      if(state.requiredField.financialManager.addressComplement === "REQUIRED"){//campo obrigatorio
        let error ="";
        if(e.target.value == ""){
          error = "Informe o complemento";
          this.setField("financialManager.addressComplement", error, false, e.target.value.toUpperCase());
        }else
          this.setField("financialManager.addressComplement", null, true, e.target.value.toUpperCase());
      }else
        this.setField("financialManager.addressComplement", null, true, e.target.value.toUpperCase());
    }
    //data de adesao
    if(e.target.name === "fm_dateSignatureContract"){
      if(state.requiredField.others.dateSignatureContract === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateDate(e.target.value) == false){
          error = "Data inválida";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error="Informe a data de adesão";
          this.setField("others.dateSignatureContract", error, false, e.target.value);
        }else {
            // TRATAR DATA DE ADESÃO
            /*
            let dataAtual = moment(new Date());
            let dataAdesao = e.target.value;
            dataAdesao = dataAdesao.split("/");            
            let data = moment(dataAdesao[2]+"-"+dataAdesao[1]+"-"+dataAdesao[0])            
            const duration =  moment.duration(dataAtual.diff(data));
            const dias = duration.asDays();

            if (Math.trunc(dias) > 30 ) {
              error = "Data inválida";
              alert("A data de adesão não pode ter mais de 30 dias retroativos");

            }
            else
               this.setField("others.dateSignatureContract", null, true, e.target.value);
            */
            let error = null; // Inicializa a variável de erro
            const dataInput = e.target.value; // Ex: "05/11/2025"

            // 1. Cria o objeto Moment para a data de hoje, zerando o tempo para comparação
            const hoje = moment().startOf('day'); 

            // 2. Cria o objeto Moment para o primeiro dia do mês atual
            const primeiroDiaDoMes = moment().startOf('month');

            // 3. Cria o objeto Moment para a data de entrada
            //    *** IMPORTANTE: Se a data de entrada for DD/MM/YYYY, especifique o formato!
            const dataAdesao = moment(dataInput, "DD/MM/YYYY").startOf('day');

            // 4. Validação
            // Condição para ser inválida:
            //   a) Se a data de adesão for FUTURA (depois de hoje) OU
            //   b) Se a data de adesão for ANTERIOR ao primeiro dia do mês
            if (dataAdesao.isAfter(hoje) || dataAdesao.isBefore(primeiroDiaDoMes)) {
                
                // Formata os limites para a mensagem de erro
                const minLimit = primeiroDiaDoMes.format('DD/MM/YYYY');
                const maxLimit = hoje.format('DD/MM/YYYY');

                error = "Data inválida";
                alert(`A data de adesão deve estar no período de ${minLimit} a ${maxLimit}.`);

                // Se for inválida, você pode definir o campo como nulo ou reverter o valor
                this.setField("others.dateSignatureContract", error, false, e.target.value);
            } else {
                // Se for válida, define o valor do campo
                this.setField("others.dateSignatureContract", null, true, dataInput);
            }
        }
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') == "")
          this.setField("others.dateSignatureContract", null, true, e.target.value);
        else{
          if(this.validateDate(e.target.value) == false)
            this.setField("others.dateSignatureContract", "Data inválida", false, e.target.value);
          else
            this.setField("others.dateSignatureContract", null, true, e.target.value);
        }
      }
    }
    //titular
    if(e.target.name === "hd_firstName"){
      if(state.requiredField.holder.firstName === "REQUIRED"){//campo obrigatorio
        if(this.validateLetters(e.target.value) == false){
          let error = "Informe apenas letras";
          if(e.target.value == "")
            error = "Informe o nome completo";
          this.setField("holder.firstName", error, false, e.target.value.toUpperCase());
        }else{
          this.setField("holder.firstName", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value == "")
          this.setField("holder.firstName", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateLetters(e.target.value) == false)
            this.setField("holder.firstName", "Informe apenas letras", false, e.target.value.toUpperCase());
          else
            this.setField("holder.firstName", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "hd_cpf"){
      this.state.holder.cpf = e.target.value;
      if(state.requiredField.holder.cpf === "REQUIRED"){//campo obrigatorio
        let error = "";
        if (e.target.value.replace(/[^\d]+/g,"").length == 11) { 
              if(this.validateCpf(e.target.value) == false){
                error = "CPF Inválido";
                if(e.target.value.replace(/[^\d]+/g,"") === "")
                  error = "Informe o CPF";
                this.setField("holder.cpf", error, false, e.target.value);
              }else{
                if(e.target.value === this.state.financialManager.cpf)
                  this.setField("holder.cpf", "CPF do responsável financeiro", false, e.target.value);
                else {
                  this.state.holderError.cpf = "";
                  document.getElementById('loading_hd_cpf').style.display = 'inline-block';
      
                  this.impededCpf(e.target.name,e.target.value);
                //  this.getDados(e.target.name,e.target.value);
                  this.setField("holder.cpf", null, true, e.target.value);
      
                }
              }          
        }
        else {
          this.state.holderError.cpf = error;
        }        

      }else{
        if(e.target.value.replace(/[^\d]+/g,"") === "")
          this.setField("holder.cpf", null, true, e.target.value);
        else{
          if(this.validateCpf(e.target.value) == false)
            this.setField("holder.cpf", "CPF inválido", false, e.target.value);
          else
            if(e.target.value === this.state.financialManager.cpf)
              this.setField("holder.cpf", "CPF do responsável financeiro", false, e.target.value);
            else
              this.setField("holder.cpf", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "hd_dateOfBirth"){
      if(state.requiredField.holder.dateOfBirth === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateDate(e.target.value) == false){
          error = "Data inválida";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error="Informe a data de nascimento";
          this.setField("holder.dateOfBirth", error, false, e.target.value);
        }else
          this.setField("holder.dateOfBirth", null, true, e.target.value);
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') == "")
          this.setField("holder.dateOfBirth", null, true, e.target.value);
        else{
          if(this.validateDate(e.target.value) == false)
            this.setField("holder.dateOfBirth", "Data inválida", false, e.target.value);
          else
            this.setField("holder.dateOfBirth", null, true, e.target.value);
        }
      }
    }
    if(e.target.name === "hd_motherName"){
      if(state.requiredField.holder.motherName === "REQUIRED"){//campo obrigatorio
        if(this.validateLetters(e.target.value) == false){
          let error = "Informe apenas letras";
          if(e.target.value == "")
            error = "Informe o nome completo";
          this.setField("holder.motherName", error, false, e.target.value.toUpperCase());
        }else{
          this.setField("holder.motherName", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value == "")
          this.setField("holder.motherName", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateLetters(e.target.value) == false)
            this.setField("holder.motherName", "Informe apenas letras", false, e.target.value.toUpperCase());
          else
            this.setField("holder.motherName", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "hd_susNumber"){
      if(state.requiredField.holder.susNumber === "REQUIRED"){//campo obrigatorio
        if(e.target.value == "")
          this.setField("holder.susNumber", "Número do cartão do SUS obrigatório", true, e.target.value);
        else{
          if(this.validateNumber(e.target.value) == false ){
            this.setField("holder.susNumber", "Informe apenas números", false, e.target.value);
          }else{
            if(this.validateSus(e.target.value) == false)
              this.setField("holder.susNumber", "Número do SUS tem 15 dígitos", true, e.target.value);
            else
              this.setField("holder.susNumber", null, true, e.target.value);
          }
        }
      }else{
        if(e.target.value == "")
          this.setField("holder.susNumber", null, true, e.target.value);
        else{
          if(this.validateNumber(e.target.value) == false ){
            this.setField("holder.susNumber", "Informe apenas números", false, e.target.value);
          }else{
            if(this.validateSus(e.target.value) == false){
              this.setField("holder.susNumber", "Número do SUS tem 15 dígitos", true, e.target.value);
            }else
              this.setField("holder.susNumber", null, true, e.target.value);
          }
        }
      }
    }
    //dependent
    if(e.target.name === "dp_firstName"){
      if(state.requiredField.dependent.firstName === "REQUIRED"){//campo obrigatorio
        if(this.validateLetters(e.target.value) == false){
          let error = "Informe apenas letras";
          if(e.target.value == "")
            error = "Informe o nome completo";
          this.setFieldDependents("dependent.firstName", error, false, e.target.value.toUpperCase());
        }else{
          this.setFieldDependents("dependent.firstName", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value == "")
          this.setFieldDependents("dependent.firstName", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateLetters(e.target.value) == false)
            this.setFieldDependents("dependent.firstName", "Informe apenas letras", false, e.target.value.toUpperCase());
          else
            this.setFieldDependents("dependent.firstName", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "dp_cpf"){
      this.setFieldDependents("dependent.cpf", "", true, e.target.value);
      if(state.requiredField.dependent.cpf === "REQUIRED"){//campo obrigatorio
        let error = "";
        if (e.target.value.replace(/[^\d]+/g,"").length == 11) { 
                  if(this.validateCpf(e.target.value) == false){
                    error = "CPF Invásslido";
                    if(e.target.value.replace(/[^\d]+/g,"") === ""){
                      if(this.state.dependentValidation.dateOfBirth == true){//verifica se a data eh valida e preenchida
                        if(this.validateDateCpfDependent(this.state.dependent[this.state.depIndex].dateOfBirth) > 10 ){//verificaçao de idade
                          error = "CPF OBRIGATÓRIO";
                          this.setFieldDependents("dependent.cpf", error, false, e.target.value);
                        }else {
                          this.setFieldDependents("dependent.cpf", "", true, e.target.value);
                        }
                          
                      }else{
                        this.setFieldDependents("dependent.cpf", "", null, e.target.value);//volta ao default de validacao
                      }
                    }else
                      this.setFieldDependents("dependent.cpf", error, false, e.target.value);
                  }else{
          
                    let position = null;
                    for(let i=0; i<this.state.dependentsList.length; i++){//serve para saber se o cpf ja foi add na lista de dependetes ou eh do titular
                      if(e.target.value == this.state.dependentsList[i].cpf){
                        position = i;break;
                      }
                    }
                    if(position != null){
                      if(position == 0)
                        this.setFieldDependents("dependent.cpf", "CPF do titular", false, e.target.value);
                      else
                        this.setFieldDependents("dependent.cpf", "Dependente já adicionado", false, e.target.value);
                    }
                    else {
                      this.state.dependentError.cpf = "";
                      document.getElementById('loading_dp_cpf').style.display = 'inline-block';
          
                      this.impededCpf(e.target.name,e.target.value);
                      this.setFieldDependents("dependent.cpf", "", true, e.target.value);
          
                    }
                      
                  }          
        }   
        else {
            this.state.dependentError.cpf = error;
        }             

      }else{
        if(e.target.value.replace(/[^\d]+/g,"") === ""){
          if(this.state.dependentValidation.dateOfBirth == true){//verifica se a data eh valida e preenchida
            if(this.validateDateCpfDependent(this.state.dependent[this.state.depIndex].dateOfBirth) > 10)//verificaçao de idade
              this.setFieldDependents("dependent.cpf", "CPF OBRIGATÓRIO", false, e.target.value);
            else
              this.setFieldDependents("dependent.cpf", "", true, e.target.value);
          }else
            this.setFieldDependents("dependent.cpf", "", null, e.target.value);//volta ao default de validacao
        }else{

          // Paulo
          if(this.validateCpf(e.target.value) == false)
            this.setFieldDependents("dependent.cpf", "CPF inválido", false, e.target.value);
          else{
            let position = null;
            for(let i=0; i<this.state.dependentsList.length; i++){//serve para saber se o cpf ja foi add na lista de dependetes ou eh do titular
              if(e.target.value == this.state.dependentsList[i].cpf){
                position = i;break;
              }
            }
            if(position != null){
              if(position == 0) {
                this.setFieldDependents("dependent.cpf", "CPF do titular", false, e.target.value);
              }
              else {
                this.setFieldDependents("dependent.cpf", "Dependente já adicionado", false, e.target.value);
              }
            }
            else {          
              this.setFieldDependents("dependent.cpf", null, true, e.target.value);

            }
          }
        }
      }
    }

    if(e.target.name === "dp_dateOfBirth"){
      if(state.requiredField.dependent.dateOfBirth === "REQUIRED"){//campo obrigatorio
        let error = "";
        if(this.validateDate(e.target.value) == false){
          error = "Data inválida";
          if(e.target.value.replace(/[^0-9]/g,'') == "")
            error="Informe a data de nascimento";
          this.setFieldDependents("dependent.dateOfBirth", error, false, e.target.value);
        }else{
          this.setFieldDependents("dependent.dateOfBirth", "", true, e.target.value);
          //verifica a idade, para obrigatoriedade do cpf
          // if(this.validateDateCpfDependent(e.target.value)>10){
          //   if(this.state.dependentValidation.cpf == null || this.state.dependentValidation.cpf == false || document.getElementById("dp_cpf").value == "") { //quer dizer q o cpf ainda nao foi digitado              
          //       this.setFieldDependents("dependent.cpf", "CPF OBRIGATÓRIO ", false, this.state.dependent[this.state.depIndex].cpf);
          //   }     
          // }else{
          //   if(this.state.dependentValidation.cpf == null || this.state.dependentValidation.cpf == false) //quer dizer q o cpf ainda nao foi digitado
          //     if(document.getElementById("dp_cpf").value.replace(/[^0-9]/g,'') != "" ) {
          //       if(this.validateCpf(document.getElementById("dp_cpf").value) == false)
          //         this.setFieldDependents("dependent.cpf", "CPF INVÁLIDO", false, this.state.dependent[this.state.depIndex].cpf);
          //       else
          //         this.setFieldDependents("dependent.cpf", "", true, this.state.dependent[this.state.depIndex].cpf);  
          //     } else
          //       this.setFieldDependents("dependent.cpf", "", true, this.state.dependent[this.state.depIndex].cpf);
          // }
        }
      }else{
        if(e.target.value.replace(/[^0-9]/g,'') == ""){
          this.setFieldDependents("dependent.dateOfBirth", "", true, e.target.value);
          //verifica a idade, para obrigatoriedade do cpf
          if(this.validateDateCpfDependent(e.target.value)>10){
            if(this.state.dependentValidation.cpf == null || this.state.dependentValidation.cpf == false) //quer dizer q o cpf ainda nao foi digitado
              this.setFieldDependents("dependent.cpf", "CPF OBRIGATÓRIO 2", false, this.state.dependent[this.state.depIndex].cpf);
          }else{
            if(this.state.dependentValidation.cpf == null || this.state.dependentValidation.cpf == false) //quer dizer q o cpf ainda nao foi digitado
              this.setFieldDependents("dependent.cpf", "", null, this.state.dependent[this.state.depIndex].cpf);
          }
        }else{
          if(this.validateDate(e.target.value) == false)
            this.setFieldDependents("dependent.dateOfBirth", "Data inválida", false, e.target.value);
          else{
            this.setFieldDependents("dependent.dateOfBirth", "", true, e.target.value);
            //verifica a idade, para obrigatoriedade do cpf
            if(this.validateDateCpfDependent(e.target.value)>10){
              if(this.state.dependentValidation.cpf == null || this.state.dependentValidation.cpf == false) //quer dizer q o cpf ainda nao foi digitado
                this.setFieldDependents("dependent.cpf", "CPF OBRIGATÓRIO 3", false, this.state.dependent[this.state.depIndex].cpf);
            }else{
              if(this.state.dependentValidation.cpf == null || this.state.dependentValidation.cpf == false) //quer dizer q o cpf ainda nao foi digitado
                this.setFieldDependents("dependent.cpf", "", null, this.state.dependent[this.state.depIndex].cpf);
            }
          }
        }
      }
    }
    if(e.target.name === "dp_motherName"){
      if(state.requiredField.dependent.motherName === "REQUIRED"){//campo obrigatorio
        if(this.validateLetters(e.target.value) == false){
          let error = "Informe apenas letras";
          if(e.target.value == "")
            error = "Informe o nome completo";
          this.setFieldDependents("dependent.motherName", error, false, e.target.value.toUpperCase());
        }else{
          this.setFieldDependents("dependent.motherName", null, true, e.target.value.toUpperCase());
        }
      }else{
        if(e.target.value == "")
          this.setFieldDependents("dependent.motherName", null, true, e.target.value.toUpperCase());
        else{
          if(this.validateLetters(e.target.value) == false)
            this.setFieldDependents("dependent.motherName", "Informe apenas letras", false, e.target.value.toUpperCase());
          else
            this.setFieldDependents("dependent.motherName", null, true, e.target.value.toUpperCase());
        }
      }
    }
    if(e.target.name === "dp_susNumber"){
      if(state.requiredField.dependent.susNumber === "REQUIRED"){//campo obrigatorio
        if(e.target.value == "")
          this.setFieldDependents("dependent.susNumber", "Número do cartão do SUS obrigatório", false, e.target.value);
        else{
          if(this.validateNumber(e.target.value) == false ){
            this.setFieldDependents("dependent.susNumber", "Informe apenas números", false, e.target.value);
          }else{
            if(this.validateSus(e.target.value) == false)
              this.setFieldDependents("dependent.susNumber", "Número do SUS tem 15 dígitos", false, e.target.value);
            else
              this.setFieldDependents("dependent.susNumber", null, true, e.target.value);
          }
        }
      }else{
        if(e.target.value == "")
          this.setFieldDependents("dependent.susNumber", null, true, e.target.value);
        else{
          if(this.validateNumber(e.target.value) == false ){
            this.setFieldDependents("dependent.susNumber", "Informe apenas números", false, e.target.value);
          }else{
            if(this.validateSus(e.target.value) == false){
              this.setFieldDependents("dependent.susNumber", "Número do SUS tem 15 dígitos", false, e.target.value);
            }else
              this.setFieldDependents("dependent.susNumber", null, true, e.target.value);
          }
        }
      }
    }
    //formas de pagamento
    if(e.target.name === "pay_cardCreditNumber"){
      if(state.requiredField.paymentCreditCard.cardCreditNumber === "REQUIRED"){//campo obrigatorio
        if(this.validateCardNumber(e.target.value) == false){
          let error = "Número inválido";
          if(e.target.value.replace(/\D/g, '') == "")
            error = "Informe o número do cartão";
          this.setField("paymentCreditCard.cardCreditNumber", error, false, e.target.value);
          this.setField("paymentCreditCard.flagCardPayment", "", "", "");//apaga imagem da bandeira
          this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");//apaga 4 ultimos digitos do cartao
        }else{
          let flagValid = this.validateflagOfCard(e.target.value);
          if(flagValid == false){
            this.setField("paymentCreditCard.cardCreditNumber", "Bandeira não aceita", true, e.target.value);
            this.setField("paymentCreditCard.flagCardPayment", "", "", "");//apaga imagem da bandeira
            this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");//apaga 4 ultimos digitos do cartao
          }else{
            this.setField("paymentCreditCard.cardCreditNumber", null, true, e.target.value);
            this.setField("paymentCreditCard.flagCardPayment", "", true, flagValid);//bandeira
            let num = e.target.value.replace(/\D/g, '');
            num = num.toString().substr(num.toString().length-4);
            this.setField("paymentCreditCard.cardNumberFourFinal", "", true, num);//4 ultimos digitos          
            if (flagValid == 'MASTERCARD') 
                this.openModalHiper();
            else 
            this.dateValidityCredtCard(null);
          }
        }
      }else{

        if(e.target.value.replace(/\D/g, '') == ""){
          this.setField("paymentCreditCard.cardCreditNumber", null, true, e.target.value);
          this.setField("paymentCreditCard.flagCardPayment", "", "", "");//apaga imagem da bandeira
          this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");//apaga 4 ultimos digitos do cartao
          this.dateValidityCredtCard(null);
        }else{
          if(this.validateCardNumber(e.target.value) == false){
            this.setField("paymentCreditCard.cardCreditNumber", "Número inválido", false, e.target.value);
            this.setField("paymentCreditCard.flagCardPayment", "", "", "");//apaga imagem da bandeira
            this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");//apaga 4 ultimos digitos do cartao
          }else{
            let flagValid = this.validateflagOfCard(e.target.value);
            if(flagValid == false){
              this.setField("paymentCreditCard.cardCreditNumber", "Bandeira não aceita", true, e.target.value);
              this.setField("paymentCreditCard.flagCardPayment", "", "", "");
              this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");
            }else{
              this.setField("paymentCreditCard.cardCreditNumber", null, true, e.target.value);
              this.setField("paymentCreditCard.flagCardPayment", "", true, flagValid);//bandeira
              let num = e.target.value.replace(/\D/g, '');
              num = num.toString().substr(num.toString().length-4);
              this.setField("paymentCreditCard.cardNumberFourFinal", "", true, num);//4 ultimos digitos
              if (flagValid == 'MASTERCARD') 
                this.openModalHiper();
              else 
                this.dateValidityCredtCard(null);
            }
          }
        }
      }
    }
    if(e.target.name === "pay_cardExpiring"){
      if(state.requiredField.paymentCreditCard.cardExpiring === "REQUIRED"){//campo obrigatorio
        if(this.validateExpirationDateCard(e.target.value) == false){
          let error = "Data inválida";
          if(e.target.value.replace(/\D/g, '') == "")
            error = "Informe a validade do Cartão";
          this.setField("paymentCreditCard.cardExpiring", error, false, e.target.value);
        }else{
          this.setField("paymentCreditCard.cardExpiring", null, true, e.target.value);
          // analisar para retirar 
          //this.dateValidityCredtCard(null);
        }
      }else{
        if(e.target.value.replace(/\D/g, '') == ""){
          this.setField("paymentCreditCard.cardExpiring", null, true, e.target.value);
          this.dateValidityCredtCard(null);
        }else{
          if(this.validateExpirationDateCard(e.target.value) == false)
            this.setField("paymentCreditCard.cardExpiring", "Data inválida", false, e.target.value);
          else {
            this.setField("paymentCreditCard.cardExpiring", null, true, e.target.value);
          // analisar para retirar 
          //this.dateValidityCredtCard(null);
            this.dateValidityCredtCard(null);
          }
        }
      }
    }
    if (e.target.name === "pay_cardHolderName") {
      if (state.requiredField.paymentCreditCard.cardHolderName === "REQUIRED") {//campo obrigatorio
        if (e.target.value == "") {
          let error = "Informe o nome do Cartão";
          this.setField("paymentCreditCard.cardHolderName", error, false, e.target.value.toUpperCase());
        }
        else {
          this.setField("paymentCreditCard.cardHolderName", null, true, e.target.value.toUpperCase());
          //this.dateValidityCredtCard(null);
        }
      }
      else {
        this.setField("paymentCreditCard.cardHolderName", null, true, e.target.value.toUpperCase());
        //this.dateValidityCredtCard(null);
      }
    }

    this.setState(state);
  }
  /***************** FUNÇOES DE ENVIO E MANIPULAÇAO DOS DADOS  ****************/

  /*
addHolderListDependent() {
    let state = this.state;
    state.holder.isHolder = true;
    
    // Garante que o titular recebe a portabilidade definida no topo do form
    state.holder.portability = this.state.portability;

    // Se o responsável financeiro for o titular
    if (this.state.others.formHolder == false) {
      state.holder.firstName = this.state.financialManager.firstName;
      state.holder.susNumber = this.state.financialManager.susNumber;
      state.holder.motherName = this.state.financialManager.motherName;
      state.holder.cpf = this.state.financialManager.cpf;
      state.holder.dateOfBirth = this.state.financialManager.dateOfBirth;
      state.holder.maritalStatus = this.state.financialManager.maritalStatus;
      state.holder.gender = this.state.financialManager.gender;
      state.holder.isHolder = true;
      state.holder.portability = this.state.portability; // 👈 Atualiza aqui também
    }
    
    state.dependentsList[0] = state.holder;
    this.setState(state);
  } 
    */ 
  /* 
  addDependentList() {
    // VALIDAR CPF 000.000.
    let dependent = {};
    if(this.validateForm("dependent") == true){
      let state = this.state;
      dependent = this.state.dependent[this.state.depIndex];
      dependent.isHolder = false;
      
      //necessario para usar lastName
      dependent.lastName ="";
      dependent.dateOfBirth = this.formatToISO(dependent.dateOfBirth);
      dependent.portability = this.state.dependent[this.state.depIndex].portability;
      state.dependentsList.push(dependent);

      let defaultDependent = {
        firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
        maritalStatus: "", gender: "", parentage: "", isHolder: "", portability: "", plansId: ""
      };
      state.dependent.push(defaultDependent);
      state.depIndex++;
      this.setState(state);
      this.clearField("dependentValidation", null);
      this.clearField("dependentError", "");
      this.updateValueTotal();//atualiza valor do plano.

    }else{
      this.handleErrorOpen();//modal campos invalidos
    }
  }
  */
addHolderListDependent() {
    let state = this.state;
    state.holder.isHolder = true;
    state.holder.portability = this.state.portability;

    if (this.state.others.formHolder == false) {
      state.holder.firstName = this.state.financialManager.firstName;
      state.holder.susNumber = this.state.financialManager.susNumber;
      state.holder.motherName = this.state.financialManager.motherName;
      state.holder.cpf = this.state.financialManager.cpf;
      state.holder.dateOfBirth = this.state.financialManager.dateOfBirth;
      state.holder.maritalStatus = this.state.financialManager.maritalStatus;
      state.holder.gender = this.state.financialManager.gender;
      state.holder.isHolder = true;
      state.holder.portability = this.state.portability;
    }
    
    // Titular assume o plano principal selecionado
    state.holder.planName = state.planoSelecionado.tradeName || state.planoSelecionado.name;
    state.holder.valuePlan = state.planoSelecionado.tabelaPreco.value2;
    state.holder.plansId = state.planoSelecionado.id || state.planoSelecionado.codeS4;
    
    state.dependentsList[0] = state.holder;
    this.setState(state);
  } 
addDependentList() {
    let dependent = {};
    if(this.validateForm("dependent") == true){
      let state = this.state;
      dependent = { ...this.state.dependent[this.state.depIndex] }; // Clona o objeto atual
      dependent.isHolder = false;
      dependent.lastName ="";
      dependent.dateOfBirth = this.formatToISO(dependent.dateOfBirth);
      dependent.portability = this.state.dependent[this.state.depIndex].portability;
      
      // 🔍 BUSCAR O PLANO ESPECÍFICO SELECIONADO PELO DEPENDENTE
      let planoEscolhido = null;
      if (dependent.plansId && state.planos_correlacionados) {
        planoEscolhido = state.planos_correlacionados.find(
          p => (p.id === dependent.plansId || p.codeS4 === dependent.plansId)
        );
      }

      // Se encontrou o plano correlacionado, salva os dados dele. Senão, herda o principal.
      if (planoEscolhido) {
        dependent.planName = planoEscolhido.tradeName || planoEscolhido.name;
        dependent.valuePlan = planoEscolhido.value2 || planoEscolhido.value || (planoEscolhido.tabelaPreco ? planoEscolhido.tabelaPreco.value2 : "0,00");
      } else {
        dependent.planName = state.planoSelecionado.tradeName || state.planoSelecionado.name;
        dependent.valuePlan = state.planoSelecionado.tabelaPreco.value2;
        dependent.plansId = state.planoSelecionado.id || state.planoSelecionado.codeS4;
      }

      state.dependentsList.push(dependent);

      let defaultDependent = {
        firstName: "", susNumber: "", motherName: "", cpf: "", dateOfBirth: "",
        maritalStatus: "", gender: "", parentage: "", isHolder: "", portability: "", plansId: ""
      };
      state.dependent.push(defaultDependent);
      state.depIndex++;
      this.setState(state);
      this.clearField("dependentValidation", null);
      this.clearField("dependentError", "");
      this.updateValueTotal(); // Atualiza os valores totais

    }else{
      this.handleErrorOpen();
    }
  }

  deleteDependentList(index) {
    let state = this.state;
    state.dependentsList.splice(index,1);
    this.setState(state);
    this.updateValueTotal();//atualiza valor do plano.
  }
  /************************ GETS Localize ************************************/
  getDados(campo, cpf) {
    // Pega o endereço POST 

    document.getElementById('loading_'+campo).style.display = 'inline-block';

    axios.get(urlBase.loopBack + 'APIS4s/BuscaDadosPorCPF?cpf='+cpf ) 
    .then((result) => {
     // let state = this.state;
      if (result.data != null) {
        var errorCampoObrigatorio = "CAMPO OBRIGATÓRIO";

        if (campo == 'fm_cpf') {
                    this.setField("financialManager.cpf", null, true, cpf);            
                    this.setField("financialManager.addressComplement", null, true, "");     
                    this.setField("financialManager.addressNumber", null, true, "");    
                    this.setField("financialManager.dateOfBirth", null, true, "");
                    this.setField("financialManager.motherName", null, true, "");     
                    this.setField("financialManager.firstName", null, true, '');              


                    if (result.data.dadosCadastrais != undefined) {

                      if ( result.data.dadosCadastrais.nome == '' || result.data.dadosCadastrais.nome == null) {

                        this.state.isEditFinancialManagerName = false;
                        document.getElementById('fm_firstName').focus();          

                      } else {
                        this.setField("financialManager.firstName", null, true, result.data.dadosCadastrais.nome.toUpperCase());              
                        this.state.isEditFinancialManagerName = true;         
                        document.getElementById('fm_email').focus();          
            
                      }
            
                      if ( result.data.dadosCadastrais.dataNascimento == '' || result.data.dadosCadastrais.dataNascimento == null) {
                        this.state.isEditFinancialManagerDateOfBirth = false;              
                        this.setField("financialManager.dateOfBirth", errorCampoObrigatorio, false, "");

                      } else {
                        this.setField("financialManager.dateOfBirth", null, true, result.data.dadosCadastrais.dataNascimento.toUpperCase());              
                        this.state.isEditFinancialManagerDateOfBirth = true;              
                      }

                      if ( result.data.dadosCadastrais.maeNome == '' || result.data.dadosCadastrais.maeNome == null) {
                        this.state.isEditFinancialManagerMotherName  = false;  
                        this.setField("financialManager.motherName", errorCampoObrigatorio, false, "");

                      } else {
                        this.setField("financialManager.motherName", null, true, result.data.dadosCadastrais.maeNome.toUpperCase());              
                        this.state.isEditFinancialManagerMotherName  = true;              
                      }
                       this.handleChangeSelectField("fm_gender","","",(result.data.dadosCadastrais.sexo != null ? (result.data.dadosCadastrais.sexo == "Masculino" ? "1" : "0") : ""))      

                    } else {
                      this.state.isEditFinancialManagerName = false;
                      this.state.isEditFinancialManagerMotherName = false;
                      this.state.isEditFinancialManagerDateOfBirth = false;
                      this.setField("financialManager.motherName", errorCampoObrigatorio, false, "");
                      this.setField("financialManager.dateOfBirth", errorCampoObrigatorio, false, "");
                      this.setField("financialManager.firstName", errorCampoObrigatorio, false, "");
                      document.getElementById('fm_firstName').focus();          


                    }
                    // Trata endereço
                    if (result.data.enderecos != undefined && result.data.enderecos != '' && result.data.enderecos != null ) { 
                      if ( result.data.enderecos.length > 1 ) {
                        for (let index = 0; index < result.data.enderecos.length; index++) {
                          const element = result.data.enderecos[index];
                          if (element.uf == 'PB' || element.uf == 'RN' || element.uf == 'PE' || element.uf == 'MA' ) {
                            let change = {
                              target : {
                              name : "fm_cep",
                              value : result.data.enderecos[0].cep
                              }
                            }
                              this.handleChange(change,"");
                              this.setField("financialManager.addressNumber", null, true, result.data.enderecos[0].numero);     
                              this.setField("financialManager.addressComplement", null, true, result.data.enderecos[0].complemento);
                              break;
                          }
                        }
                        /// tratar mais de um

                      } else { // retorna apenas um endereço
                        if (result.data.enderecos[0].uf == 'PB' || result.data.enderecos[0].uf == 'RN' || result.data.enderecos[0].uf == 'PE' ||
                          result.data.enderecos[0].uf == 'MA' ) {
                              let change = {
                                target : {
                                name : "fm_cep",
                                value : result.data.enderecos[0].cep
                                }
                              }
                                this.handleChange(change,"");
                                this.setField("financialManager.addressNumber", null, true, result.data.enderecos[0].numero);     
                                this.setField("financialManager.addressComplement", null, true, result.data.enderecos[0].complemento);                              
                            
                          } else {
                            this.setField("financialManager.state", errorCampoObrigatorio, false, "");
                            this.setField("financialManager.state", errorCampoObrigatorio, false, "");
                            this.setField("financialManager.addressType", errorCampoObrigatorio, false,"");
                            this.setField("financialManager.address", errorCampoObrigatorio, false,"");
                            this.setField("financialManager.city", errorCampoObrigatorio, false,'');
                            this.setField("financialManager.district", errorCampoObrigatorio, false,"");
                            this.setField("financialManager.addressNumber", errorCampoObrigatorio, false, '');     
                          }
                      }
               
                    } else {
                      this.setField("financialManager.state", errorCampoObrigatorio, false, "");
                      this.setField("financialManager.addressType", errorCampoObrigatorio, false,"");
                      this.setField("financialManager.address", errorCampoObrigatorio, false,"");
                      this.setField("financialManager.city", errorCampoObrigatorio, false,'');
                      this.setField("financialManager.district", errorCampoObrigatorio, false,"");
                      this.setField("financialManager.addressNumber", errorCampoObrigatorio, false, '');     
                    }
   
                    if (this.state.isEditFinancialManagerName == false) {
                      document.getElementById('fm_firstName').focus();          

                    }
                    else {
                      document.getElementById('fm_email').focus();               
                    }

        }

        if (campo == 'hd_cpf') {

          this.setField("holder.firstName", null, true, "");
          this.setField("holder.dateOfBirth", null, true, "");
          this.setField("holder.motherName", null, true, ""); 

          if (result.data.dadosCadastrais != undefined) {

            if ( result.data.dadosCadastrais.nome == '' || result.data.dadosCadastrais.nome == null) {
              this.state.isEditHolderName = false;
              this.setField("holder.firstName", "Informe o nome completo", true, "");
              document.getElementById('hd_firstName').focus();  
            } else {
              this.state.isEditHolderName = true;     
              document.getElementById('hd_maritalStatus').focus();   
              this.setField("holder.firstName", null, true, result.data.dadosCadastrais.nome.toUpperCase());              

            }
  
            if ( result.data.dadosCadastrais.dataNascimento == '' || result.data.dadosCadastrais.dataNascimento == null) {
              this.state.isEditHolderDateOfBirth = false;              
              this.setField("holder.dateOfBirth", "Informe a data de nascimento", false, "");

            } else {
              this.state.isEditHolderDateOfBirth = true;       
              this.setField("holder.dateOfBirth", "", true, result.data.dadosCadastrais.dataNascimento);              

            }
            if ( result.data.dadosCadastrais.maeNome == '' || result.data.dadosCadastrais.maeNome == null) {
              this.state.isEditHolderMotherName  = false;              
              this.setField("holder.motherName", "Informe o nome da mãe", false, "");             


            } else {
              this.state.isEditHolderMotherName  = true;              
              this.setField("holder.motherName", null, true, result.data.dadosCadastrais.maeNome.toUpperCase());             
            }

  
            this.handleChangeSelectField("hd_gender","","", (result.data.dadosCadastrais.sexo == null ? (result.data.dadosCadastrais.sexo == "Masculino" ? "1" : "0") : "") )           

          } else {

            this.state.isEditHolderName = false;
            this.setField("holder.firstName", "Informe o nome completo", false, "");

            this.state.isEditHolderMotherName = false;
            this.setField("holder.motherName", "Informe o nome da mãe", false, "");             

            this.state.isEditHolderDateOfBirth = false;
            this.setField("holder.dateOfBirth", "Informe a data de nascimento", false, "");
            document.getElementById('hd_firstName').focus();  


          } 

          if (this.state.isEditHolderName == false) {
             document.getElementById('hd_firstName').focus();  
          }
          else {
            document.getElementById('hd_maritalStatus').focus();   

          }

       //   this.setField("holder.firstName", null, true, result.data.dadosCadastrais.nome.toUpperCase());
       //   this.setField("holder.dateOfBirth", null, true, result.data.dadosCadastrais.dataNascimento);
       //   this.setField("holder.motherName", null, true, result.data.dadosCadastrais.maeNome.toUpperCase());        
       //   this.handleChangeSelectField("hd_gender","","",(result.data.dadosCadastrais.sexo == "Masculino" ? "1" : "0"))          

        }        


        if (campo == 'dp_cpf') {

          this.setFieldDependents("dependent.firstName", null, true, "");
          this.setFieldDependents("dependent.dateOfBirth", null, true, "");
          this.setFieldDependents("dependent.motherName", null, true, "");             

          if (result.data.dadosCadastrais != undefined) {

            if ( result.data.dadosCadastrais.nome == '' || result.data.dadosCadastrais.nome == null) {
              this.state.isEditDependentName = false;
            } else {
              this.setFieldDependents("dependent.firstName", null, true, result.data.dadosCadastrais.nome.toUpperCase());              
              this.state.isEditDependentName = true;           
            }
  
            if ( result.data.dadosCadastrais.dataNascimento == '' || result.data.dadosCadastrais.dataNascimento == null) {
              this.state.isEditDependentDateOfBirth = false;              
              this.setFieldDependents("dependent.dateOfBirth", "Informe a data de nascimento", false, "");

            } else {
              this.setFieldDependents("dependent.dateOfBirth", "", true, result.data.dadosCadastrais.dataNascimento);              
              this.state.isEditDependentDateOfBirth = true;              
            }
            if ( result.data.dadosCadastrais.maeNome == '' || result.data.dadosCadastrais.maeNome == null || result.data.dadosCadastrais.maeNome == undefined) {
              this.state.isEditDependentMotherName  = false;          
              this.setFieldDependents("dependent.motherName", "Informe o nome da mãe", false, "");
    
            } else {
              this.setFieldDependents("dependent.motherName", null, true, result.data.dadosCadastrais.maeNome.toUpperCase());             
              this.state.isEditDependentMotherName  = true;              
            }

  
            this.handleChangeSelectField("dp_gender","","", ( result.data.dadosCadastrais.sexo != null ? (result.data.dadosCadastrais.sexo == "Masculino" ? "1" : "0") : "") )          

          } else {
  
            this.state.isEditDependentName = false;
            this.state.isEditDependentMotherName = false;
            this.state.isEditDependentDateOfBirth = false;
            this.setFieldDependents("dependent.motherName", "Informe o nome da mãe", false, "");
            this.setFieldDependents("dependent.firstName", "Informe o nome completo", false, "");
            this.setFieldDependents("dependent.dateOfBirth", "Informe a data de nascimento", false, "");

        //    this.setFieldDependents("dependent.firstName", null, true, '');              
            document.getElementById('dp_firstName').focus();              


          }          
 
          if (this.state.isEditDependentName == false) {
            document.getElementById('dp_firstName').focus();  
         }
         else {
           document.getElementById('dp_maritalStatus').focus();   

         }    

        }  
      }        
      document.getElementById('loading_'+campo).style.display  = 'none';
    })
    .catch(function (erro) {
      alert("Não conseguimos localizar os dados do CPF informado!. Detalhes : " + erro);
    });
  }
 
  /************************ GETS S4 ************************************/
  //APIS4s/Endereco
  getAddress(cep) {
    this.setField("financialManager.addressComplement", "", true, '');      
    document.getElementById('loading_address').style.display = 'inline-block';//icone loading
    let dataPost = {
      'cep': cep
    };
    // Pega o endereço
    let state = this.state;
    axios.post(urlBase.loopBack + 'APIS4s/Endereco', dataPost)
    .then((result) => {
      if (result.data != null) {
        if ( result.data.Uf != "MARANHÃO" && result.data.Uf != "PARAIBA" && result.data.Uf != "PERNAMBUCO" 
          && result.data.Uf != "RIO GRANDE DO NORTE" 
          && result.data.Uf != "ALAGOAS" 
        ) {
            alert("O CEP informado não faz parte da abrangência antedida pela Dental");
            this.setField("financialManager.state",  "CAMPO OBRIGATÓRIO", false, "");
            this.setField("financialManager.addressType",  "CAMPO OBRIGATÓRIO", false, "");
            this.setField("financialManager.address", "CAMPO OBRIGATÓRIO", false,"");
            this.setField("financialManager.city",  "CAMPO OBRIGATÓRIO", false, "");
            this.setField("financialManager.district",  "CAMPO OBRIGATÓRIO", false,"");
            this.setField("financialManager.addressNumber",  "CAMPO OBRIGATÓRIO", false, '');     
            this.setField("financialManager.addressComplement", "", true, '');     
           
            return;
        }
        // Atualiza a lista de cidades e de bairros        
        state.cityList = [];
        state.districtList = [];


        if (state.planSLZ.includes(state.planName) && result.data.Uf != "MARANHÃO") {
          state.planAvaliable = false;
          state.stateMASLZ = false
        }

        if (state.planSLZ.includes(state.planName) && result.data.Uf == "MARANHÃO") {
          state.planAvaliable = true;          
          state.stateMASLZ = true
        }
        if (state.planPB.includes(state.planName) && ( result.data.Uf != "PARAIBA" || result.data.Uf != "PERNAMBUCO" || result.data.Uf != "RIO GRANDE DO NORTE"  ) ) {
          state.planAvaliable = false;
       //   if (result.data.Municipio == "JOAO PESSOA")
          state.stateJPA = false;

        }

        if (state.planPB.includes(state.planName) && ( result.data.Uf == "PARAIBA" || result.data.Uf == "PERNAMBUCO" || result.data.Municipio == "NATAL")) {
          state.planAvaliable = true;
        //  if (result.data.Municipio == "JOAO PESSOA")
          state.stateJPA = true;
          state.openCep = false;
          state.combineWithSalesman = true;
        }
        //@s4e uf
       // this.setState(state);
        this.getCity(result.data.IdUf);
        this.getDistrict(result.data.IdMunicipio);     
        this.getAddressType();
        this.state.IdBairro = result.data.IdBairro;
        this.state.nomeBairro = result.data.Bairro;
        this.state.municipio = result.data.Municipio;
        this.state.estado = result.data.Uf
        this.setField("financialManager.state", "", true, result.data.IdUf);
        this.setField("financialManager.addressType", "", true, result.data.IdTipoLogradouro);
        this.setField("financialManager.address", "", true, result.data.Logradouro);
        this.setField("financialManager.city", "", true, result.data.IdMunicipio);
        this.setField("financialManager.district", "", true, result.data.IdBairro);
        this.setField("financialManager.com", "", true, result.data.IdBairro);


        document.getElementById('fm_city').value = result.data.IdMunicipio;
        document.getElementById('fm_addressType').value = result.data.IdMunicipio;
        document.getElementById('fm_district').value = result.data.IdBairro;
        document.getElementById('loading_address').style.display = 'none';
      }
      else{
        this.setField("financialManager.cep", "Cep não encontrado! informe os campos de endereço manualmente", true, cep);
        document.getElementById('loading_address').style.display = 'none';
      }
    })
    .catch(function (erro) {
      document.getElementById('loading_address').style.display = 'none';
      console.log("Erro ao buscar endereço : " + erro);
    });
  }
  //APIS4s/UFs
  getStates(){
    // Pega a lista de estados
    axios.get(urlBase.loopBack + 'APIS4s/UFs')
    .then((result) => {
      let state = this.state;
      state.stateList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      console.log(erro);
    });
  }
  //APIS4s/Municipios
  getCity(idState) {
    let dataPost = {
      'idUF': idState
    };
    // Pega a lista de cidades
    axios.post(urlBase.loopBack + 'APIS4s/Municipios', dataPost)
    .then((result) => {
      let state = this.state;
      state.cityList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      let state = this.state;
      state.financialManager.city = null;
      state.cityList = [];
      console.log("Erro ao buscar cidades : "+ erro);
      this.setState(state);

    });
  }
  //APIS4s/Bairros
  getDistrict(IdCity) {
    let dataPost = {
      'idCity': IdCity
    };
    // Pega a lista de bairros
    axios.post(urlBase.loopBack + 'APIS4s/Bairros', dataPost)
    .then((result) => {
      let state = this.state;
      state.districtList = result.data;
      this.setState(state);

      //definição do centro de custo
      axios.get(urlBase.loopBack + 'Cities?filter={"where":{"codeS4":"'+IdCity+'"}}')
      .then((result2) => {
        document.getElementById('fm_addressNumber').focus();
        document.getElementById('loading_address').style.display = 'none';
        if (result2.data[0] != undefined){
          sessionStorage.setItem('select_cities', result2.data[0].id);
        }          
        else{
          
          if (state.financialManager.state=='9'){
            axios.get(urlBase.loopBack + 'Cities?filter={"where":{"codeS4":"210"}}')
              .then((result3) => {
                // Padrão Maranhão
                sessionStorage.setItem('select_cities', result3.data[0].id);
              })
              .catch(function (erro) {
                alert('Erro ao buscar cidade padrão do Maranhão: ' + erro);
              });// Fim centro de custo padrão
          }else{
            axios.get(urlBase.loopBack + 'Cities?filter={"where":{"default":true}}')
              .then((result3) => {
                // Padrão João Pessoa
                sessionStorage.setItem('select_cities', result3.data[0].id);
              })
              .catch(function (erro) {
                alert('Erro ao buscar cidade padrão: ' + erro);
              });// Fim centro de custo padrão
          }                    
          
        }
      })
      .catch(function (erro) {
        alert('Erro ao buscar cidades: '+erro);
      });// Fim centro de custo
    })
    .catch(function (erro) {
      console.log("Erro : "+ erro);
    });
  }
  //APIS4s/tipoLogradouro
  getAddressType(){
    // Pega a lista de tipos de endereço
    axios.get(urlBase.loopBack + 'APIS4s/tipoLogradouro')
    .then((result) => {
      let state = this.state;
      state.addressTypeList = result.data;
      this.setState(state);
    })
    .catch(function (erro) {
      console.log("Erro tipo logaradouro :" + erro);
    });
  }
  /*********** GETS BANCO *******************************************/
  getCurrentTimeServer(){
    //Sales/currentTime
    // Pega a data atual do servidor
    axios.post(urlBase.loopBack + 'Sales/currentTime')
    .then((response) => {
      let state = this.state;
      state.currentTimeServer = response.data;
      this.setState(state);
    })
    .catch(function () {
      alert('Problema encontrado ao pegar data do servidor');
    });
  }

  getDataInfo() {
    // Pega características do salesman broker paypal e pag seguro

    if (localStorage.getItem('dental_y') == 'SALESMAN') {
      let idUser = localStorage.getItem('dental_u');

      axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"userId":"'+idUser+'"},"include":["user",{"broker":"user"}]}')
      .then((result) => {
        let salesman = null;

        if (result.data.length == 0) {
          alert('Vendedor não encontrado');
          this.props.onClickFn();
        }
        else if (result.data.length > 1)
          salesman = result.data[result.data.length - 1];
        else
          salesman = result.data[0];

        if (salesman != null) {
          let state = this.state;
          state.nameSalesman = salesman.user.name;
          state.nameBroker = salesman.broker.user.name;
          state.salesmanPagSeguroEmail = salesman.pagSeguroEmail;
          state.salesmanPagSeguroToken = salesman.pagSeguroToken;
          state.salesmanPaypalId = salesman.paypalId;
          this.setState(state);
        }
      })
      .catch(function () {
        alert('Problema encontrado ao pegar dados do vendedor');
        this.props.onClickFn();
      }.bind(this));
    }
    else {
      let salesmanIdSelect = this.props.salesmanId;

      if (salesmanIdSelect != null) {
        axios.get(urlBase.loopBack + 'Salesmans?filter={"where":{"id":"'+salesmanIdSelect+'"},"include":["user",{"broker":"user"}]}')
        .then((result) => {
          let state = this.state;
          state.nameSalesman = result.data[0].user.name;
          state.nameBroker = result.data[0].broker.name;
          state.salesmanPagSeguroEmail = result.data[0].pagSeguroEmail;
          state.salesmanPagSeguroToken = result.data[0].pagSeguroToken;
          state.salesmanPaypalId = result.data[0].paypalId;
          this.setState(state);
        })
        .catch(function () {
          alert('Problema encontrado ao pegar dados do vendedor');
          this.props.onClickFn();
        }.bind(this));
      }
      else {
        alert('Vendedor não selecionado corretamente na etapa anterior');
        this.props.onClickFn();
      }
    }
  }

  dateValiditySalesman() {
    let date = this.state.others.dateSignatureContract;
    date = date.split('/');

   // date = new Date(date[2], date[1], date[0]);
    let day = date[0];
    let year = date[2];
    let month = date[1] //date.getMonth() + 1;

    /* let chosenDate = document.getElementById(id).value; */
    if (day < 10)
      day = '0' + day;
    if (month < 10)
      month = '0' + month;
    moment.locale('pt-BR');

    let dataSubmit = {
      city: sessionStorage.getItem("select_cities"),
      dayInclusion: day,
      type: 'BOLETO'
    };
    console.dir(dataSubmit )
    axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
    .then((response) => {
      let state = this.state;
      // Seta as características da forma de pagamento no state para ser enviado posteriormente
      state.financialManager.formOfPaymentId = response.data.id;
      state.financialManager.contractNumberS4 = response.data.codeS4;
      // Início da vigência:
      state.effectiveDate = this.state.others.dateSignatureContract;
      state.financialManager.valid = response.data.validity;


      // Calcula data de vencimento
      state.maturityDate = moment(year + '-' +
                            month + '-' +
                            response.data.validity).add(1, 'M').format('DD/MM/YYYY');
      this.setState(state);
    })
    .catch(function () {
      alert('Erro ao buscar Forma de Pagamento');
    });
  }

  dateValidityCredtCard(day = null) {
    //data de vencimento cartão de crédito
    let chosenDate = day;//dia do vencimento escolhido
      let date = this.state.others.dateSignatureContract;
      date = date.split('/');

      var dia = date[0];    
      /* Retirar esse IF definitivamente  
      if (dia < 10 ){
        dia = '0' + dia;
      }      
      */        
    moment.locale('pt-BR');
    chosenDate = dia;
    let dataSubmit = {
      city: sessionStorage.getItem("select_cities"),
      dayInclusion: chosenDate,
      type: 'CARTÃO',
      flag: MoipValidator.cardType(this.state.paymentCreditCard.cardCreditNumber.replace(/\D/g, '')).brand
    };

    if (dataSubmit.dayInclusion != null) {
      axios.post(urlBase.loopBack + 'FormOfPayments/firstPaymentDate', dataSubmit)
      .then((response) => {
        let state = this.state;
        // Seta as características da forma de pagameto no state para ser enviado posteriormente
        state.financialManager.formOfPaymentId = response.data.id;
        state.financialManager.contractNumberS4 = response.data.codeS4;
       // state.financialManager.cardDayExpiration = this.state.paymentCreditCard.cardInvoiceExpiration;
        state.financialManager.cardDayExpiration = response.data.validity
        // Início da vigência:
        state.effectiveDate = response.data.validity;
        // Calcula data de vencimento: dia escolhido + 1 mês

        /* Regra dos 25 dias */
        let cartao = '';
        let cartaoMes = state.paymentCreditCard.cardExpiring.substring(0,2);
        let cartaoAno = state.paymentCreditCard.cardExpiring.substring(3,7);

        // Cálculo do mês do cartão
        cartaoMes = parseInt(cartaoMes)-1;
        if (cartaoMes < 10)
          cartaoMes = '0'+cartaoMes;

        let partDate = state.others.dateSignatureContract.split('/');
        let adesao = moment(partDate[2]+'-'+partDate[1]+'-'+partDate[0]);

        cartao = moment(new Date(cartaoAno, cartaoMes, '01'));

        if (cartao.diff(adesao, 'days') >= 25) {
          state.maturityDate = moment(state.currentTimeServer.year+'-'+
            state.currentTimeServer.month + '-' +
            response.data.validity
          ).add(1, 'M').format('DD/MM/YYYY');
        }
        else {
          state.maturityDate = moment(state.currentTimeServer.year+'-'+
            state.currentTimeServer.month + '-' +
            response.data.validity
          ).add(2, 'M').format('DD/MM/YYYY');
        }
        /* Fim Regra dos 25 dias */


        /* state.maturityDate = moment(state.currentTimeServer.year + '-' +
                              state.currentTimeServer.month + '-' +
                              response.data.validity).add(1, 'M').format('DD/MM/YYYY'); */
        this.setState(state);
      })
      .catch(function () {
        alert('Erro ao buscar Forma de Pagamento');
      });
    }
  }
  /*
  getDataInfoPlans(){
    // Pega características do plano
    this.getCurrentTimeServer();
    axios.get(urlBase.loopBack + 'Plans/'+localStorage.getItem("dental_plan"))
    .then((result) => {
      let state = this.state;
      state.value_plan = result.data.value;
      state.value_total = result.data.value;
      state.objectPlan = result.data;
      state.planName = result.data.name;
      state.codeS4_plan =  result.data.codeS4;
      // implementar aqui lógica de promoção de novembro
      if ( this.state.currentTimeServer.month == 11
        && ( localStorage.getItem("type_plan")  == 'vip' || localStorage.getItem("type_plan")  == 'digital' )
        && 	(localStorage.getItem('dental_u') == '6130e3def501252ea56929e3' 
          || localStorage.getItem('dental_u') == '5dd55301ee0313765bd2bc81'
          || localStorage.getItem('dental_u') == '60db2529723a84336c5db4f0' 
          || localStorage.getItem('dental_u') == '66b5f9abe7c20a534766e989') 
          )
          { 

            if ( localStorage.getItem("type_plan") == 'vip' ) { // Plano VIP
              this.state.value_plan  = "31,50";
              if (result.data.familyTable.value2) {
                state.unitary_value = "28,30";
                state.unitary_value2 = "24,90";
              }
              else {
                state.unitary_value = "31,50";
                state.unitary_value2 = "31,50";
              }


            }
            if ( localStorage.getItem("type_plan") == 'digital' ) { // Plano DIGITAL
              this.state.value_plan  = "21,90";
              if (result.data.familyTable.value2) {
                state.unitary_value = "21,90";
                state.unitary_value2 = "21,90";
              }
              else {
                state.unitary_value = "21,90";
                state.unitary_value2 = "21,90";
              }
            }
            state.objectPlan.value = this.state.value_plan;
            state.value_total = this.state.value_plan;
            state.objectPlan.familyTable.value2 = state.unitary_value;
            state.objectPlan.familyTable.value3 = state.unitary_value2;        
        } else { // voltar a partir daqui depois da promoção de novembro

          if (result.data.familyTable.value2) {
            state.unitary_value = result.data.familyTable.value2;
            state.unitary_value2 = result.data.familyTable.value3;
          }
          else {
            state.unitary_value = result.data.value;
            state.unitary_value2 = result.data.value;
          }
        }    


      state.payment_plan = localStorage.getItem("payment_plan");
      state.type_plan = localStorage.getItem("type_plan");
      this.setState(state);
    })
    .catch(function (erro) {
      alert(erro);
    });

  }
  */
  /******************* MODAIS **************/
  //modal error
  handleErrorOpen(){
    this.setState({modalError: true});
  }
  handleErrorClose(){
    this.setState({modalError: false});
  }

  //modal sem dependentes adicionados
  handleNoDependentsOpen(){
    this.setState({modalNoDependents: true});
  }
  handleNoDependentsClose(){
    this.setState({modalNoDependents: false});
  }
  //Abre modal de alerta para priorização no cadastro dos beneficiários
  handlePriorizarCadastroOpen(){
    let state = this.state;
    // Para ativar colocar o true
    state.modalPriorizarCadastro = true;
    this.setState(state);
  }

  handlePriorizarCadastroClose(){
    this.setState({modalPriorizarCadastro: false});
  }  
  //Abre modal que define se o cartão master é Hiper-Master
  handleHiperMasterOpen(){
    let state = this.state;
    state.modalHiperMaster = true;
    this.setState(state);
  }
  
  //Fecha modal que define se o cartão master é Hiper-Master

  handleHiperMasterClose(){
    this.setState({hiperMarter:false})
    this.setState({modalHiperMaster: false});
  }  
  //modal dependentes prox etapa resume ou anexo
  handleDependentsNextOpen(){
    this.setState({modalDependentsNext: true});
  }
  handleDependentsNextClose(){
    let state = this.state;
    state.modalDependentsNext = false;
    this.setState(state);
  }
  //modal de sucesso
  handleSuccessOpen(){
    let state = this.state;
    state.modalSuccess = true;
    this.setState(state);
  }
  handleSuccessClose(){
    let state = this.state;
    state.modalSuccess = false;
    this.setState(state);
  }
  //modal de Resumo
  handleResumeOpen(){
    let state = this.state;

    if (this.state.payment_plan == true ) {
           if (document.getElementById("alert_questionUsuarioCpfCard") != null)
               document.getElementById("alert_questionUsuarioCpfCard").style.display="none";

            if (state.habilitaCpfCartao === "") {  
                 if (document.getElementById("alert_questionUsuarioCpfCard") != null)
                     document.getElementById("alert_questionUsuarioCpfCard").style.display="block";
              state.modalResume = false;

            } else {
                  if (state.habilitaCpfCartao === true ) {
                    if (state.financialManager.cpfCard.replace(/[^\d]+/g,"")  === ""  || state.financialManagerError.cpfCard != "" ) {
                      state.financialManagerError.cpfCard = "CPF Inválido!";
                      state.modalResume = false;

                    } else {
                      state.modalResume = true;
                    }        
                  } else {
                      state.financialManager.cpfCard = "";
                      state.modalResume = true;

                  }

            }     
    } else {

      state.modalResume = true;

    }


    this.setState(state);
  }
  handleResumeClose(){
    let state = this.state;
    state.modalResume = false;
    this.setState(state);
  }
  onResumePrint(){
    //window.print();
    this.printRef.handlePrint();
  }

  /******************* FUNÇOES DE VALIDAÇAO **************/

  impededCpf(campo,cpf) {
    let test = false;
    let url = urlBase.loopBack + 'APIS4s/Associados';
    let dataPost = {
        cpf: cpf
    };
    //axios.get(urlBase.loopBack + 'FinancialManagers/CPFInapto?cpf='+cpf)
    axios.post(url,dataPost)        
      .then((response) => {
        console.dir(response)
        let listDependente = [];
          if (response.data.length >= 1) { 

            for (let a = 0; a < response.data.length; a++) { 

                listDependente= response.data[a].dependentes; 
                for (let y = 0; y < listDependente.length; y++) {

                        if (listDependente[y].codigoSituacao == 4 || listDependente[y].codigoSituacao == 18 || listDependente[y].codigoSituacao == 21
                            || listDependente[y].codigoSituacao == 6 || listDependente[y].codigoSituacao == 24 || listDependente[y].codigoSituacao == 5 ) {    
                              test = true;

                        }                                            

                }
              
            }
          }

          if ( test == true ) {
            if (campo == 'fm_cpf') {
              alert('Ops! Por algum motivo o registro deste CPF não foi admitido. Quando isso ocorre é melhor entrar em contato com a Dental Center.');
                //alert('Ops... esse CPF: ('+cpf+') consta em nosso sistema com a situação irregular. Sendo assim, não é possível inclui-lo no plano. Para mais informações, por favor, entre em contato com a Dental Center');
                this.inicilizaFinancialManager();
            }
            if (campo == 'hd_cpf') {
              // alert('Ops... esse CPF: ('+cpf+') consta em nosso sistema com a situação irregular. Para conseguir incluí-lo como TITULAR, por favor, entre em contato com a Dental Center.'); 
              alert('Ops! Por algum motivo o registro deste CPF não foi admitido. Quando isso ocorre é melhor entrar em contato com a Dental Center.');

              this.inicilizaHolder();
            }           
            if (campo == 'dp_cpf') {
              //alert('Ops... esse CPF: ('+cpf+') consta em nosso sistema com a situação irregular. Sendo assim, não é possível incluir no plano. Para mais informações, por favor, entre em contato com a Dental Center');
              alert('Ops! Por algum motivo o registro deste CPF não foi admitido. Quando isso ocorre é melhor entrar em contato com a Dental Center.');

              this.inicilizaDependente();
          } 
          } else {
            this.getDados(campo,cpf);
          }

      })
.catch((error) => {
    let mensagemErro = "Erro desconhecido";

    if (error.response) {
        // O Axios coloca a resposta do servidor em error.response.data
        const data = error.response.data;

        // Tenta encontrar a mensagem em diferentes padrões comuns de APIs
        if (typeof data === 'string') {
            mensagemErro = data;
        } else if (data.error && typeof data.error === 'string') {
            mensagemErro = data.error;
        } else if (data.error && data.error.message) {
            // Padrão comum do LoopBack: { error: { message: "..." } }
            mensagemErro = data.error.message;
        } else if (data.message) {
            mensagemErro = data.message;
        } else {
            // Se ainda for um objeto, transforma em string legível
            mensagemErro = JSON.stringify(data);
        }
    } else if (error.request) {
        mensagemErro = "Servidor indisponível ou erro de rede (Timeout)";
    } else {
        mensagemErro = error.message;
    }

    // Exibe a string final, evitando o [object Object]
    alert("APIS4s/Associados: " + mensagemErro);

    this.setState({ 
        loading: false,
        erroAtivo: true 
    });
});


  }  
  validateCpf(id) {
    let cpf = id.replace(/[^\d]+/g,"");
    let test = true;
    let add = 0, i = 0, rev = 0;
    if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999"){
      test = false;
    }
    else {
      // Valida 1° digito
      for (i=0; i < 9; i ++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11){
          rev = 0;
        }
        if (rev != parseInt(cpf.charAt(9))){
          test = false;
        }
      // Valida 2° digito
      add = 0;
      for (i = 0; i < 10; i ++){
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11){
        rev = 0;
      }
      if (rev != parseInt(cpf.charAt(10))){
        test = false;
      }
    }
    if (test == true){
      return true;
    }else {
      return false;
    }

  }
  validateEmail(id) {
    let email = id,
        emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if(!emailReg.test(email) || email == ""){
      return false;
    }else{
      return true;
    }
  }
  validateLetters(id){
    let name = id;
    let nameReg = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/;
    if (name == "") {
      return false;
    }else{
      if(!nameReg.test(name)){
        return false;
      }else{
        return true;
      }
    }
  }
  validateDate(id){
    let dateReg  = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;
    if (dateReg.test(id))
     return true;
    else
      return false;
  }
  validateSus(id){
    let tam = id.length;
    if (tam == 15 || tam == 0) {
      return true;
    }else{
      return false;
    }
  }
  validateTel(id){
    let tel = id.replace(/[^0-9]/g,'').length;
    if (tel == 10 || tel == 0) {
      return true;
    }else{
      return false;
    }
  }
  validateCell(id){
    let tel = id.replace(/[^0-9]/g,'').length;
    if (tel == 11) {
      return true;
    }else{
      return false;
    }
  }
  validateNumber(id){
    let number = id,
        num = /^[0-9/ ]+$/;

    if(number == "" || !num.test(number)){
      return false;
    }else{
      return true;
    }
  }
  validateCep(id){
    let cep = id.replace(/[^0-9]/g,'').length;
    if (cep == 8)
     return true;
    else
      return false;
  }
  validateDateCpfDependent(id){
    //verifica a idade do dependente, para definir a obrigatoriedade do cpf
    let part = id.split('/'),
        dateIs = new Date(),//data atual
        day = dateIs.getDate(),
        year = dateIs.getFullYear(),
        month = dateIs.getMonth() + 1;

    //let date = (part[2]+"/"+part[1]+"/"+part[0]);
    let age = '';
    //let dateReg  = /^((((0?[1-9]|[12]\d|3[01])[\.\-\/](0?[13578]|1[02])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|[12]\d|30)[\.\-\/](0?[13456789]|1[012])[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|((0?[1-9]|1\d|2[0-8])[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?\d{2}))|(29[\.\-\/]0?2[\.\-\/]((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00)))|(((0[1-9]|[12]\d|3[01])(0[13578]|1[02])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|[12]\d|30)(0[13456789]|1[012])((1[6-9]|[2-9]\d)?\d{2}))|((0[1-9]|1\d|2[0-8])02((1[6-9]|[2-9]\d)?\d{2}))|(2902((1[6-9]|[2-9]\d)?(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00)|00))))$/;

    age = year - part[2];
    if (month < parseInt(part[1]) || month == parseInt(part[1]) && day < parseInt(part[0])) {
      age--;
    }
    //verificacao da idade para obrigatoriedade do cpf
    return age;
  }
  validateflagOfCard(number){//função que exibe a bandeira do cartão
    let numberCard = number.replace(/\D/g, '');
    if(MoipValidator.cardType(numberCard).brand == "MASTERCARD"){//return [Object]MASTERCARD
      return "MASTERCARD";
    }
    else if(MoipValidator.cardType(numberCard).brand == "VISA"){//return [Object]VISA
      return "VISA";
    }
    else if(MoipValidator.cardType(numberCard).brand == "HIPERCARD"){//return [Object]HIPERCARD
      return "HIPERCARD";
    }
    else if(MoipValidator.cardType(numberCard).brand == "ELO"){//return [Object]ELO
      return "ELO";
    }
    else{
      return false;
    }
  }
  validateCardNumber(id){//valida o numero do cartão
    return MoipValidator.isValidNumber(id.replace(/\D/g, ''));//valida o numero do cartão
  }
  validateExpirationDateCard(id){// valida a data de validade do cartão
    let dateExpiration = id.split('/');
    if(parseInt(dateExpiration[1]).toString().length != 4 )
      return false;
    else
      if(MoipValidator.isExpiryDateValid(dateExpiration[0], dateExpiration[1]))//valida da data de validade do cartão
        return true;
      else
        return false;
  }
validateForm(type) {
  const validations = this.state[type + "Validation"] || {};
  const requiredFields = this.state.requiredField[type] || {};
  const errors = this.state[type + "Error"] || {};

  let invalidCount = 0;

  // Itera de forma segura pelas chaves do objeto de validação
  Object.keys(validations).forEach((prop) => {
    const isValid = validations[prop];
    const isRequired = requiredFields[prop] === "REQUIRED";

    // Caso 1: O campo não foi tocado/validado ainda (null)
    if (isValid === null) {
      if (isRequired) {
        invalidCount++;
        // Evita sobrescrever erros existentes
        if (!errors[prop]) {
          this.setError(type, prop);
        }
      }
    } 
    // Caso 2: O campo foi validado e explicitamente marcado como inválido (false)
    else if (isValid === false) {
      invalidCount++;
    }
  });

  return invalidCount === 0;
}
  /********************OUTRAS FUNÇÔES *******************************/
  // Seta os valores dos campos do Responsável Financeiro no State
updateValueTotal() {
    let state = this.state;
    let totalVidas = state.dependentsList.length; // Quantidade total de usuários (Titular + Dependentes)
    let somaTotalComDesconto = 0;
    let somaTotalSemDesconto = 0;

    // Recalcula o valor unitário para cada participante com base no total de vidas e no plano escolhido
    state.dependentsList.forEach((item, index) => {
      let planoDoItem = state.planoSelecionado;
      if (index > 0 && item.plansId && state.planos_correlacionados) {
        let encontrado = state.planos_correlacionados.find(
          p => (p.id === item.plansId || p.codeS4 === item.plansId)
        );
        if (encontrado) planoDoItem = encontrado;
      }

      let tabela = planoDoItem.tabelaPreco || planoDoItem.familyTable || {};
      
      // Valor base individual sem desconto (sempre value2)
      let valorBaseStr = tabela.value2 || planoDoItem.value;
      let valorBaseNum = parseFloat(String(valorBaseStr).replace(',', '.')) || 0;

      // Valor com desconto da tabela família baseado na quantidade de vidas
      let valorComDescontoStr = tabela.value2;
      if (totalVidas === 1) {
        valorComDescontoStr = tabela.value2 || planoDoItem.value;
      } else if (totalVidas === 2) {
        valorComDescontoStr = tabela.value3 || tabela.value2 || planoDoItem.value;
      } else { // 3 ou mais
        valorComDescontoStr = tabela.value4 || tabela.value3 || tabela.value2 || planoDoItem.value;
      }

      // Salva o valor individual com desconto para exibir na tabela
      item.valuePlan = valorComDescontoStr;

      let valorComDescontoNum = parseFloat(String(valorComDescontoStr).replace(',', '.')) || 0;

      somaTotalSemDesconto += valorBaseNum;
      somaTotalComDesconto += valorComDescontoNum;
    });

    // Calcula o desconto total (diferença entre o preço cheio base e o preço com desconto da tabela família)
    let descontoTotalNum = somaTotalSemDesconto - somaTotalComDesconto;
    if (descontoTotalNum < 0) descontoTotalNum = 0;

    state.totalNoDescont = somaTotalSemDesconto.toFixed(2).replace('.', ',');
    state.valueDescontTotal = descontoTotalNum.toFixed(2).replace('.', ',');
    state.value_total = somaTotalComDesconto.toFixed(2).replace('.', ',');

    this.setState(state);
  }
  /*
  updateValueTotal() {
    let state = this.state;
    state.value_total = state.planoSelecionado.tabelaPreco.value2;
    state.totalNoDescont = (parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) * this.state.dependentsList.length);
    state.totalNoDescont = state.totalNoDescont.toFixed(2).replace('.', ',');

    if (this.state.dependentsList.length == 1) {
      state.value_total = state.planoSelecionado.tabelaPreco.value2;
      state.valueIndividualPlan = state.planoSelecionado.tabelaPreco.value2;
      state.valueDescontIndividual = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) - parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.'));
      state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
      state.valueDescontTotal = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) - parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.'));
      state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',');
    }
    else if (this.state.dependentsList.length == 2) {
      if (state.planoSelecionado.tabelaPreco.value3) {
        state.value_total = parseFloat(state.planoSelecionado.tabelaPreco.value3.replace(',','.')) * 2;
        state.value_total = state.value_total.toFixed(2).replace('.', ',');
        state.valueIndividualPlan = state.planoSelecionado.tabelaPreco.value3;
        state.valueDescontIndividual = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) - parseFloat(state.valueIndividualPlan.replace(',','.'));
        state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
        state.valueDescontTotal =  (parseFloat(state.valueDescontIndividual.replace(',','.')) *2);
        state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',');
      }
      else {
        state.value_total = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) * 2;
        state.value_total = state.value_total.toFixed(2).replace('.', ',');
        state.valueIndividualPlan = state.planoSelecionado.tabelaPreco.value2;
        state.valueDescontIndividual = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) - parseFloat(state.valueIndividualPlan.replace(',','.'));
        state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
        state.valueDescontTotal =  (parseFloat(state.valueDescontIndividual.replace(',','.')) *2);
        state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',');
      }
    }
    else if (this.state.dependentsList.length >= 3) {
      if (state.planoSelecionado.tabelaPreco.value4) {
        state.value_total = parseFloat(state.planoSelecionado.tabelaPreco.value4.replace(',','.')) * this.state.dependentsList.length;
        state.value_total = state.value_total.toFixed(2).replace('.', ',');
        state.valueIndividualPlan = state.planoSelecionado.tabelaPreco.value4;
        state.valueDescontIndividual = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) - parseFloat(state.valueIndividualPlan.replace(',','.'));
        state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
        state.valueDescontTotal =  (parseFloat(state.valueDescontIndividual.replace(',','.')) *this.state.dependentsList.length);
        state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',');

      }
      else {
        state.value_total = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) * this.state.dependentsList.length;
        state.value_total = state.value_total.toFixed(2).replace('.', ',');
        state.valueIndividualPlan = state.planoSelecionado.tabelaPreco.value2;
        state.valueDescontIndividual = parseFloat(state.planoSelecionado.tabelaPreco.value2.replace(',','.')) - parseFloat(state.valueIndividualPlan.replace(',','.'));
        state.valueDescontIndividual = state.valueDescontIndividual.toFixed(2).replace('.', ',');
        state.valueDescontTotal =  (parseFloat(state.valueDescontIndividual.replace(',','.')) *this.state.dependentsList.length);
        state.valueDescontTotal = state.valueDescontTotal.toFixed(2).replace('.', ',');
      }
    }
    this.setState(state);
  }
  */
  // Agrupa os dependentes/titular por nome do plano para exibir corretamente no resumo
getResumoPlanosAgrupados() {
    let grupos = {};
    
    this.state.dependentsList.forEach((item, index) => {
      // Descobre o plano correspondente de cada item
      let planoDoItem = this.state.planoSelecionado;
      if (index > 0 && item.plansId && this.state.planos_correlacionados) {
        let encontrado = this.state.planos_correlacionados.find(
          p => (p.id === item.plansId || p.codeS4 === item.plansId)
        );
        if (encontrado) planoDoItem = encontrado;
      }

      let nomePlano = item.planName || planoDoItem.tradeName || planoDoItem.name || "Plano";
      let valorComDesconto = item.valuePlan || "0,00";
      
      // Pega o valor original/base SEM desconto (tabela.value2 ou planoDoItem.value)
      let tabela = planoDoItem.tabelaPreco || planoDoItem.familyTable || {};
      let valorSemDesconto = tabela.value2 || planoDoItem.value || "0,00";

      let chave = `${nomePlano}_${valorComDesconto}_${valorSemDesconto}`;
      
      if (!grupos[chave]) {
        grupos[chave] = {
          nome: nomePlano,
          quantidade: 0,
          valorUnitario: valorComDesconto,
          valorSemDesconto: valorSemDesconto
        };
      }
      grupos[chave].quantidade += 1;
    });

    return Object.values(grupos);
  }

  fileToBase64(typeDoc) {
    /*
    * @type pode ser: "cpf", "rg", "rg2", "address", cardCredit
    */
    let reader = new FileReader();
    let file = document.getElementById('doc_'+typeDoc).files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;
    if (ext == 'pdf')
      state.imagesDocs[typeDoc] = "pdf";
    else
      state.imagesDocs[typeDoc] = window.URL.createObjectURL(file);
    this.setState(state);

    reader.onloadend = function() {
      document.getElementById('imagem_'+typeDoc).value = reader.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }
  //focusId(focus){
    //console.log(focus);
  //  document.getElementById('dp_firstName').focus();
  //}
 
  nextAuxDependents(){
    this.handleNoDependentsClose();
    this.handleDependentsNextOpen();
  }
  nextAuxDependents2(){
    //console.log('teste');
    this.handleDependentsNextClose();
    this.stageForm(3);
  }
  backPlans() {
    //volta pra escolha de planos
    if (this.props.onClickFn != null)
      this.props.onClickFn();
  }

  // Responsavel financeiro participa como titular? SIM/NAO
formHolderOn() {
  let state = this.state;
  if (state.financialManager.cpf === "") {
    alert('Favor, preencher campo CPF do Responsável Financeiro antes de definí-lo como TITULAR do plano');
  } else {
    if (!state.titular.habilita) {
      alert('Atenção! O CPF do responsável financeiro consta em nosso sistema como (' + state.titular.situacao + '). Para conseguir incluí-lo como TITULAR, por favor, entre em contato com a Dental Center');
    } else {          
      this.setField("others.formHolder", "", true, false); // NÂO exibe form do titular separado
      this.clearField("holder", "");
      this.clearField("holderError", "");
      this.clearField("holderValidation", null);
    }      
  }  
}

formHolderOff() {
  this.clearField("holder", "");
  this.clearField("holderError", "");
  this.clearField("holderValidation", null);
  this.setField("others.formHolder", "", true, true); // Exibe form do titular
  this.handlePriorizarCadastroOpen();
}  
  /*
  formHolderOn(){
    let state = this.state;

    if(state.financialManager.cpf === ""){
      alert('Favor, preencher campo CPF do Responsável Financeiro antes de definí-lo com TITULAR do plano');
    } else {
        if (!state.titular.habilita) {
          alert('Atenção! O CPF do responsável financeiro consta em nosso sistema como ('+state.titular.situacao+'). Para conseguir incluí-lo como TITULAR, por favor, entre em contato com a Dental Center' );
        } else {          
          this.setField("others.formHolder", "", true, false);
          //limpa campos holder
          this.clearField("holder", "");
        }      

    }  
    //limpa campos holder
  }
  

  formHolderOff(){
    this.clearField("holder", "");
    this.setField("others.formHolder", "", true, true);
    this.handlePriorizarCadastroOpen();

  }
  */    
  // Voltar e Avançar FORMULARIO
  stageForm(position){
    let state = this.state;
    state.btnFinishDisabled = false;
    state.phasesForm = position;
    this.setState(state);
  }
  //2 etapa do fomulario
// 2 etapa do formulario
formSteps2() {
  var matServidor = this.state.financialManager.matServidor;
  var isServer = this.state.isServidor;
  var codOrgao = this.state.financialManager.codOrgao;

  // Validação Condicional do Servidor
// Validação Condicional do Servidor
  if (isServer) {
    if (!matServidor || matServidor.trim() === '') {
      this.setState(prevState => ({
        financialManagerError: {
          ...prevState.financialManagerError,
          matServidor: 'A Matrícula do Servidor é obrigatória.'
        }
      }));
      
      const elMatricula = document.getElementById('matricula-servidor');
      if (elMatricula) {
        elMatricula.focus();
      }
      return;
    }      
    if (!codOrgao || codOrgao.trim() === '') {
      this.setState(prevState => ({
        financialManagerError: {
          ...prevState.financialManagerError,
          codOrgao: 'Selecione um órgão público.'
        }
      }));

      const elEmpresa = document.getElementById('busca-empresa');
      if (elEmpresa) {
        elEmpresa.focus();
      }
      return;
    } 
  }

  this.state.isEditDependentName = false;
  this.state.isEditDependentDateOfBirth = false;
  this.state.isEditDependentMotherName = false;

  // Executa as validações
  const isFmValid = this.validateForm("financialManager");
  const isOthersValid = this.validateForm("others");
  let isHolderValid = true;

  // Se o formulário do titular estiver ativo/exibido (quando formHolder == true)
  if (this.state.others.formHolder === true) {
    isHolderValid = this.validateForm("holder");
  }

  // Verifica se TODAS as partes necessárias são válidas
  if (isFmValid && isOthersValid && isHolderValid) {
    this.addHolderListDependent(); // Adiciona o titular na lista
    this.stageForm(2);             // Avança para a etapa 2
  } else {
    this.handleErrorOpen();        // Exibe modal de campos inválidos
  }

  this.updateValueTotal();
}  
  /*
  formSteps2(){
    var matServidor = this.state.financialManager.matServidor;
    var isServer = this.state.isServidor;
    var codOrgao = this.state.financialManager.codOrgao;

  // Validação Condicional 
  if (isServer) {
      if (!matServidor || matServidor.trim() === '') {
        this.setState(prevState => ({
          financialManagerError: {
            ...prevState.financialManagerError,
            matServidor: 'A Matrícula do Servidor é obrigatória.'
          }
        }));
        document.getElementById('matricula-servidor').focus();
        return; // Para a execução
      }      
      if (!codOrgao || codOrgao.trim() === '') {
        this.setState(prevState => ({
          financialManagerError: {
            ...prevState.financialManagerError,
            codOrgao: 'Selecione um órgão público.'
          }
        }));
        document.getElementById('busca-empresa').focus();
        return; // Para a execução
      } 
  }  
  // Paulo
    alert(this.validateForm("holder"));
    alert(this.state.holder.cpf)
    this.state.isEditDependentName  = false;
    this.state.isEditDependentDateOfBirth = false;
    this.state.isEditDependentMotherName = false;
    if(this.validateForm("financialManager") == true && this.validateForm("others") == true){
      if(this.state.others.formHolder == true){ 
        if(this.validateForm("holder") == true){
          alert("entrei aqui")
          this.addHolderListDependent();//add titular na lista de dependent
          this.stageForm(2);
        }else {
          alert("entrei aqui 2")
          this.handleErrorOpen();//modal campos invalidos
        }
         
      }else{
        this.addHolderListDependent();//add titular na lista de dependent
        this.stageForm(2);
      }
    }else{
      if(this.state.others.formHolder == true)//apenas para disparar erros caso os campos holder estejam exibidos
        this.validateForm("holder");
      this.handleErrorOpen();//modal campos invalidos
    }
    this.updateValueTotal();
  }
  */
  //3 etapa do fomulario
  formSteps3(){
    if(this.state.dependentsList.length == 1){
      this.handleNoDependentsOpen();//modal prosseguir sem adiçao de dependentes
    }else{
      this.handleDependentsNextOpen();//modal escolha resumo ou anexo de docs
    }
  }
  //4 etapa do fomulario
  formSteps4(){

   if ( this.state.isServidor &&  (document.getElementById('imagem_autorizacaoAverbacao').value === '')) {
      alert("É necessário anexar a autorização de averbação para servidor público")
      return;
    }
    
    if(this.state.payment_plan == "false" || this.state.isServidor)//boleto
      this.dateValiditySalesman();
    this.stageForm(4);
  }

   // PROBLEMA DO CAMPO DATA DE VALIDADE
  beforeSubmitForm () { 

    this.handleResumeClose();
    let state = this.state;
    state.btnFinishDisabled = true;
    this.setState(state);
    //antes de enviar
    //busca o vendedor.
    if (localStorage.getItem('dental_y') == 'SALESMAN') {
      let filter = 'Salesmans?filter={"where":{"userId":"' + localStorage.getItem('dental_u') +'"}}';
       
      axios.get(urlBase.loopBack + filter)
      .then((response) => {
        if(this.state.payment_plan == "true" && !this.state.isServidor){
          if(this.validateForm("paymentCreditCard") == true ){
            this.onSubmitForm(response.data[0].id);
          }else{
            let state = this.state;
            state.btnFinishDisabled = false;
            this.setState(state);

            this.handleErrorOpen();//modal de alerta para campos vazios ou dados invalidos!
          }
        }else{

          this.onSubmitForm(response.data[0].id);
        }
      })
      .catch((error) => {
        let state = this.state;
        state.btnFinishDisabled = false;
        this.setState(state);
        alert('Erro ao buscar o vendedor : ' + error);
      });
    }
    else
      if(this.state.payment_plan == "true"){
        if(this.validateForm("paymentCreditCard") == true ){
          this.onSubmitForm(localStorage.getItem('dental_v_i'));
        }else{
          let state = this.state;
          state.btnFinishDisabled = false;
          this.setState(state);
          this.handleErrorOpen();//modal de alerta para campos vazios ou dados invalidos!
        }
      }else{
        // RETIRAR COMENTÁRIO
       this.onSubmitForm(localStorage.getItem('dental_v_i'));
      }

  }
// Função auxiliar para evitar repetição de código (DRY)
  formatToISO  (dateStr) {
    if (!dateStr || typeof dateStr !== 'string') return "";
    
    const parts = dateStr.split('/');
    
    // Verifica se temos os 3 componentes (dia, mês e ano)
    if (parts.length !== 3) {
        console.error("Data em formato inválido:", dateStr);
        return dateStr; // Retorna o original ou trate como erro
    }
    
    const [day, month, year] = parts;
    return `${year}-${month}-${day}`;
  }
  // envia os dados do formulário
  onSubmitForm(idSalesman) {


    let state = this.state;

    this.updateValueTotal();//atualiza valor do plano.

    this.state.btnFinishSales = "no-active";
    this.setState(state);

    /* REMOVER
    for (let i = 0; i < this.state.dependentsList.length; i++) {
      state.dependentsList[i].valuePlan = this.state.valueIndividualPlan;
    }
    */

    state.financialManager.dateOfBirth = this.formatToISO(this.state.financialManager.dateOfBirth);
    state.holder.dateOfBirth = this.formatToISO(this.state.holder.dateOfBirth);
    
    this.setState(state);

    let dataSubmit = {
      idSalesman: idSalesman,
      plansId: localStorage.getItem("dental_plan"),
      financialManagerId: this.state.editFinancialManagerId,
      imagesDocId: this.state.editImagesDocId,
      salesId: this.state.editSalesId,
      salesFmChanelConfirm: this.state.confirmationForm,
      planServer : this.state.isServidor,
      paymentType : (this.state.isServidor ? "server" : 
        (localStorage.getItem('payment_plan') != null &&
        localStorage.getItem('payment_plan') == 'true' ? "card" : "ticket")
      ),

      financialManager: this.state.financialManager,
      dependents: this.state.dependentsList,
      imagesDocs: {
        cnh: document.getElementById('imagem_cnh').value,
        cpf: document.getElementById('imagem_cpf').value,
        autorizacaoAverbacao: document.getElementById('imagem_autorizacaoAverbacao').value,
        rg: document.getElementById('imagem_rg').value,
        rg2: document.getElementById('imagem_rg2').value,
        address: document.getElementById('imagem_address').value,
        credtFrontal: document.getElementById('imagem_cardCredit').value,
        physicalContract: document.getElementById('imagem_physicalContract').value,
        adtive: document.getElementById('imagem_adtive').value,
        declarationPortability: document.getElementById('imagem_declarationPortability').value,
        others: document.getElementById('imagem_others').value
      }
    };
    
    dataSubmit.financialManager.responsibility = this.state.value_total;

    dataSubmit.financialManager.dateSignatureContract = this.formatToISO(this.state.others.dateSignatureContract);
    // Portabilidade
    dataSubmit.financialManager.portability = this.state.portability;

    // Quando for pagamento no cartão
    if (localStorage.getItem('payment_plan') != null &&
        localStorage.getItem('payment_plan') == 'true') {
      dataSubmit.financialManager.cardNumber = this.state.paymentCreditCard.cardCreditNumber;
      dataSubmit.financialManager.cardValidity = this.state.paymentCreditCard.cardExpiring;
      dataSubmit.financialManager.cardHolderName = this.state.paymentCreditCard.cardHolderName;
      dataSubmit.financialManager.cardFlag = this.state.paymentCreditCard.flagCardPayment;
    }

    if (this.state.isServidor) {
      dataSubmit.financialManager.matServidor = this.state.financialManager.matServidor;
      dataSubmit.financialManager.contractNumberS4 = this.state.financialManager.codOrgao;
      dataSubmit.financialManager.codOrgao = this.state.financialManager.codOrgao;
   
    } else {
      dataSubmit.financialManager.matServidor = 0;
      dataSubmit.financialManager.codOrgao = "";      
    }
    dataSubmit.financialManager.district = this.state.IdBairro;
    /*   temporário */
    axios.post(urlBase.loopBack + 'FinancialManagers/saveProposal', dataSubmit)
    .then((response) => {
      // Solicitado mudança no fluxo de email de confirmação: Se for plano de servidor e se vendedor for Daniel Muniz não enviar email
      if (this.state.isServidor && idSalesman === "69a6e247ac05a458990deabc") {
          let state = this.state;        
          this.handleSuccessOpen();
          this.state.btnFinishSales = 'enable';
          this.setState(state);   
      }        
      else {
          // Envia email
          let dataSend = {
            id: response.data.sales.id
          };
          axios.post(urlBase.loopBack + 'Sales/SendEmailProposalCreate', dataSend)
          .then(() => {
            let state = this.state;
            // state.btnFinishDisabled = false;          
            //modal de SUCESSO!
            this.handleSuccessOpen();
            this.state.btnFinishSales = 'enable';
            this.setState(state);
          })
          .catch(function (error) {
            let state = this.state;
            // state.btnFinishDisabled = false;
            this.state.btnFinishSales = 'enable';        
            this.setState(state);
            alert(error);
          }.bind(this));        
      } 

      
    })
    .catch(() => {
      let state = this.state;
      //state.btnFinishDisabled = false;
      this.state.btnFinishSales = 'enable';        
      this.setState(state);
      alert('Erro ao salvar a proposta');
    });
    this.setState(state);

  }

  confirmationForm (e, value) {
    let state = this.state;
    state.confirmationForm = value;
    if (value == 'EMAIL')
      state.requiredField.financialManager.email = 'REQUIRED';
    else
      state.requiredField.financialManager.email = '';
    this.setState(state);
  }

  portabilityForm (e, value) {
    let state = this.state;
    state.portability = value;
    this.setState(state);
  }

  handleInputFocus(e) {
    this.setState({ focus: e.target.name });
  }

  handleInputChange(e) {
    const { name, value } = e.target;

    if (e.target.name == 'name') {
      this.inputToUpperCase(e.target.id);
    }

    //this.setState({ [name]: value });
    
    switch (name) {
      case 'number':
        this.state.paymentCreditCard.cardCreditNumber = value;

        if (this.validateCardNumber(e.target.value) == false) {
          let error = "Número inválido";
          if (e.target.value.replace(/\D/g, '') == "")
            error = "Informe o número do cartão";
          this.setField("paymentCreditCard.cardCreditNumber", error, false, e.target.value);
          this.setField("paymentCreditCard.flagCardPayment", "", "", "");//apaga imagem da bandeira
          this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");//apaga 4 ultimos digitos do cartao
        } else {
          let flagValid = this.validateflagOfCard(e.target.value);
          if (flagValid == false) {
            this.setField("paymentCreditCard.cardCreditNumber", "Bandeira não aceita", true, e.target.value);
            this.setField("paymentCreditCard.flagCardPayment", "", "", "");//apaga imagem da bandeira
            this.setField("paymentCreditCard.cardNumberFourFinal", "", "", "");//apaga 4 ultimos digitos do cartao
          } else {
            this.setField("paymentCreditCard.cardCreditNumber", null, true, e.target.value);
            this.setField("paymentCreditCard.flagCardPayment", "", true, flagValid);//bandeira
            let num = e.target.value.replace(/\D/g, '');
            num = num.toString().substr(num.toString().length - 4);
            this.setField("paymentCreditCard.cardNumberFourFinal", "", true, num);//4 ultimos digitos
            this.dateValidityCredtCard(null);
          }
        }


        break;
      case 'cardExpiring':
        this.state.paymentCreditCard.cardExpiring = value;
        break;  
      case 'pay_cardHolderName':
        this.state.paymentCreditCard.cardHolderName = value;
        break;    
    }

    this.setState(this.state)


  }


  render() {
 
    return (
      
      <div>     
        <Form id="form">
          <input id="imagem_cpf" type="hidden"/>
          <input id="imagem_cnh" type="hidden"/>
          <input id="imagem_rg" type="hidden"/>
          <input id="imagem_rg2" type="hidden"/>
          <input id="imagem_address" type="hidden"/>
          <input id="imagem_cardCredit" type="hidden"/>
          <input id="imagem_physicalContract" type="hidden"/>
          <input id="imagem_adtive" type="hidden"/>
          <input id="imagem_declarationPortability" type="hidden"/>
          <input id="imagem_autorizacaoAverbacao" type="hidden"/>
          <input id="imagem_others" type="hidden"/>

          
          <div>
            <p className="title_form">CADASTRO DE PLANO INDIVIDUAL OU FAMILIAR</p>
          {/************************* PRIMEIRA etapa do formulário *************************/}
            {this.state.phasesForm == 1 ?(
              <div>

                <Container>
                  <Row>
                    <Col className="text_center">
                      <Stepper activeStep={this.state.phasesForm - 1} >
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DADOS PESSOAIS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DEPENDENTES</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DOCUMENTOS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >FINANCEIRO</StepLabel> */}
                        </Step>
                      </Stepper>
                    </Col>
                  </Row>
                </Container>      


                <Container className="form_container_panel2">
                  <Container className="form_container_internal_panel">

                    <p className='alert-info'>Atenção os campos marcados com * são obrigatórios</p> 
                    {
                      this.state.isServidor ? (
                        <p className='alert-info'>Atenção vendedor, verificar margem do consignado antes de avançar na inclusão da proposta do servidor </p> 
                      ): ''
                    }

                    {/***************** Responsável Financeiro ***************/}   
                    <p className="form_p">Responsável Financeiro</p>
                    {
                      this.state.confirmationForm == null ? ('') : (
                          
                    <div>
                      { 
                        this.state.isServidor  ? (                     
                          <fieldset style={Styles.fieldset}>
                              <legend style={Styles.legenda_filedset}>
                                SELECIONE O ÓRGÃO PÚBLICO
                              </legend>
                              <div>
                                {/* Input de texto conectado ao datalist */}
                                <input
                                  id="busca-empresa"
                                  list="lista-empresas-datalist"
                                  value={this.state.nomeEmpresa || ''} 
                                  onChange={this.lidarComMudancaCampos.bind(this)}
                                  placeholder="Digite o nome da empresa para buscar..."
                                  style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px'
                                  }}
                                />

                                {/* O container de sugestões mostra apenas o nome */}
                                <datalist id="lista-empresas-datalist">
                                    {this.state.empresasPublicas && 
                                      [...this.state.empresasPublicas]
                                        .sort((a, b) => (a.nome_fantasia || "").localeCompare(b.nome_fantasia || ""))
                                        .map((empresa) => (
                                          <option 
                                            key={empresa.codigo} 
                                            value={empresa.nome_fantasia} // O navegador mostrará apenas o nome
                                            data-codigo={empresa.codigo}  // O código fica escondido aqui
                                          />
                                        ))
                                    }
                                </datalist>
                                    {/* Mensagem de erro dinâmica abaixo do campo */}
                                      {this.state.financialManagerError.codOrgao && (
                                        <div style={{ 
                                          color: '#dc3545', 
                                          fontSize: '12px', 
                                          marginTop: '5px', 
                                          fontWeight: '500' 
                                        }}>
                                          {this.state.financialManagerError.codOrgao}
                                        </div> 
                                      )} 
                                {/* Feedback visual interno (apenas para você confirmar que o ID foi capturado) */}
                                {this.state.financialManager.codOrgao && (
                                  <small style={{ color: 'green', display: 'block', marginTop: '5px' }}>
                                    Empresa: {this.state.financialManager.codOrgao} - {this.state.nomeEmpresa}
                                  </small>
                                )}
                              </div>
                              {/* 2. NOVO CAMPO: MATRÍCULA DO SERVIDOR */}
                                <div style={{ marginBottom: '15px' }}>
                                  <label htmlFor="matricula-servidor" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                    Matrícula do Servidor:
                                  </label>
                                  <input
                                    id="matricula-servidor"
                                    type="tel" // ou "number", dependendo do padrão de vocês
                                    maxLength="15"
                                    value={this.state.financialManager.matServidor || ''} 
                                    onChange={this.lidarComMudancaCampos.bind(this)}
                                    onKeyPress={(e) => {
                                        // Permite apenas números (0-9)
                                        if (!/[0-9]/.test(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}                                    
                                    placeholder="Digite a matrícula do servidor..."
                                    style={{
                                      width: '100%',
                                      padding: '10px',
                                      borderRadius: '4px',
                                      border: '1px solid #ccc',
                                      fontSize: '14px'
                                    }}
                                  />
                                    {/* Mensagem de erro dinâmica abaixo do campo */}
                                      {this.state.financialManagerError.matServidor && (
                                        <div style={{ 
                                          color: '#dc3545', 
                                          fontSize: '12px', 
                                          marginTop: '5px', 
                                          fontWeight: '500' 
                                        }}>
                                          {this.state.financialManagerError.matServidor}
                                        </div> 
                                      )}                                 
                                </div>                            
                          </fieldset>  
                         ) : ('') 
                      }                       
                        <fieldset style={Styles.fieldset}>
                        <legend style={Styles.legenda_filedset}>
                            FORMA DE CONFIRMAÇÃO
                        </legend>
                          <div>
                              <RadioButtonGroup
                                name="confirmation"
                                valueSelected='EMAIL'
                                onChange={this.confirmationForm.bind(this)}
                              >
                                <RadioButton
                                  value="EMAIL"
                                  label="Email"
                                  aria-label='Email'                              
                                  //disabled={true}
                                />
                              </RadioButtonGroup>

                          </div>  
                        </fieldset>    
                        <fieldset style={Styles.fieldset}>
                              <legend style={Styles.legenda_filedset}>
                                  PORTABILIDADE
                              </legend>

                                  <div>
                                    <p className="form_p_title">Portabilidade?</p>
                                    {
                                      this.state.portability == true ? (
                                        <div>
                                          <div style={{ height: '20px' }}></div>
                                          <Button className="form_extra_s_true" onClick={this.portabilityOn.bind(this)}>SIM</Button>{''}
                                          <Button className="form_extra_n" onClick={this.portabilityOff.bind(this)}>NÃO</Button>
                                        </div>
                                      ) : (
                                        <div>
                                          <div style={{ height: '20px' }}></div>
                                          <Button className="form_extra_s" onClick={this.portabilityOn.bind(this)}>SIM</Button>{''}
                                          <Button className="form_extra_n_false" onClick={this.portabilityOff.bind(this)}>NÃO</Button>
                                        </div>
                                      )
                                    }
                                  </div>

                        </fieldset>                
                        <fieldset style={Styles.fieldset}>
                              <legend style={Styles.legenda_filedset}>
                                  DADOS PESSOAIS
                              </legend>
                            <Row>
                              <Col xs="12" sm="12" md="5" lg="2" style={{height:80}}>
                                  <TextField
                                    underlineStyle={{ display: 'none' }}
                                    placeholder="CPF *"
                                    className="input_style form-control"
                                    errorText={this.state.financialManagerError.cpf}
                                  >
                                    <InputMask
                                      id="fm_cpf"
                                      mask="999.999.999-99"
                                      maskChar=" "
                                      type="tel"
                                      name="fm_cpf"
                                      placeholder="CPF *"
                                      aria-label='Cpf'                              
                                      value={this.state.financialManager.cpf}
                                      onBlur={this.validaCPFOnblur.bind(this)}
                                      onChange={this.handleChange.bind(this)}
                                      //onBlur={this.situacaoResponsavelFinanceiro.bind(this,'fm_cpf')}
                                    />
                                  </TextField>
                                  <div id="loading_fm_cpf" className="spin_finder">
                                    <i style={{marginRight: 5}}className="fa fa-spinner fa-spin">{""}</i>
                                    Vefificando CPF
                                  </div>

                              </Col>                        
                              <Col xs="12" sm="12" md="7" lg="7" style={{height:80}}>

                                    {    this.state.isEditFinancialManagerName == false ? ( 
                                          <TextField
                                          placeholder="*NOME COMPLETO"
                                          // floatingLabelText="NOME COMPLETO *"
                                          underlineStyle={{ display: 'none' }}
                                          name="fm_firstName"
                                          aria-label='Nome'                                                                  
                                          id="fm_firstName"
                                          className="input_style form-control"       
                                          errorText={this.state.financialManagerError.firstName}
                                          value={this.state.financialManager.firstName}
                                          onChange={this.handleChange.bind(this)}
                                        />                                    
                                        ): (
                                          <TextField
                                          placeholder="*NOME COMPLETO"
                                          // floatingLabelText="NOME COMPLETO *"
                                          underlineStyle={{ display: 'none' }}
                                          name="fm_firstName"
                                          id="fm_firstName"
                                          aria-label='Nome'                                                                  
                                          className="input_style form-control"
                                          disabled
                                          errorText={this.state.financialManagerError.firstName}
                                          value={this.state.financialManager.firstName}
                                          onChange={this.handleChange.bind(this)}
                                        />                                    

                                        ) } 


                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  underlineStyle={{ display: 'none' }}
                                  placeholder="EMAIL *"
                                  name="fm_email"
                                  id="fm_email"
                                  type="email"
                                  aria-label='Email'                                                                  
                                  className="input_style form-control"
                                  errorText={this.state.financialManagerError.email}
                                  value={this.state.financialManager.email}
                                  onChange={this.handleChange.bind(this)}
                                />
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  underlineStyle={{ display: 'none' }}
                                  placeholder="TELEFONE RESIDENCIAL"
                                      className="input_style form-control"
                                  errorText={this.state.financialManagerError.homePhone}
                                >
                                  <InputMask
                                    mask="(99) 9999-9999"
                                    placeholder="TELEFONE RESIDENCIAL"
                                    maskChar=" "
                                    type="tel"
                                    aria-label='Tel residencial'                               
                                    name="fm_homePhone"
                                    value={this.state.financialManager.homePhone}
                                    onChange={this.handleChange.bind(this)}
                                  />
                                </TextField>
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  // hintText="CELULAR 1"
                                  // floatingLabelText="CELULAR 1 *"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder="CELULAR 1 *"
                                  className="input_style form-control"
                                  errorText={this.state.financialManagerError.cellPhone}
                                  >
                                  <InputMask
                                    mask="(99) \9 9999-9999"
                                    maskChar=" "
                                    placeholder="CELULAR 1 *"
                                    type="tel"
                                    name="fm_cellPhone"
                                    aria-label='CELULAR 1'                               
                                    value={this.state.financialManager.cellPhone}
                                    onChange={this.handleChange.bind(this)}
                                  />
                                </TextField>
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  // hintText="CELULAR 2"
                                  // floatingLabelText="CELULAR 2"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder="CELULAR 2"
                                  className="input_style form-control"
                                  errorText={this.state.financialManagerError.cellPhone2}
                                  >
                                  <InputMask
                                    mask="(99) \9 9999-9999"
                                    maskChar=" "
                                    placeholder="CELULAR 2"
                                    type="tel"
                                    aria-label='CELULAR 2'                              
                                    name="fm_cellPhone2"
                                    value={this.state.financialManager.cellPhone2}
                                    onChange={this.handleChange.bind(this)}
                                  />
                                </TextField>
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  // hintText="RG"
                                  // floatingLabelText="RG *"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='RG '
                                  name="fm_rg"
                                  className="input_style form-control"
                                  aria-label='RG'
                                  errorText={this.state.financialManagerError.rg}
                                  value={this.state.financialManager.rg}
                                  onChange={this.handleChange.bind(this)}
                                />
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  // hintText="ORGÃO EXPEDIDOR"
                                  // floatingLabelText="ORGÃO EXPEDIDOR *"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='ORGÃO EXPEDIDOR '
                                  name="fm_rgEmitter"
                                  aria-label='Orgão Expedidor'                            
                                  className="input_style form-control"
                                  errorText={this.state.financialManagerError.rgEmitter}
                                  value={this.state.financialManager.rgEmitter}
                                  onChange={this.handleChange.bind(this)}
                                />
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                              {    this.state.isEditFinancialManagerDateOfBirth  == false ? ( 

                                    <TextField
                                    // hintText="DATA DE NASCIMENTO"
                                    // floatingLabelText="DATA DE NASCIMENTO *"
                                    underlineStyle={{ display: 'none' }}
                                    placeholder='DATA DE NASCIMENTO *'
                                    className="input_style form-control"
                                    errorText={this.state.financialManagerError.dateOfBirth}
                                    >
                                    <InputMask
                                      mask="99/99/9999"
                                      maskChar=" "
                                      type="tel"
                                      aria-label='Data de Nascimento'                                
                                      placeholder='DATA DE NASCIMENTO *'
                                      name="fm_dateOfBirth"
                                      value={this.state.financialManager.dateOfBirth}
                                      onChange={this.handleChange.bind(this)}
                                    />
                                    </TextField>                          

                              ) : (

                                  <TextField
                                    // hintText="DATA DE NASCIMENTO"
                                    // floatingLabelText="DATA DE NASCIMENTO *"
                                    underlineStyle={{ display: 'none' }}
                                    placeholder='DATA DE NASCIMENTO *'
                                    className="input_style form-control"
                                    disabled
                                    errorText={this.state.financialManagerError.dateOfBirth}
                                    >
                                    <InputMask
                                      mask="99/99/9999"
                                      maskChar=" "
                                      type="tel"
                                      aria-label='Data de Nascimento'                                
                                      placeholder='DATA DE NASCIMENTO *'
                                      name="fm_dateOfBirth"
                                      value={this.state.financialManager.dateOfBirth}
                                      onChange={this.handleChange.bind(this)}
                                    />
                                  </TextField>                          

                              )}

                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                              {    this.state.isEditFinancialManagerMotherName  == false ? ( 

                                <TextField
                                  // hintText="NOME DA MÃE"
                                  // floatingLabelText="NOME DA MÃE *"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='NOME DA MÃE *'
                                  name="fm_motherName"
                                  aria-label='NOME DA MÃE'                                
                                  className="input_style form-control"
                                  errorText={this.state.financialManagerError.motherName}
                                  value={this.state.financialManager.motherName}
                                  onChange={this.handleChange.bind(this)}
                                />
                              ) : (
                                <TextField
                                  // hintText="NOME DA MÃE"
                                  // floatingLabelText="NOME DA MÃE *"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='NOME DA MÃE *'
                                  name="fm_motherName"
                                  aria-label='NOME DA MÃE'                                
                                  disabled
                                  className="input_style form-control"
                                  errorText={this.state.financialManagerError.motherName}
                                  value={this.state.financialManager.motherName}
                                  onChange={this.handleChange.bind(this)}
                                />
                              )}
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <SelectField
                                  id="fm_maritalStatus"
                                  // hintText="ESTADO CIVIL"
                                  // floatingLabelText="ESTADO CIVIL *"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='ESTADO CIVIL *'
                                  className="input_style form-control"
                                  name="fm_maritalStatus"
                                  aria-label='ESTADO CIVIL'                       
                                  errorText={this.state.financialManagerError.maritalStatus}
                                  value={this.state.financialManager.maritalStatus}
                                  onChange={this.handleChangeSelectField.bind(this,"fm_maritalStatus")}
                                >
                                      <MenuItem value={""} label="ESTADO CIVIL *" primaryText="ESTADO CIVIL *"/>
                                  <MenuItem value={"SOLTEIRO"} label="SOLTEIRO"  primaryText="SOLTEIRO" />
                                  <MenuItem value={"CASADO"} label="CASADO" primaryText="CASADO" />
                                  <MenuItem value={"VIÚVO"} label="VIÚVO"  primaryText="VIÚVO" />
                                  <MenuItem value={"SEPARADO"} label="SEPARADO"  primaryText="SEPARADO" />
                                  <MenuItem value={"DIVORCIADO"} label="DIVORCIADO"  primaryText="DIVORCIADO" />
                                  <MenuItem value={"RELAÇÃO ESTÁVEL"} label="RELAÇÃO ESTÁVEL"  primaryText="RELAÇÃO ESTÁVEL" />
                                </SelectField>
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <SelectField
                                  id="fm_gender"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='SEXO *'
                                  className="input_style form-control"
                                  name="fm_gender"
                                  aria-label='Sexo'                       
                                  errorText={this.state.financialManagerError.gender}
                                  value={this.state.financialManager.gender}
                                  onChange={this.handleChangeSelectField.bind(this,"fm_gender")}
                                >
                                  <MenuItem value={""} label="SEXO *" primaryText="SEXO *"/>
                                  <MenuItem value={"1"} label="MASCULINO"  primaryText="MASCULINO" />
                                  <MenuItem value={"0"} label="FEMININO" primaryText="FEMININO" />
                                </SelectField>
                              </Col>
                              <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                                <TextField
                                  // hintText="CARTÃO DO SUS"
                                  // floatingLabelText="CARTÃO DO SUS"
                                  underlineStyle={{ display: 'none' }}
                                  placeholder='CARTÃO DO SUS'
                                  aria-label='Cartão do Sus'                       
                                  className="input_style form-control"
                                  name="fm_susNumber"
                                  errorText={this.state.financialManagerError.susNumber}
                                  value={this.state.financialManager.susNumber}
                                  onChange={this.handleChange.bind(this)}
                                />
                              </Col>
                            </Row>
                       </fieldset>
                      {/***************** Responsável Financeiro Endereço ******/}
                      <fieldset style={Styles.fieldset}>
                        <legend style={Styles.legenda_filedset}>
                            ENDEREÇO
                        </legend>                      
                          {!this.state.planAvaliable ? (
                            <Alert color="danger">Plano selecionado indisponível para o endereço informado!</Alert>
                          ) : ('')}
                      <Row>
                        <Col xs="12" sm="12" md="7" lg="2" style={{height:80}}>
                          <TextField
                            // hintText="CEP"
                            // floatingLabelText="CEP *"
                            // className="input_style"
                          underlineStyle={{ display: 'none' }}
                          placeholder='CEP *'
                          className="input_style form-control"
                            
                            errorText={this.state.financialManagerError.cep}
                          >
                            <InputMask
                              mask="99.999-999"
                              maskChar=" "
                              name="fm_cep"
                              placeholder='CEP *'
                              aria-label='Cep'                               
                              type="tel"
                              value={this.state.financialManager.cep}
                              onChange={this.handleChange.bind(this)}
                            />
                          </TextField>
                          <div id="loading_address" className="spin_finder">
                            <i style={{marginRight: 5}}className="fa fa-spinner fa-spin">{""}</i>
                            Buscando endereço
                          </div>
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <SelectField
                            id="fm_addressType"
                            // hintText="LOGRADOURO"
                            // floatingLabelText="LOGRADOURO *"
                            underlineStyle={{ display: 'none' }}
                            placeholder='LOGRADOURO *'
                            aria-label='LOGRADOURO'                             
                            className="input_style form-control"
                            name="fm_addressType"
                            errorText={this.state.financialManagerError.addressType}
                            value={this.state.financialManager.addressType}
                            onChange={this.handleChangeSelectField.bind(this,"fm_addressType")}
                          >
                                <MenuItem value={""} label="LOGRADOURO *" primaryText="LOGRADOURO *"/>
                            {this.state.addressTypeList.map(item =>
                              <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                            )}
                          </SelectField>
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="4" style={{height:80}}>
                          <TextField
                            // hintText="RUA"
                            // floatingLabelText="RUA *"
                            aria-label='Rua'                             
                            underlineStyle={{ display: 'none' }}
                            placeholder='RUA *'
                            className="input_style form-control"
                            name="fm_address"
                            
                            errorText={this.state.financialManagerError.address}
                            value={this.state.financialManager.address}
                            onChange={this.handleChange.bind(this)}
                          />
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="1" style={{height:80}}>
                          <TextField
                            id="tf_fm_addressNumber"
                            name="tf_fm_addressNumber"                          
                            underlineStyle={{ display: 'none' }}
                            placeholder='NÚMERO *'
                            className="input_style form-control"
                            errorText={this.state.financialManagerError.addressNumber}
                          >
                            <CurrencyInput
                              id="fm_addressNumber"
                              precision="0"
                              decimalSeparator=""
                              thousandSeparator=""
                              aria-label='Número'                             
                              name="fm_addressNumber"
                              value={this.state.financialManager.addressNumber}
                              onChangeEvent={this.handleChange.bind(this)}
                              prefix=""
                            />
                          </TextField>
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="2" style={{height:80}}>
                          <SelectField
                            id="fm_state"
                            // hintText="UF"
                            // floatingLabelText="UF *"
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            name="fm_state"
                            aria-label='UF'                             
                            errorText={this.state.financialManagerError.state}
                            value={this.state.financialManager.state}
                            onChange={this.handleChangeSelectField.bind(this,"fm_state")}
                          >
                                <MenuItem value={""} label="UF *" primaryText="UF *"/>
                            {this.state.stateList.map(item =>
                              <MenuItem key={item.Id} value={item.Id} label={item.Sigla}  primaryText={item.Sigla} />
                            )}
                          </SelectField>
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <TextField
                            // hintText="COMPLEMENTO"
                            // floatingLabelText="COMPLEMENTO"
                            placeholder='COMPLEMENTO'
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            aria-label='COMPLEMENTO'                             
                            name="fm_addressComplement"
                            errorText={this.state.financialManagerError.addressComplement}
                            value={this.state.financialManager.addressComplement}
                            onChange={this.handleChange.bind(this)}
                          />
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <SelectField
                            id="fm_city"
                            // hintText="CIDADE"
                            // floatingLabelText="CIDADE *"
                            // className="input_style"
                            placeholder='CIDADE *'
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            name="fm_city"
                            aria-label='CIDADE'                             
                            errorText={this.state.financialManagerError.city}
                            value={this.state.financialManager.city}
                            onChange={this.handleChangeSelectField.bind(this,"fm_city")}
                          >
                                <MenuItem value={""} label="CIDADE *" primaryText="CIDADE *"/>
                            {this.state.cityList.map(item =>
                              <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                            )}
                          </SelectField>
                        </Col>
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                         
                           <SelectField
                            id="fm_district"
                            // hintText="BAIRRO"
                            // floatingLabelText="BAIRRO *"
                            // className="input_style"
                            placeholder='BAIRRO *'
                            aria-label='BAIRRO'                             
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            name="fm_district"
                            errorText={this.state.financialManagerError.district}
                            value={this.state.financialManager.district}
                            onChange={this.handleChangeSelectField.bind(this,"fm_district")}
                          >
                                <MenuItem value={""} label="BAIRRO *" primaryText="BAIRRO *"/>
                            {this.state.districtList.map(item =>
                              <MenuItem key={item.Id} value={item.Id} label={item.Nome}  primaryText={item.Nome} />
                            )}
                          </SelectField> 
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <TextField
                            // hintText="DATA DE ADESÃO"
                            // floatingLabelText="DATA DE ADESÃO *"
                            // className="input_style"
                            placeholder='DATA DE ADESÃO *'
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            errorText={this.state.othersError.dateSignatureContract}
                            >
                            <InputMask
                              mask="99/99/9999"
                              maskChar=" "
                              type="tel"
                              placeholder='DATA DE ADESÃO *'
                              aria-label='DATA DE ADESÃO'                             
                              name="fm_dateSignatureContract"
                              value={this.state.others.dateSignatureContract}
                              onChange={this.handleChange.bind(this)}
                            />
                          </TextField>
                        </Col>
                      </Row>
                      </fieldset>
                      {/*********** Responsavel financeiro participa como titular? ***************/}
                   
                      <fieldset style={Styles.fieldset}>
                        <legend style={Styles.legenda_filedset}>
                            TITULAR DO PLANO
                        </legend>                      
                      <div>
                        {this.state.others.formHolder == false ? (
                          <div>
                            <Row style={{marginLeft:0, marginBottom:20}}>
                              <div className="form_p_question">O RESPON&shy;SÁVEL FINAN&shy;CEIRO VAI PARTI&shy;CIPAR COMO TITULAR DO PLANO?</div>
                              <Button className="form_extra_s_true" onClick={this.formHolderOn.bind(this)}>SIM</Button>{''}
                              <Button className="form_extra_n" onClick={this.formHolderOff.bind(this)}>NÃO</Button>{''}
                            </Row>
                            <Alert className="alert_style">{this.state.othersError.formHolder}</Alert>
                          </div>
                        ):(
                          this.state.others.formHolder == true? (
                            <div>
                              <Row style={{marginLeft:0, marginBottom:20}}>
                                <div className="form_p_question">O RESPON&shy;SÁVEL FINAN&shy;CEIRO VAI PARTI&shy;CIPAR COMO TITULAR DO PLANO?</div>
                                <Button className="form_extra_s" onClick={this.formHolderOn.bind(this)}>SIM</Button>{''}
                                <Button className="form_extra_n_false" onClick={this.formHolderOff.bind(this)}>NÃO</Button>{''}
                              </Row>
                              <Alert className="alert_style">{this.state.othersError.formHolder}</Alert>
                            </div>
                          ):(
                            <div>
                              <Row style={{marginLeft:0, marginBottom:20}}>
                                <div className="form_p_question">O RESPON&shy;SÁVEL FINAN&shy;CEIRO VAI PARTI&shy;CIPAR COMO TITULAR DO PLANO?</div>
                                <Button className="form_extra_s" onClick={this.formHolderOn.bind(this)}>SIM</Button>{''}
                                <Button className="form_extra_n" onClick={this.formHolderOff.bind(this)}>NÃO</Button>{''}
                              </Row>
                              <Alert className="alert_style">{this.state.othersError.formHolder}</Alert>
                            </div>
                          )
                        )}
                      </div>
                      {/************ Titular do plano ***************/}
                      {this.state.others.formHolder == true ? (
                        
                      <div>

                        <p className="form_p_title">Dados do titular</p>
                        <Row>
                        <Col xs="12" sm="12" md="5" lg="2" style={{height:80}}>
                            <TextField
                              // hintText="CPF"
                              // floatingLabelText="CPF"
                              underlineStyle={{ display: 'none' }}
                              placeholder='CPF*'
                              className="input_style form-control"
                              errorText={this.state.holderError.cpf}
                            >
                              <InputMask
                                mask="999.999.999-99"
                                maskChar=" "
                                id="hd_cpf"
                                type="tel"
                                name="hd_cpf"
                                placeholder='CPF*'
                                value={this.state.holder.cpf}
                                onChange={this.handleChange.bind(this)}
                                onBlur={this.validaCPFOnblur.bind(this)}

                              //  onBlur={this.verificaSituacaoTitular.bind(this,"hd_cpf")}

                              />
                            </TextField>
                            <div id="loading_hd_cpf" className="spin_finder" style={{top: -5, position: 'relative'}}>
                            <i style={{marginRight: 5}}className="fa fa-spinner fa-spin">{""}</i>
                            Validando CPF
                          </div>                            
                          </Col>                          
                          <Col xs="12" sm="12" md="7" lg="7" style={{height:80}}>

                          {    this.state.isEditHolderName == false ? ( 
                            <TextField
                            // hintText="NOME"
                            // floatingLabelText="NOME COMPLETO"
                            underlineStyle={{ display: 'none' }}
                            placeholder='NOME COMPLETO*'                              
                            name="hd_firstName"
                            id="hd_firstName"

                            className="input_style form-control"
                            errorText={this.state.holderError.firstName}
                            value={this.state.holder.firstName}
                            onChange={this.handleChange.bind(this)}
                          />                            
                          ) : (
                            <TextField
                              // hintText="NOME"
                              // floatingLabelText="NOME COMPLETO"
                              underlineStyle={{ display: 'none' }}
                              placeholder='NOME COMPLETO*'                              
                              name="hd_firstName"
                              id="hd_firstName"
                              disabled
                              className="input_style form-control"
                              errorText={this.state.holderError.firstName}
                              value={this.state.holder.firstName}
                              onChange={this.handleChange.bind(this)}
                            />                            

                          ) }


                          </Col>

                          <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>

                          {    this.state.isEditHolderDateOfBirth == false ? (    
                              <TextField
                              // hintText="DATA DE NASCIMENTO"
                              // floatingLabelText="DATA DE NASCIMENTO"
                              underlineStyle={{ display: 'none' }}
                              placeholder='DATA DE NASCIMENTO*'
                              className="input_style form-control"
                      
                              errorText={this.state.holderError.dateOfBirth}
                              >
                              <InputMask
                                mask="99/99/9999"
                                placeholder='DATA DE NASCIMENTO*'
                                maskChar=" "
                                type="tel"
                                name="hd_dateOfBirth"
                                value={this.state.holder.dateOfBirth}
                                onChange={this.handleChange.bind(this)}
                              />
                            </TextField>                            
                          ) : (
                                <TextField
                                // hintText="DATA DE NASCIMENTO"
                                // floatingLabelText="DATA DE NASCIMENTO"
                                underlineStyle={{ display: 'none' }}
                                placeholder='DATA DE NASCIMENTO*'
                                className="input_style form-control"
                                disabled
                                errorText={this.state.holderError.dateOfBirth}
                                >
                                <InputMask
                                  mask="99/99/9999"
                                  placeholder='DATA DE NASCIMENTO*'
                                  maskChar=" "
                                  type="tel"
                                  name="hd_dateOfBirth"
                                  value={this.state.holder.dateOfBirth}
                                  onChange={this.handleChange.bind(this)}
                                />
                              </TextField>
                          ) }                        
  
                          </Col>
                          <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                            <SelectField
                              id="hd_maritalStatus"
                              // hintText="ESTADO CIVIL"
                              // floatingLabelText="ESTADO CIVIL"
                              underlineStyle={{ display: 'none' }}
                              className="input_style form-control"
                              name="hd_maritalStatus"
                              aria-label='Estado Civil'
                              errorText={this.state.holderError.maritalStatus}
                              value={this.state.holder.maritalStatus}
                              onChange={this.handleChangeSelectField.bind(this,"hd_maritalStatus")}
                            >
                              <MenuItem value={""} label="ESTADO CIVIL" primaryText="ESTADO CIVIL"/>
                              <MenuItem value={"SOLTEIRO"} label="SOLTEIRO"  primaryText="SOLTEIRO" />
                              <MenuItem value={"CASADO"} label="CASADO" primaryText="CASADO" />
                              <MenuItem value={"VIÚVO"} label="VIÚVO"  primaryText="VIÚVO" />
                              <MenuItem value={"SEPARADO"} label="SEPARADO"  primaryText="SEPARADO" />
                              <MenuItem value={"DIVORCIADO"} label="DIVORCIADO"  primaryText="DIVORCIADO" />
                              <MenuItem value={"RELAÇÃO ESTÁVEL"} label="RELAÇÃO ESTÁVEL"  primaryText="RELAÇÃO ESTÁVEL" />
                            </SelectField>
                          </Col>
                          <Col xs="12" sm="12" md="4" lg="2" style={{height:80}}>
                            <SelectField
                              id="hd_gender"
                              underlineStyle={{ display: 'none' }}
                              className="input_style form-control"
                              name="hd_gender"
                              errorText={this.state.holderError.gender}
                              value={this.state.holder.gender}
                              onChange={this.handleChangeSelectField.bind(this,"hd_gender")}
                            >
                              <MenuItem value={""} label="SEXO" primaryText="SEXO"/>
                              <MenuItem value={"1"} label="MASCULINO"  primaryText="MASCULINO" />
                              <MenuItem value={"0"} label="FEMININO" primaryText="FEMININO" />
                            </SelectField>
                          </Col>
                          <Col xs="12" sm="12" md="4" lg="4" style={{height:80}}>
                          {    this.state.isEditHolderMotherName == false ? (    
                                <TextField
                                // hintText="NOME DA MÃE"
                                // floatingLabelText="NOME DA MÃE"
                                underlineStyle={{ display: 'none' }}
                                className="input_style form-control"
                                name="hd_motherName"
                                placeholder='NOME DA MÃE'
                                
                                errorText={this.state.holderError.motherName}
                                value={this.state.holder.motherName}
                                onChange={this.handleChange.bind(this)}
                              />                            
                          ) : (
                                <TextField
                                // hintText="NOME DA MÃE"
                                // floatingLabelText="NOME DA MÃE"
                                underlineStyle={{ display: 'none' }}
                                className="input_style form-control"
                                name="hd_motherName"
                                placeholder='NOME DA MÃE'
                                disabled
                                errorText={this.state.holderError.motherName}
                                value={this.state.holder.motherName}
                                onChange={this.handleChange.bind(this)}
                              />
                          ) }

  
                          </Col>
                          <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                            <TextField
                              // hintText="CARTÃO DO SUS"
                              // floatingLabelText="CARTÃO DO SUS"
                              underlineStyle={{ display: 'none' }}
                              className="input_style form-control"
                              placeholder='CARTÃO DO SUS'
                              name="hd_susNumber"
                              errorText={this.state.holderError.susNumber}
                              value={this.state.holder.susNumber}
                              onChange={this.handleChange.bind(this)}
                            />
                          </Col>
                        </Row>
                      </div>
                      ):("")}
                      </fieldset>
                      {/***************** Valor do plano ***************/}
                      <fieldset style={Styles.fieldset}>

                      <div className="value_panel">
                        <div className="form_panel_top">
                          <p >VALOR DO PLANO</p>
                        </div>
                        <div className="form_panel_mid">
                            <p>
                              {this.state.planoSelecionado 
                                ? (this.state.planoSelecionado.tradeName || this.state.planoSelecionado.name) 
                                : ''
                              } 
                              {this.state.planoSelecionado && this.state.planoSelecionado.tabelaPreco && 
                                ` R$ ${this.state.planoSelecionado.tabelaPreco.value2}`
                              }
                            </p>                        
                          </div>
                        <div className="form_panel_bottom">
                          <p>TOTAL DO PLANO 
                            R$ {this.state.planoSelecionado  
                                ? (this.state.planoSelecionado.tabelaPreco.value2)
                                : '' 
                            }
                          </p>
                        </div>
                      </div>
                      
                      </fieldset>
                      {/***************** Botoes avancar e voltar ***************/}
                      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                              <Button
                                  variant="contained"
                                  color="primary"
                                  fullWidth
                                  style={{
                                      ...Styles.buttonCancel,
                                      backgroundColor: Colors.textLight,
                                      textTransform: 'none'
                                  }}
                                onClick={this.backPlans.bind(this)} 
                                >
                                Voltar
                              </Button>                        
                              <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
                                onClick={this.formSteps2.bind(this)} 
                              >
                              Avançar
                            </Button>                   
                      </div>

                    </div>
                      )
                    }

                  </Container>
                </Container>
              </div>
            ):("")}
  {/************************* SEGUNDA etapa do formulário **************************/}
            {this.state.phasesForm == 2 ?(
              <div>
                {/* <div id="form_img2">&nbsp;</div> */}
                <Container>
                  <Row>
                    <Col className="text_center">
                      <Stepper activeStep={this.state.phasesForm - 1} >
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DADOS PESSOAIS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DEPENSENTES</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DOCUMENTOS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >FINANCEIRO</StepLabel> */}
                        </Step>
                      </Stepper>
                    </Col>
                  </Row>
                </Container>      
                <Container className="form_container_panel2">
                  <Container className="form_container_internal_panel">
                    <fieldset style={Styles.fieldset}>
                        <legend style={Styles.legenda_fieldset}>
                            ADICIONAR DEPENDENTES
                        </legend> 
                    <p className="form_dp_subtitle">PODEM PARTICIPAR DO PLANO: CÔNJUGES, FILHOS(AS)
                      COM ATÉ 24 ANOS DE IDADE, ENTEADOS E PAIS DO TITULAR OU DO CÔNJUGE
                    </p>
                    <p className="form_p_title">Dados Pessoais</p>
                      <Row>
                        <Col xs="12" sm="12" md="3" lg="3" style={{height:80}}>
                          <TextField
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            errorText={this.state.dependentError.cpf}
                          >
                            <InputMask
                              placeholder='CPF*'
                              mask="999.999.999-99"
                              maskChar=" "
                              name="dp_cpf"
                              type="tel"
                              id="dp_cpf"
                              aria-label='Cpf Dependente'
                              value={this.state.dependent[this.state.depIndex].cpf}
                              onChange={this.handleChange.bind(this)}
                              onBlur={this.validaCPFOnblur.bind(this)}
                            />
                          </TextField>
                          <div id="loading_dp_cpf" className="spin_finder">
                            <i style={{marginRight: 5}}className="fa fa-spinner fa-spin">{""}</i>
                            Verificando CPF
                          </div>                        
                        </Col>                        
                        
                        <Col xs="12" sm="12" md="3" lg="3" style={{height:80}}>
                          <SelectField
                            id="dp_parentage"
                            underlineStyle={{ display: 'none' }}       
                            className="input_style form-control"
                            name="dp_parentage"
                            aria-label='Parentesco'
                            errorText={this.state.dependentError.parentage}
                            value={this.state.dependent[this.state.depIndex].parentage}
                            onChange={this.handleChangeSelectField.bind(this,"dp_parentage")}
                          >
                          <MenuItem value={""} label="PARENTESCO" primaryText="PARENTESCO"/>
                            <MenuItem value={"CÔNJUGE"} label="CÔNJUGE"  primaryText="CÔNJUGE" />
                            <MenuItem value={"FILHO"} label="FILHO" primaryText="FILHO" />
                            <MenuItem value={"PAI/MÃE"} label="PAI/MÃE"  primaryText="PAI/MÃE" />
                            <MenuItem value={"OUTRO"} label="OUTRO"  primaryText="OUTRO" />
                          </SelectField>
                        </Col>   

                        <Col xs="12" sm="12" md="6" lg="6" style={{height:80}}>

                        {    this.state.isEditDependentName == false ? ( 

                              <TextField
                                underlineStyle={{ display: 'none' }}
                                className="input_style form-control"
                                placeholder='NOME COMPLETO*'
                                aria-label='Nome Completo'
                                name="dp_firstName"
                                id="dp_firstName"
                                errorText={this.state.dependentError.firstName}
                                value={this.state.dependent[this.state.depIndex].firstName}
                                onChange={this.handleChange.bind(this)}
                              />
                        ) : (
                              <TextField
                                underlineStyle={{ display: 'none' }}
                                className="input_style form-control"
                                placeholder='NOME COMPLETO*'
                                aria-label='Nome Completo'
                                name="dp_firstName"
                                id="dp_firstName"
                                disabled
                                errorText={this.state.dependentError.firstName}
                                value={this.state.dependent[this.state.depIndex].firstName}
                                onChange={this.handleChange.bind(this)}
                            />                        
                        )}
                        </Col>
                        </Row>
                        <Row>
                            {/** Data de Nascimento */}
                            <Col xs="12" sm="12" md="6" lg="3" style={{height: 80}}>
                                {this.state.isEditDependentDateOfBirth == false ? ( 
                                    <TextField
                                        underlineStyle={{ display: 'none' }}
                                        className="input_style form-control"
                                        errorText={this.state.dependentError.dateOfBirth}
                                    >
                                        <InputMask
                                            placeholder='DATA DE NASCIMENTO*'
                                            mask="99/99/9999"
                                            maskChar=" "
                                            type="tel"
                                            aria-label='Data de nascimento'
                                            name="dp_dateOfBirth"
                                            id="dp_dateOfBirth"
                                            value={this.state.dependent[this.state.depIndex].dateOfBirth}
                                            onChange={this.handleChange.bind(this)}
                                        />
                                    </TextField>                        
                                ) : (
                                    <TextField
                                        underlineStyle={{ display: 'none' }}
                                        className="input_style form-control"
                                        disabled
                                        errorText={this.state.dependentError.dateOfBirth}
                                    >
                                        <InputMask
                                            placeholder='DATA DE NASCIMENTO*'
                                            mask="99/99/9999"
                                            maskChar=" "
                                            type="tel"
                                            aria-label='Data de Nascimento'
                                            name="dp_dateOfBirth"
                                            id="dp_dateOfBirth"
                                            value={this.state.dependent[this.state.depIndex].dateOfBirth}
                                            onChange={this.handleChange.bind(this)}
                                        />
                                    </TextField>
                                )}
                            </Col>
                            
                            {/** Estado Civil */}
                            <Col xs="12" sm="12" md="6" lg="3" style={{height: 80}}>
                                <SelectField
                                    id="dp_maritalStatus"
                                    underlineStyle={{ display: 'none' }}
                                    className="input_style form-control"
                                    aria-label='Estado Civil'
                                    name="dp_maritalStatus"
                                    errorText={this.state.dependentError.maritalStatus}
                                    value={this.state.dependent[this.state.depIndex].maritalStatus}
                                    onChange={this.handleChangeSelectField.bind(this, "dp_maritalStatus")}
                                >
                                    <MenuItem value={""} label="ESTADO CIVIL" primaryText="ESTADO CIVIL"/>
                                    <MenuItem value={"SOLTEIRO"} label="SOLTEIRO" primaryText="SOLTEIRO" />
                                    <MenuItem value={"CASADO"} label="CASADO" primaryText="CASADO" />
                                    <MenuItem value={"VIÚVO"} label="VIÚVO" primaryText="VIÚVO" />
                                    <MenuItem value={"SEPARADO"} label="SEPARADO" primaryText="SEPARADO" />
                                    <MenuItem value={"DIVORCIADO"} label="DIVORCIADO" primaryText="DIVORCIADO" />
                                    <MenuItem value={"RELAÇÃO ESTÁVEL"} label="RELAÇÃO ESTÁVEL" primaryText="RELAÇÃO ESTÁVEL" />
                                </SelectField>
                            </Col>

                            {/** Sexo */}
                            <Col xs="12" sm="12" md="6" lg="2" style={{height: 80}}>
                                <SelectField
                                    id="dp_gender"
                                    underlineStyle={{ display: 'none' }}
                                    className="input_style form-control"
                                    aria-label='Sexo'                                 
                                    name="dp_gender"
                                    errorText={this.state.dependentError.gender}
                                    value={this.state.dependent[this.state.depIndex].gender}
                                    onChange={this.handleChangeSelectField.bind(this, "dp_gender")}
                                >
                                    <MenuItem value={""} label="SEXO" primaryText="SEXO"/>
                                    <MenuItem value={"1"} label="MASCULINO" primaryText="MASCULINO" />
                                    <MenuItem value={"0"} label="FEMININO" primaryText="FEMININO" />
                                </SelectField>
                            </Col>

                            {/** Nome da Mãe */}
                            <Col xs="12" sm="12" md="6" lg="4" style={{height: 80}}>
                                {this.state.isEditDependentMotherName == false ? ( 
                                    <TextField
                                        underlineStyle={{ display: 'none' }}
                                        className="form-control"
                                        placeholder='NOME DA MÃE*'
                                        aria-label='Nome da mãe'
                                        name="dp_motherName"
                                        id="dp_motherName"                            
                                        errorText={this.state.dependentError.motherName}
                                        value={this.state.dependent[this.state.depIndex].motherName}
                                        onChange={this.handleChange.bind(this)}
                                    />                        
                                ) : (
                                    <TextField
                                        underlineStyle={{ display: 'none' }}
                                        className="form-control"
                                        placeholder='NOME DA MÃE*'
                                        name="dp_motherName"
                                        id="dp_motherName"
                                        aria-label='Nome da mãe'      
                                        disabled                       
                                        errorText={this.state.dependentError.motherName}
                                        value={this.state.dependent[this.state.depIndex].motherName}
                                        onChange={this.handleChange.bind(this)}
                                    />                        
                                )}
                            </Col>
                        </Row>
                        <Row>
                        {/*cartão sus*/}
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <TextField
                            underlineStyle={{ display: 'none' }}
                            className="form-control"
                            placeholder='CARTÃO DO SUS'
                            name="dp_susNumber"
                            id="dp_susNumber"    
                            aria-label='Cartão SUS'                        
                            errorText={this.state.dependentError.susNumber}
                            value={this.state.dependent[this.state.depIndex].susNumber}
                            onChange={this.handleChange.bind(this)}
                          />
                        </Col>
                        {/* NOVO CAMPO: Seleção de Plano Específico para o Dependente */}
                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <SelectField
                            id="dp_plan"
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            aria-label='Plano do Dependente'
                            name="dp_plan"
                            errorText={this.state.dependentError.plan}
                            value={this.state.dependent[this.state.depIndex].plansId || ""}
                            onChange={this.handleChangeSelectField.bind(this, "dp_plansId")}
                          >
                            <MenuItem value={""} label="SELECIONE O PLANO" primaryText="SELECIONE O PLANO"/>
                              {this.state.planos_correlacionados && this.state.planos_correlacionados.map((plano, index) => (
                                <MenuItem 
                                  key={index} 
                                  value={plano.id || plano.codeS4} 
                                  label={plano.tradeName || plano.name } 
                                  primaryText={ plano.tradeName || plano.name} 
                                />
                              ))}
                          </SelectField>
                        </Col>

                        <Col xs="12" sm="12" md="4" lg="3" style={{height:80}}>
                          <SelectField
                            id="dp_portability"
                            underlineStyle={{ display: 'none' }}
                            className="input_style form-control"
                            aria-label='Portabilidade?'
                            name="dp_portability"
                            errorText={this.state.dependentError.portability}
                            value={this.state.dependent[this.state.depIndex].portability}
                            onChange={this.handleChangeSelectField.bind(this, "dp_portability")}
                          >
                            <MenuItem value="" label="PORTABILIDADE?" primaryText="PORTABILIDADE?"/>
                            <MenuItem value={true} label="SIM" primaryText="SIM" />
                            <MenuItem value={false} label="NÃO" primaryText="NÃO" />
                          </SelectField>
                        </Col>                       
                      </Row>

                      <div style={{textAlign:"center"}}>
                        <Button 
                          onClick={this.addDependentList.bind(this)} 
                          style={{
                            ...Styles.buttonSuccess,
                            fontWeight: 'bold',
                            textTransform: 'none'
                            }}>
                            ADICIONAR DEPENDENTE
                            </Button>{''}
                      </div>                     
                    </fieldset>
                    <fieldset style={Styles.fieldset}>
                        <legend style={Styles.legenda_filedset}>
                            DEPENDENTES NO PLANO
                        </legend> 
                          {/***************** Tabela  dependentes ***************/}
                          <Container style={{padding:0}}>
                            <table className="table_dependent">
                              <thead className="dep_thead">
                                <tr className="dep_tr_thead">
                                  <th className="dep_th_left" >Nomes</th>
                                  <th className="dep_th" >Tipo</th>
                                  <th className="dep_th" >Plano</th>
                                  <th className="dep_th" >Valor Unitário</th>
                                  <th className="dep_th" >Portabilidade</th>
                                  <th className="dep_th" >Ação</th>
                                </tr>
                              </thead>
<tbody>
  {this.state.dependentsList.map((item, index) => {
    const trClassName = index % 2 === 0 ? "dep_tr_body1" : "dep_tr_body2";
    
    return (
      <tr className={trClassName} key={index}>
        <td className="dep_td_body_name1">{item.firstName}</td>
        
        {/* EXIBE O NOME DO PLANO DO CORRESPONDENTE */}
        <td className="dep_td_body_name1">
          {item.planName || (this.state.planoSelecionado.tradeName || this.state.planoSelecionado.name)}
        </td>                                        
        
        <td className="dep_td_body1">
          {item.isHolder ? ('Titular') : ('Dependente')}
        </td>
        
        {/* EXIBE O VALOR UNITÁRIO INDIVIDUAL DO PLANO */}
        <td className="dep_td_body1">
          {item.valuePlan ? `R$ ${item.valuePlan}` : (this.state.planoSelecionado && this.state.planoSelecionado.tabelaPreco ? `R$ ${this.state.planoSelecionado.tabelaPreco.value2}` : '')}
        </td>
        
        <td className="dep_td_body_name1">
          {item.portability ? ('Sim') : ('Não')}
        </td>
        
        <td className="dep_td_body1">
          {item.isHolder ? ('') : (
            <div className="icon_lixo_dep" onClick={this.deleteDependentList.bind(this, index)}>
              {''}
            </div>
          )}
        </td>
      </tr>
    );
  })}
</tbody>
                            </table>
                          </Container>

                    </fieldset>
                    <fieldset style={Styles.fieldset}>
                          {/***************** Tabela  Valor do plano ***************/}
                       {/* <div className="value_panel_table">
                        <p className="value_table_top">VALOR DO PLANO</p>
                        <div className="value_table_mid">
                          <Row>
                            <Col xs="7" sm="9" md="9" lg="9" className="value_table">
                                {this.state.dependentsList.length}X {this.state.planoSelecionado 
                                ? (this.state.planoSelecionado.tradeName || this.state.planoSelecionado.name) 
                                : ''
                              }
                            </Col>
                            <Col xs="5" sm="3" md="3" lg="3" className="value_table2">R$ {this.state.planoSelecionado.tabelaPreco.value2}</Col>
                          </Row>
                          <Row>
                            <Col xs="7" sm="9" md="9" lg="9" className="value_table">SUBTOTAL</Col>
                            <Col xs="5" sm="3" md="3" lg="3" className="value_table4">R$ {this.state.totalNoDescont}</Col>
                          </Row>
                          <hr className="hr_value_table"/>
                          <Row>
                            <Col xs="7" sm="9" md="9" lg="9" className="value_table5">DESCONTO TABELA FAMÍLIA</Col>
                            <Col xs="5" sm="3" md="3" lg="3" className="value_table6">R$ -{this.state.valueDescontTotal}</Col>
                          </Row>
                        </div>
                        <div className="value_table_bottom">
                          <Row>
                            <Col xs="7" sm="9" md="9" lg="9" className="value_table7">TOTAL</Col>
                            <Col xs="5" sm="3" md="3" lg="3" className="value_table8">R${this.state.value_total}</Col>
                          </Row>
                        </div>
                      </div> */}
<div className="value_panel_table">
  <p className="value_table_top">VALOR DO PLANO</p>
  <div className="value_table_mid" style={{ height: 'auto', paddingBottom: '15px' }}>
    
    {this.getResumoPlanosAgrupados().map((grupo, idx) => {
      let subtotalGrupo = (parseFloat(String(grupo.valorUnitario).replace(',', '.')) * grupo.quantidade).toFixed(2).replace('.', ',');
      return (
        <Row key={idx}>
          <Col xs="7" sm="9" md="9" lg="9" className="value_table">
            {grupo.quantidade}X {grupo.nome} 
            <span style={{ fontSize: '11px', color: '#666', display: 'block' }}>
              (Valor sem desconto: R$ {grupo.valorSemDesconto} cada)
            </span>
          </Col>
          <Col xs="5" sm="3" md="3" lg="3" className="value_table2">
            R$ {subtotalGrupo}
          </Col>
        </Row>
      );
    })}

    <Row>
      <Col xs="7" sm="9" md="9" lg="9" className="value_table3">TOTAL</Col>
      <Col xs="5" sm="3" md="3" lg="3" className="value_table4">R$ {this.state.totalNoDescont}</Col>
    </Row>
    <hr className="hr_value_table"/>
    <Row>
      <Col xs="7" sm="9" md="9" lg="9" className="value_table5">DESCONTO TABELA FAMÍLIA</Col>
      <Col xs="5" sm="3" md="3" lg="3" className="value_table6">R$ -{this.state.valueDescontTotal}</Col>
    </Row>
  </div>
  <div className="value_table_bottom" style={{ position: 'relative', marginTop: '0px' }}>
    <Row>
      <Col xs="7" sm="9" md="9" lg="9" className="value_table7">TOTAL COM DESCONTO</Col>
      <Col xs="5" sm="3" md="3" lg="3" className="value_table8">R${this.state.value_total}</Col>
    </Row>
  </div>
</div>             
                    </fieldset>


                      {/***************** Botoes avancar e voltar ***************/}
                      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>

                        <Button 
                            onClick={this.stageForm.bind(this, 1)}
                              style={{
                                  ...Styles.buttonCancel,
                                  backgroundColor: Colors.textLight,
                                  textTransform: 'none'
                              }}
                            >VOLTAR</Button>{''}
                        <Button 
                            onClick={this.formSteps3.bind(this)} 
                            style={{
                              ...Styles.buttonSuccess,
                              fontWeight: 'bold',
                              textTransform: 'none'
                              }} >
                              AVANÇAR
                        </Button>{''}
                      </div>
                  </Container>
                </Container>
              </div>
            ):("")}
  {/************************* TERCEIRA  etapa do formulario - ANEXO DE DOCS ********/}
            {this.state.phasesForm == 3 ?(
              <div>
                {/* <div id="form_img3">&nbsp;</div> */}
                <Container>
                  <Row>
                    <Col className="text_center">
                      <Stepper activeStep={this.state.phasesForm - 1} >
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DADOS PESSOAIS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DEPENSENTES</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DOCUMENTOS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >FINANCEIRO</StepLabel> */}
                        </Step>
                      </Stepper>
                    </Col>
                  </Row>
                </Container>
                <Container className="form_container_panel2">
                  <Container className="form_container_internal_panel">
                    <p className="form_p">ANEXAR CÓPIAS DOS DOCUMENTOS DO RESPONSÁVEL FINANCEIRO</p>
                    <p className="form_docs_subtitle">RESPONSÁVEL FINANCEIRO</p>
                    <p className="form_docs_subtitle2">{this.state.financialManager.firstName}</p>
                    {/********************* Anexo de documentos  ************************/}
                    <div >
                      {/** AUTORIZACAO AVERBAÇÃO  ***********/}
                      { this.state.isServidor ? (
                       <div style={{width:'100%', textAlign:"center"}}>
                        <label htmlFor="doc_autorizacaoAverbacao" style={{cursor:'pointer'}}>
                          <p className="label_doc_style">AUTORIZACAO DE AVERBAÇÃO</p>
                          {this.state.imagesDocs.autorizacaoAverbacao == "" ? (
                            <div>
                              <div id="name_file_choose_cpf" className="doc_style">ESCOLHER O ARQUIVO</div>
                              <p id="legend_doc_style_cpf" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                            </div>
                          ):(
                            this.state.imagesDocs.autorizacaoAverbacao == "pdf" ? (
                              <i id="name_file_pdf_rg" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                            ):(
                              <img id="name_file_autorizacaoAverbacao" src={this.state.imagesDocs.autorizacaoAverbacao} width="90" className="icon_layout"/>
                            )
                          )}
                        </label>
                        <input id="doc_autorizacaoAverbacao" style={{visibility:"hidden",position:'absolute',left: -9999}}
                          type="file" name="autorizacaoAverbacao" onChange={this.fileToBase64.bind(this, 'autorizacaoAverbacao')}
                        />
                      </div>    
                      )
                        : null
                      }
                      {/* SELETOR */}
                    <div style={{width:'100%', textAlign:"center"}}>
                      <label>
                        <strong>Selecione o documento de identificação:</strong>
                      </label>

                      <div style={{width:'100%', textAlign:"center"}}>
                        <label>
                          <input
                            type="radio"
                            value="rg"
                            checked={this.state.documentType === 'rg'}
                            onChange={(e) => this.setState({ documentType: e.target.value })}
                          /> RG
                        </label>

                        <br /><br />

                        <label>
                          <input
                            type="radio"
                            value="cnh"
                            checked={this.state.documentType === 'cnh'}
                            onChange={(e) => this.setState({ documentType: e.target.value })}
                          /> CNH
                        </label>
                      </div>
                    </div>
                       {this.state.documentType === 'rg' && (
                        <div>
                            {/** RG  ***********/}
                            <div style={{width:'100%', textAlign:"center"}}>
                              <label htmlFor="doc_rg" style={{cursor:'pointer'}}>
                                <p className="label_doc_style">RG (LADO DA FRENTE)</p>
                                {this.state.imagesDocs.rg == "" ? (
                                  <div>
                                    <div id="name_file_choose_rg" className="doc_style">ESCOLHER O ARQUIVO</div>
                                    <p id="legend_doc_style_rg" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                  </div>
                                ):(
                                  this.state.imagesDocs.rg == "pdf" ? (
                                    <i id="name_file_pdf_rg" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                  ):(
                                    <img id="name_file_rg" src={this.state.imagesDocs.rg} width="90" className="icon_layout"/>
                                  )
                                )}
                              </label>
                              <input id="doc_rg" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                type="file" name="rg" onChange={this.fileToBase64.bind(this, 'rg')}
                              />
                            </div>                       
                            {/** RG (Verso)  ***********/}
                            <div style={{width:'100%', textAlign:"center"}}>
                              <label htmlFor="doc_rg2" style={{cursor:'pointer'}}>
                                <p className="label_doc_style">RG (Verso)</p>
                                {this.state.imagesDocs.rg2 == "" ? (
                                  <div>
                                    <div id="name_file_choose_rg2" className="doc_style">ESCOLHER O ARQUIVO</div>
                                    <p id="legend_doc_style_rg2" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                  </div>
                                ):(
                                  this.state.imagesDocs.rg2 == "pdf" ? (
                                    <i id="name_file_pdf_rg" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                  ):(
                                    <img id="name_file_rg2" src={this.state.imagesDocs.rg2} width="90" className="icon_layout"/>
                                  )
                                )}
                              </label>
                              <input id="doc_rg2" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                type="file" name="rg2" onChange={this.fileToBase64.bind(this, 'rg2')}
                              />
                            </div>
                            <div style={{width:'100%', textAlign:"center"}}>
                              <label htmlFor="doc_cpf" style={{cursor:'pointer'}}>
                                <p className="label_doc_style">CPF</p>
                                {this.state.imagesDocs.cpf == "" ? (
                                  <div>
                                    <div id="name_file_choose_cpf" className="doc_style">ESCOLHER O ARQUIVO</div>
                                    <p id="legend_doc_style_cpf" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                  </div>
                                ):(
                                  this.state.imagesDocs.cpf == "pdf" ? (
                                    <i id="name_file_pdf_rg" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                  ):(
                                    <img id="name_file_cpf" src={this.state.imagesDocs.cpf} width="90" className="icon_layout"/>
                                  )
                                )}
                              </label>
                              <input id="doc_cpf" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                type="file" name="cpf" onChange={this.fileToBase64.bind(this, 'cpf')}
                              />
                            </div>                            
                        </div>
                       )}
                      {this.state.documentType === 'cnh' && (
                        <div style={{width:'100%', textAlign:"center"}}>
                          <label htmlFor="doc_cnh" style={{cursor:'pointer'}}>
                            <p className="label_doc_style">CNH</p>
                            {this.state.imagesDocs.cnh == "" ? (
                              <div>
                                <div id="name_file_choose_cnh" className="doc_style">ESCOLHER O ARQUIVO</div>
                                <p id="legend_doc_style_cnh" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                              </div>
                            ):(
                              this.state.imagesDocs.cnh == "pdf" ? (
                                <i id="name_file_pdf_cnh" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                              ):(
                                <img id="name_file_cnh" src={this.state.imagesDocs.cnh} width="90" className="icon_layout"/>
                              )
                            )}
                          </label>
                          <input id="doc_cnh" style={{visibility:"hidden",position:'absolute',left: -9999}}
                            type="file" name="cnh" onChange={this.fileToBase64.bind(this, 'cnh')}
                          />
                        </div>
                      )}
                      {/** Comprovante de Residência  ***********/}
                      <div style={{width:'100%', textAlign:"center"}}>
                        <label htmlFor="doc_address" style={{cursor:'pointer'}}>
                          <p className="label_doc_style">COMPROVANTE DE <br/>RESIDÊNCIA (COM CEP)</p>
                          {this.state.imagesDocs.address == "" ? (
                            <div>
                              <div id="name_file_choose_address" className="doc_style">ESCOLHER O ARQUIVO</div>
                              <p id="legend_doc_style_address" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                            </div>
                          ):(
                            this.state.imagesDocs.address == "pdf" ? (
                              <i id="name_file_pdf_rg" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                            ):(
                              <img id="name_file_address" src={this.state.imagesDocs.address} width="90" className="icon_layout"/>
                            )
                          )}
                        </label>
                        <input id="doc_address" style={{visibility:"hidden",position:'absolute',left: -9999}}
                          type="file" name="address" onChange={this.fileToBase64.bind(this, 'address')}
                        />
                      </div>
                                {/** DECLARAÇÃO DE PORTABILIDADE  ***********/}
                                <div style={{width:'100%', textAlign:"center"}}>
                                  <label htmlFor="doc_declarationPortability" style={{cursor:'pointer'}}>
                                    <p className="label_doc_style" style={{textAlign: 'inherit'}}>DECLARAÇÃO DE PORTABILIDADE</p>
                                    {this.state.imagesDocs.declarationPortability == "" ? (
                                      <div>
                                        <div id="name_file_choose_others" className="doc_style" style={{minWidth: 290}}>
                                          ESCOLHER O ARQUIVO
                                        </div>
                                        <p id="legend_doc_style_others" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                      </div>
                                    ):(
                                      this.state.imagesDocs.declarationPortability == "pdf" ? (
                                        <i id="name_file_pdf_declarationPortability" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                      ):(
                                        <img id="name_file_declarationPortability" src={this.state.imagesDocs.declarationPortability} width="90" className="icon_layout"/>
                                      )
                                    )}
                                  </label>
                                  <input id="doc_declarationPortability" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                    type="file" name="declarationPortability" onChange={this.fileToBase64.bind(this, 'declarationPortability')}
                                  />
                                </div>                      
                                {/** OUTRO  ***********/}
                                <div style={{width:'100%', textAlign:"center"}}>
                                  <label htmlFor="doc_others" style={{cursor:'pointer'}}>
                                    <p className="label_doc_style" style={{textAlign: 'inherit'}}>OUTROS</p>
                                    {this.state.imagesDocs.others == "" ? (
                                      <div>
                                        <div id="name_file_choose_others" className="doc_style" style={{minWidth: 290}}>
                                          ESCOLHER O ARQUIVO
                                        </div>
                                        <p id="legend_doc_style_others" className="legend_doc_style">NENHUM ARQUIVO SELECIONADO</p>
                                      </div>
                                    ):(
                                      this.state.imagesDocs.others == "pdf" ? (
                                        <i id="name_file_pdf_others" className="far fa-file-pdf fa-6x icon_layout">{""}</i>
                                      ):(
                                        <img id="name_file_others" src={this.state.imagesDocs.others} width="90" className="icon_layout"/>
                                      )
                                    )}
                                  </label>
                                  <input id="doc_others" style={{visibility:"hidden",position:'absolute',left: -9999}}
                                    type="file" name="others" onChange={this.fileToBase64.bind(this, 'others')}
                                  />
                                </div>
                    </div>
                    {/***************** Botoes avancar e voltar ***************/}
                    <div style={{textAlign:"center"}}>
                      <Button 
                          onClick={this.stageForm.bind(this, 2)} 
                          style={{
                                  ...Styles.buttonCancel,
                                  backgroundColor: Colors.textLight,
                                  textTransform: 'none'
                          }} >
                          VOLTAR
                      </Button>{''}
                      <Button 
                          onClick={this.formSteps4.bind(this)}
                                                      style={{
                              ...Styles.buttonSuccess,
                              fontWeight: 'bold',
                              textTransform: 'none'
                              }} >
                          AVANÇAR
                      </Button>{''}
                    </div>
                  </Container>
              </Container>
            </div>
            ):("")}
  {/************************* QUARTA etapa do formulario - Formas de pagamento *****/}
            {this.state.phasesForm == 4 ?(
              <div>

                <Container>
                  <Row>
                    <Col className="text_center">
                      <Stepper activeStep={this.state.phasesForm - 1} >
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DADOS PESSOAIS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DEPENSENTES</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >DOCUMENTOS</StepLabel> */}
                        </Step>
                        <Step>
                          <StepLabel className='dados' ></StepLabel>
                          {/* <StepLabel className='dados' >FINANCEIRO</StepLabel> */}
                        </Step>
                      </Stepper>
                    </Col>
                  </Row>
                </Container>
                <Container className="form_container_panel2">
                  <Container className="form_container_internal_panel">
                                          
                    <fieldset style={Styles.fieldset}>
                        <legend style={Styles.legenda_filedset}>
                          DADOS FINANCEIROS
                      </legend>
                        {
                          this.state.isServidor ? (
                            <p className="form_dp_subtitle">PRÓXIMAS MENSALIDADES DESCONTADAS EM FOLHA</p>
                          ) : this.state.payment_plan == "true" ? ( // <--- Adicionado o '?' e removido o parêntese incorreto
                          <div>
                              <p className="form_dp_subtitle">INSIRA SEUS DADOS FINANCEIROS PARA COBRANÇA DAS PRÓXIMAS MENSALIDADES</p>
                              {/* <p className="form_p_title">Dados Pessoais</p> */}
                              
                              <Row>
                                <Col md="4"></Col>
                                <Col md="4" style={{ marginBottom: 20 }}>
                                  <Cards cvc={this.state.cvc} expiry={this.state.paymentCreditCard.cardExpiring} focused={this.state.focus} name={this.state.paymentCreditCard.cardHolderName} number={this.state.paymentCreditCard.cardCreditNumber} />
                                </Col>
                                <Col md="4"></Col>
                              </Row>

                              <Row>
                                <Col xs="12" sm="12" md="1" lg="2">{''}</Col>
                                <Col xs="12" sm="12" md="5" lg="4" style={{height:80}}>
                                  <TextField
                                    // hintText="NÚMERO DO CARTÃO"
                                    // floatingLabelText="NÚMERO DO CARTÃO"
                                    type="tel"
                                    name="pay_cardCreditNumber"
                                    // name="number"
                                    underlineStyle={{ display: 'none' }}
                                    placeholder='*Número do Cartão'
                                    id="pay_cardCreditNumber"
                                    aria-label='NÚMERO DO CARTÃO'
                                    // value={this.state.paymentCreditCard.cardCreditNumber}                              
                                    // onChange={this.handleInputChange.bind(this)}
                                    // onFocus={this.handleInputFocus.bind(this)}
                                    onChange={this.handleChange.bind(this)}
                                    onBlur={this.validarCartaoCreditoCardBin.bind(this)}
                                    // onBlur={this.validateCardNumber.bind(this, "numeroCartao", null)}
                                    className="form-control"
                                    errorText={this.state.paymentCreditCardError.cardCreditNumber}
                                  />
                                    
                                  {/* </TextField> */}
                                    {this.state.paymentCreditCard.flagCardPayment == "MASTERCARD" ?  (
                                      <label className="payment_layout_card master_card">&nbsp;</label>
                                    ):("")}
                                    {this.state.paymentCreditCard.flagCardPayment == "VISA" ? (
                                      <label className="payment_layout_card visa_card">&nbsp;</label>
                                    ):("")}
                                    {this.state.paymentCreditCard.flagCardPayment == "HIPERCARD" ? (
                                      
                                      <label className="payment_layout_card hiper_card">&nbsp;</label>
                                    ):("")}
                                    {this.state.paymentCreditCard.flagCardPayment == "ELO" ? (
                                      <label className="payment_layout_card elo_card">&nbsp;</label>
                                    ):("")}
                                </Col>
                                <Col xs="12" sm="12" md="5" lg="4" style={{height:80}}>
                                  {/* <TextField
                                    hintText="VALIDADE: EX.: 01/2099"
                                    floatingLabelText="VALIDADE: EX.: 01/2099"
                                    className="input_style"
                                    errorText={this.state.paymentCreditCardError.cardExpiring}
                                  > */}
                                  <TextField
                                      name="tf_pay_cardExpiring"
                                      id="tf_pay_cardExpiring"
                                      underlineStyle={{ display: 'none' }}
                                      errorText={this.state.paymentCreditCardError.cardExpiring}
                                  >
                                    <InputMask
                                      mask="99/9999"
                                      maskChar=" "
                                      type="tel"
                                      placeholder='VALIDADE: EX.: 01/2099'
                                      name="pay_cardExpiring"
                                      id="pay_cardExpiring"
                                      aria-label='VALIDADE'
                                      className='form-control'
                                      onChange={this.handleChange.bind(this)}

                                    />
                                    </TextField>
      {/*                             <div className='errorText'>{this.state.paymentCreditCardError.cardExpiring}</div>
      */}                            {/* </TextField> */}
                                </Col>
                                <Col xs="12" sm="12" md="1" lg="2">{''}</Col>
                              </Row>

                              <Row>
                                <Col xs="12" sm="12" md="1" lg="2">{''}</Col>
                                <Col xs="12" sm="12" md="5" lg="4" style={{height:80}}>
                                  <TextField
                                    // hintText="NOME DO TITULAR DO CARTÃO"
                                    // floatingLabelText="NOME DO TITULAR DO CARTÃO"
                                    underlineStyle={{ display: 'none' }}
                                    className="form-control"
                                    errorText={this.state.paymentCreditCardError.cardHolderName}
                                    placeholder='NOME DO TITULAR DO CARTÃO'
                                    name="pay_cardHolderName"
                                    id="pay_cardHolderName"
                                    aria-label='NOME DO TITULAR DO CARTÃO'
                                    // value={this.state.paymentCreditCard.cardHolderName}
                                    // onChange={this.handleChange.bind(this)}
                                    // onChange={this.handleInputChange.bind(this)}
                                    // onFocus={this.handleInputFocus.bind(this)}
                                    // onBlur={this.handleChange.bind(this)}
                                    onChange={this.handleChange.bind(this)}
                                  />

                                  
                                </Col>
                                <Col xs="12" sm="12" md="5" lg="4" style={{height:80}}>
                                  <div className="card_flag" >BANDEIRAS ACEITAS</div>
                                  <div className="card_credit_flag">{''}</div>
                                      
                                </Col>    
                                                    
                                <Col xs="12" sm="12" md="1" lg="2">{''}
                                
                                </Col>
                              </Row>

                              <Row  style={{height:40}}>
                                <Col xs="12" sm="12" md="4" lg="3">
                                  {""}
                                </Col>
            
                                <Col xs="12" sm="12" md="4" lg="3">
                                  {""}
                              
                                </Col>
                                            
                              </Row>

                              <Row >    
                                <Col lg="12">
                                    {this.state.habilitaCpfCartao === '' ? (
                                    <Row style={{ marginLeft: 0, marginBottom: 20 }}>
                                    <div className="form_titular">O cartão pertence a algum usuário do plano? </div>
                                    <Button className="form_extra_s" onClick={this.formCardQuestionS.bind(this)}>SIM</Button>{''}
                                    <Button className="form_extra_n" onClick={this.formCardQuestionN.bind(this)}>NÃO</Button>{''}                                            
                                  </Row>
                                  ):(
                                    this.state.habilitaCpfCartao == true? (
                                      <Row style={{ marginLeft: 0, marginBottom: 20 }}>
                                      <div className="form_titular">O cartão pertence a algum usuário do plano?</div>
                                      <Button className="form_extra_s" onClick={this.formCardQuestionS.bind(this)}>SIM</Button>{''}
                                      <Button className="form_extra_n_false" onClick={this.formCardQuestionN.bind(this)}>NÃO</Button>{''}                                            
                                    </Row>                                    
                                    ): (
                                    <Row style={{ marginLeft: 0, marginBottom: 20 }}>
                                    <div className="form_titular">O cartão pertence a algum usuário do plano?</div>
                                    <Button className="form_extra_s_true" onClick={this.formCardQuestionS.bind(this)}>SIM</Button>{''}
                                    <Button className="form_extra_n" onClick={this.formCardQuestionN.bind(this)}>NÃO</Button>{''}                                           
                                  </Row>                                     
                                    )
                                  ) }   
                                  <Row >
                                        <Col lg="5"  > 
                                                  {""}
                                          </Col>   														
                                          <Col lg="5">
                                              <Alert id="alert_questionUsuarioCpfCard" color="danger">*Escolha uma opção, SIM OU NÃO!</Alert>
                                          </Col>	
                                  </Row>	                                                     
                                </Col>
                                </Row>   
                                <Row>        
                                  <Col lg="5"> {""} </Col>                   
                                  <Col>   
                                      {this.state.habilitaCpfCartao ? (
                                        <div  style={{ width:250 } }>
                                          <TextField
                                                id="tf_card_cpf"
                                                name="tf_card_cpf"

                                                underlineStyle={{ display: 'none' }}
                                                placeholder="CPF *"
                                                className="input_style form-control"
                                                errorText={this.state.financialManagerError.cpfCard}
                                              >
                                                <InputMask
                                                  id="card_cpf"
                                                  mask="999.999.999-99"
                                                  maskChar=" "
                                                  type="tel"
                                                  name="card_cpf"
                                                  placeholder="Informe o CPF do dono do cartão*"
                                                  value={this.state.financialManager.cpfCard}
                                                  onBlur={this.validaCPFOnblur.bind(this)}
                                                  onChange={this.handleChange.bind(this)}                                      
                                                />
                                        </TextField>  
                                      </div>                                        
                                      ):("")}
                                  </Col>                                    
                                  </Row>  
                                                          
                          </div>
                        ) : (
                        <div>
                          <p className="form_dp_subtitle">PRÓXIMAS MENSALIDADES NO BOLETO BANCÁRIO</p>
                        </div>
                        )
                      }


                    </fieldset>

                    <fieldset style={Styles.fieldset}>
                        {/***************** Tabela  Valor do plano ***************/}
                        <Row>
                          <Col xs="12" sm="12" md="12" lg="12">
<div className="value_panel_table">
  <p className="value_table_top">VALOR DO PLANO</p>
  <div className="value_table_mid" style={{ height: 'auto', paddingBottom: '15px' }}>
    
    {this.getResumoPlanosAgrupados().map((grupo, idx) => {
      let subtotalGrupo = (parseFloat(String(grupo.valorUnitario).replace(',', '.')) * grupo.quantidade).toFixed(2).replace('.', ',');
      return (
        <Row key={idx}>
          <Col xs="7" sm="9" md="9" lg="9" className="value_table">
            {grupo.quantidade}X {grupo.nome} 
            <span style={{ fontSize: '11px', color: '#666', display: 'block' }}>
              (Valor sem desconto: R$ {grupo.valorSemDesconto} cada)
            </span>
          </Col>
          <Col xs="5" sm="3" md="3" lg="3" className="value_table2">
            R$ {subtotalGrupo}
          </Col>
        </Row>
      );
    })}

    <Row>
      <Col xs="7" sm="9" md="9" lg="9" className="value_table3">TOTAL</Col>
      <Col xs="5" sm="3" md="3" lg="3" className="value_table4">R$ {this.state.totalNoDescont}</Col>
    </Row>
    <hr className="hr_value_table"/>
    <Row>
      <Col xs="7" sm="9" md="9" lg="9" className="value_table5">DESCONTO TABELA FAMÍLIA</Col>
      <Col xs="5" sm="3" md="3" lg="3" className="value_table6">R$ -{this.state.valueDescontTotal}</Col>
    </Row>
  </div>
  <div className="value_table_bottom" style={{ position: 'relative', marginTop: '0px' }}>
    <Row>
      <Col xs="7" sm="9" md="9" lg="9" className="value_table7">TOTAL COM DESCONTO</Col>
      <Col xs="5" sm="3" md="3" lg="3" className="value_table8">R${this.state.value_total}</Col>
    </Row>
  </div>
</div> 
                          </Col>
                        </Row>
                    </fieldset>
                    {
                      this.state.btnFinishDisabled == true ? (
                    <div style={{textAlign:"center", marginTop:25}}>
                      <CircularProgress />
                    </div>
                      ) : ('')
                    }

                    {/***************** Botoes Concluir e voltar ***************/}
                    <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                      <Button 
                          onClick={this.stageForm.bind(this, 3)} 
                          style={{
                              ...Styles.buttonCancel,
                              backgroundColor: Colors.textLight,
                              textTransform: 'none'
                          }} >
                            VOLTAR
                      </Button>{''}
                      <Button
                          onClick={this.handleResumeOpen.bind(this)}
                          style={{
                            ...Styles.buttonSuccess,
                            fontWeight: 'bold',
                            textTransform: 'none'
                            }}
                        disabled={this.state.btnFinishDisabled}
                      >
                        CONCLUIR
                      </Button>
                    </div>
                  </Container>
                </Container>
              </div>
            ):("")}
          </div>
        </Form>
  {/*************************** MODAIS DIALOG ***************************************/}
        {/*Modal de dados invalidos */}       
         {/* paulo 2 */}       
         {/* 
         
         <Modal
         open={this.state.openModalHiper} 
         onClose={this.closeModalHiper.bind(this)}
          center showCloseIcon={false}
          classNames={{ modal: 'custom-modal-parcial_dental'}}
        >
          <div id="formgroup_select_dental" >  
            <Container style={{marginTop:10}}>
              <Row style={{marginBottom:30, paddingLeft:15}}>

                <Col className="icon-scroll-dental">
                  <i onClick={this.closeModalHiper.bind(this)} className="fas fa-times-circle color_fa">{''}</i>
                </Col>
              </Row>
              <p className="text-modal" style={{ marginBottom:0, marginTop:0, fontSize : 16 }}>
              Que boa notícia! Em breve você fará parte do time Dental Center. Por favor deixe suas informações, entraremos em contato.
              </p>
              <div >
              <Alert id="id_alerta" variant='danger'  color='danger' style={{display: 'none', marginBottom:0, marginTop:0, fontSize : 14 }}>
                   </Alert>   
               <Alert id="id_success"  variant='success'  color='success' style={{display: 'none', marginBottom:0, fontSize : 14}}>
                   </Alert>  
              </div>
              <div onClick={this.selectHiperMasterSim.bind(this)} className="button_contact_dental">
                             <span >SIM</span>
              </div>   
              <div onClick={this.selectHiperMasterNao.bind(this)} className="button_contact_dental">
                             <span   >NÃO</span>
              </div>                 
            </Container>
          </div>
        </Modal> */}

        <Dialog
          modal={false}
          open={this.state.modalPriorizarCadastro}
          onRequestClose={this.handlePriorizarCadastroClose.bind(this)}
        >
          <p className="modal_title">ATENÇÃO</p>
          <div className="modal_error_text">
          Agora que vai cadastrar os demais beneficiários do plano, a PREFERÊNCIA é que COMECE por um dependente maior de idade sendo o primeiro titular. Caso não tenha, prossiga normalmente.
          </div>
          <div style={{textAlign:"center"}}>
            <Button onClick={this.handlePriorizarCadastroClose.bind(this)} className="modal_button1" >FECHAR</Button>{''}
          </div>
        </Dialog>



         <Dialog
          modal={false}
          open={this.state.openModalHiper}
          onRequestClose={this.handleHiperMasterClose.bind(this)}
        >
          <p className="modal_title">ATENÇÃO</p>
          <div className="modal_error_text">
          Confirme a bandeira do cartão:
          </div>
          <div style={{textAlign:"center"}}>
          <Button onClick={this.selectHiperMasterSim.bind(this)} className="modal_button1" >HIPER</Button>{''}
            <Button onClick={this.selectHiperMasterNao.bind(this)} className="modal_button1" >MASTER</Button>{''}
          </div>
        </Dialog>




        <Dialog
          modal={true}
          open={this.state.modalError}
          onRequestClose={this.handleErrorClose.bind(this)}
        >
          <p className="modal_title">ATENÇÃO</p>
          <div className="modal_error_text">
            Por favor, verifique o formulário,
            preencha os campos obrigatórios, e informe dados válidos.
          </div>
          <div style={{textAlign:"center"}}>
            <Button onClick={this.handleErrorClose.bind(this)} className="button_next_panel" >FECHAR</Button>{''}
          </div>
        </Dialog>

        <Dialog
          open={this.state.alertCardAvaliable}
          modal={true}
        >
          <p className="form_p_client">ATENÇÃO!</p>
          <div className="subtitle_dependents">
            <Row>
              <Col xs="12" sm="2" md="2" lg="2"></Col>
              <Col xs="12" sm="8" md="8" lg="8">
              <div style={{ fontSize:'14px',marginLeft: '20px',marginTop: '4px',textAlign: 'left'}}>
              {this.state.messagesErrorCard},

                 
            </div>              </Col>
              <Col xs="12" sm="2" md="2" lg="2"></Col>
            </Row>
          </div>
          <Row style={{ marginTop: '-40px' }}>
            <Col md="3" lg="3"></Col>
            <Col xs="12" sm="12" md="6" lg="6">              
                <div className="button_plans" onClick={this.onCloseModalValidateCard.bind(this)}>
                  <span>Fechar</span>
                </div>              
            </Col>
            <Col md="3" lg="3"></Col>
          </Row>

        </Dialog>


        {/*Modal sem dependentes */}
        <Dialog
          modal={true}
          open={this.state.modalNoDependents}
          onRequestClose={this.handleNoDependentsClose.bind(this)}
        >
          <p className="modal_title">ATENÇÃO</p>
          <div className="modal_error_text">
            Deseja prosseguir sem adicionar dependentes?
          </div>
          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <Button 
                onClick={this.handleNoDependentsClose.bind(this)}
                style={{
                    ...Styles.buttonCancel,
                    backgroundColor: Colors.textLight,
                    textTransform: 'none'
                }} >
                  NÃO
            </Button>{''}
            <Button 
                onClick={this.nextAuxDependents.bind(this)}
                style={{
                  ...Styles.buttonSuccess,
                  fontWeight: 'bold',
                  textTransform: 'none'
                }} >
                SIM
            </Button>{''}
          </div>
        </Dialog>
        {/*Modal dependentes */}
        <Dialog
          modal={true}
          open={this.state.modalDependentsNext}
          onRequestClose={this.handleDependentsNextClose.bind(this)}
        >
          <p className="modal_title">FALTA POUCO!</p>
          <div className="modal_error_text">
            Você está a duas etapas de concluir a compra
            do seu plano. Agora é hora de anexar os documentos necessários.
          </div>
          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <Button 
                onClick={this.handleResumeOpen.bind(this)}
                style={{
                    ...Styles.buttonSuccess,
                    fontWeight: 'bold',
                    textTransform: 'none'
                }} >
                RESUMO DA PROPOSTA
            </Button>{''}
            <Button 
                onClick={this.nextAuxDependents2.bind(this)} 
                style={{
                    ...Styles.buttonSuccess,
                    fontWeight: 'bold',
                    textTransform: 'none'
                }} >
                  ANEXAR DOCUMENTOS
            </Button>{''}
          </div>
        </Dialog>
        {/*Modal sucesso envio da proposta */}
        <Dialog
          modal={true}
          open={this.state.modalSuccess}
          onRequestClose={this.handleSuccessClose.bind(this)}
        >
          <p className="modal_title">PARABÉNS</p>
          <div className="modal_error_text">
            Você pode acompanhar o andamento desta proposta em&nbsp;
            <Link
              onClick={this.handleSuccessClose.bind(this)}
              to={urlBase.client + 'panel/proposals/awaitingSolution'}
            >
              <span style={{color: '#d51125', textDecoration: 'underline'}}>
                Listagem de Propostas
              </span>
            </Link>
          </div>
          <div style={{textAlign:"center"}}>
            <Link className="p_success" to={urlBase.client + 'panel'}>
              <Button onClick={this.handleSuccessClose.bind(this)} className="modal_button2" >FECHAR</Button>{''}
            </Link>
          </div>
        </Dialog>
        {/*Modal resumo */}

        <ReactToPrint
          ref={el => (this.printRef = el)}
          trigger={() => <span>{''}</span>}
          content={() => this.componentRef}
        />
{/* incicio do dialog*/}

        <Dialog
          modal={true}
          open={this.state.modalResume}
          onRequestClose={this.handleResumeClose.bind(this)}
          autoScrollBodyContent={true}
          contentStyle={this.styles.modal}
          className='modalPrint'
          //classNames={{modal: 'custom-resume-proposal custom-resume-proposal-form'}}
          title={
            <div className="print_resume" ref={el => (this.componentRef = el)}>
              <div className="logo_modal_resume navbar-brand">&nbsp;</div>
              <div style={{display: 'inline-block', verticalAlign: 'bottom', marginLeft: 10}}>
                <h2 className="title_modal_resume">RESUMO DA PROPOSTA</h2>
                <h3 className="title_modal_resume2">{this.state.planoSelecionado.tradeName || ""}</h3>               
              </div>
              <i
                id="modal_wallet_slip_close_modal"
                className="fas fa-times-circle color_fa"
                onClick={this.handleResumeClose.bind(this)}
              >{''}</i>
            </div>
          }
        >
          <div id="print_resume" ref={el => (this.componentRef = el)}>
            <div className="print_resume" id="modal_resume_parcial">
              <div className="modal_resume">
                <div className="resume_title"><span>RESPONSÁVEL FINANCEIRO</span></div>
                <Row style={{marginBottom: 15}}>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="5" xl="5">
                    <label className="label_bold2">Nome: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.firstName+' '+this.state.financialManager.lastName }
                    </p>
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">CPF: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.cpf }
                    </p>
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">RG: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.rg+" / "+this.state.financialManager.rgEmitter }
                    </p>
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Data de Nasc.: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.dateOfBirth }
                    </p>
                  </Col>
                </Row>
                <Row style={{marginBottom: 15}}>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="5" xl="5">
                    <label className="label_bold2">Mãe: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.motherName}
                    </p>
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Estado civil: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.maritalStatus}
                    </p>
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Cartão do SUS: </label>
                    {this.state.financialManager.susNumber == "" ?(
                      <p className="p_text_resume">Não informado</p>
                    ):(
                      <p className="p_text_resume">{this.state.financialManager.susNumber}</p>
                    )}
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Telefone: </label>
                    {this.state.financialManager.homePhone == "" ?(
                      <p className="p_text_resume">Não informado</p>
                    ):(
                      <p className="p_text_resume">{this.state.financialManager.homePhone}</p>
                    )}
                  </Col>
                </Row>
                <Row style={{marginBottom: 15}}>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Celular 1: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.cellPhone}
                    </p>
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Celular 2: </label>
                    {this.state.financialManager.cellPhone2 == "" ?(
                      <p className="p_text_resume">Não informado</p>
                    ):(
                      <p className="p_text_resume">{this.state.financialManager.cellPhone2}</p>
                    )}
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Email: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.email}
                    </p>
                  </Col>
                 
                </Row>
                {
                   this.state.isServidor ? (
                    <Row>
                      <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                        <label className="label_bold2">Empresa: </label>
                        <p className="p_text_resume">
                          {this.state.nomeEmpresa}
                        </p>
                      </Col> 
                      <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                        <label className="label_bold2">Matrícula do Servidor: </label>
                        <p className="p_text_resume">
                          {this.state.financialManager.matServidor}
                        </p>
                      </Col>                                     
                    </Row>
                  ) : ''
                }

                <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>
                <div className="resume_title"><span>ENDEREÇO</span></div>

                <Row style={{marginBottom: 15}}>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Tipo de Lograd.: </label>
                    {this.state.addressTypeList.map((item, index) =>
                      item.Id == this.state.financialManager.addressType ? (
                    <p key={index} className="p_text_resume">
                      {" "+item.Nome}
                    </p>
                      ):("")
                    )}
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="9" xl="9">
                    <label className="label_bold2">Rua: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.address+", N°: "+this.state.financialManager.addressNumber}
                    </p>
                  </Col>
                </Row>

                <Row style={{marginBottom: 15}}>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Complemento: </label>
                    {this.state.financialManager.addressComplement == "" ? (
                      <p className="p_text_resume">
                        Não informado
                      </p>
                    ):(
                      <p className="p_text_resume">
                        {this.state.financialManager.addressComplement}
                      </p>
                    )}
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Bairro: </label>
                    <p className="p_text_resume">
                    {this.state.nomeBairro}
                    </p>

                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Cidade: </label>
                    {this.state.cityList.map((item, index) =>
                      item.Id == this.state.financialManager.city ?(
                        <p key={index} className="p_text_resume">
                          {" "+item.Nome}
                        </p>
                      ):("")
                    )}
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="1" xl="1">
                    <label className="label_bold2">U.F.: </label>
                    {this.state.stateList.map((item, index) =>
                      item.Id == this.state.financialManager.state ? (
                        <p key={index} className="p_text_resume">
                          {" "+item.Sigla}
                        </p>
                      ):("")
                    )}
                  </Col>
                  <Col className="col-print" xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">CEP: </label>
                    <p className="p_text_resume">
                      {this.state.financialManager.cep}
                    </p>
                  </Col>
                </Row>

                <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>
              </div>

              {
                this.state.dependentsList.length > 0 ? (
              <div className="modal_resume">
                <div className="resume_title"><span>TITULAR</span></div>

                <Row style={{marginBottom: 15}}>
                  <Col xs="12" sm="12" md="6" lg="5" xl="5">
                    <label className="label_bold2">Nome: </label>
                    <p className="p_text_resume">
                      {this.state.dependentsList[0].firstName + " " + this.state.dependentsList[0].lastName}
                    </p>
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">CPF: </label>
                    <p className="p_text_resume">
                      {this.state.dependentsList[0].cpf}
                    </p>
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Data de Nasc.: </label>
                    <p className="p_text_resume">
                      {this.state.dependentsList[0].dateOfBirth}
                    </p>
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Estado civil: </label>
                    <p className="p_text_resume">
                      {this.state.dependentsList[0].maritalStatus}
                    </p>
                  </Col>
                </Row>

                <Row style={{marginBottom: 15}}>
                  <Col xs="12" sm="12" md="6" lg="5" xl="5">
                    <label className="label_bold2">Mãe: </label>
                    <p className="p_text_resume">
                      {this.state.dependentsList[0].motherName}
                    </p>
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Plano:</label>
                    <p style={{fontFamily:"RobotoBold"}} className="p_text_resume">
                      {this.state.dependentsList[0].planName}
                    </p>
                  </Col>                  
                  <Col xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Valor Individual:</label>
                    <p style={{fontFamily:"RobotoBold"}} className="p_text_resume">
                      {' R$ '+this.state.dependentsList[0].valuePlan}
                    </p>
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Portabilidade:</label>
                    <p style={{fontFamily:"RobotoBold"}} className="p_text_resume">
                      {this.state.dependentsList[0].portability ? "SIM" : "NÃO"}
                    </p>
                  </Col>                  
                </Row>
                <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>
              </div>
                ) : ('')
              }

              {
                this.state.dependentsList.length > 1 ? (
              <div style={{marginTop: 30}}>
                <div className="resume_title"><span>DEPENDENTES</span></div>
                {
                  this.state.dependentsList.map((item, index) =>
                  index > 0 ? (
                <div className="modal_resume">
                  <Row style={{marginBottom: 15}}>
                    <Col xs="12" sm="12" md="6" lg="5" xl="5">
                      <label className="label_bold2">Nome: </label>
                      <p className="p_text_resume">
                        {item.firstName + " " + item.lastName}
                      </p>
                    </Col>
                    <Col xs="12" sm="12" md="6" lg="2" xl="2">
                      <label className="label_bold2">CPF: </label>
                      <p className="p_text_resume">
                        {item.cpf}
                      </p>
                    </Col>
                    <Col xs="12" sm="12" md="6" lg="3" xl="3">
                      <label className="label_bold2">Data de Nasc.: </label>
                      <p className="p_text_resume">
                        { item.dateOfBirth.substring(8,11) + "/"+item.dateOfBirth.substring(5,7) + "/"+ item.dateOfBirth.substring(0,4) }
                      </p>
                    </Col>
                    <Col xs="12" sm="12" md="6" lg="2" xl="2">
                      <label className="label_bold2">Estado civil: </label>
                      <p className="p_text_resume">
                        {item.maritalStatus}
                      </p>
                    </Col>
                  </Row>

                  <Row  style={{marginBottom: 15}}>
                    <Col xs="12" sm="12" md="6" lg="5" xl="5">
                      <label className="label_bold2">Mãe: </label>
                      <p className="p_text_resume">
                        {item.motherName}
                      </p>
                    </Col>
                    <Col xs="12" sm="12" md="6" lg="2" xl="2">
                      <label className="label_bold2">Plano </label>
                      <p className="p_text_resume">
                        {item.planName}
                      </p>
                    </Col>                    
                    <Col xs="12" sm="12" md="6" lg="3" xl="3">
                      <label className="label_bold2">Valor Individual:</label>
                      <p style={{fontFamily:"RobotoBold"}} className="p_text_resume">
                        {"R$ " + item.valuePlan}
                      </p>
                    </Col>
                    <Col xs="12" sm="12" md="6" lg="2" xl="2">
                      {index == 0 ? (""):(
                        <div>
                          <label className="label_bold2">Parentesco: </label>
                          <p className="p_text_resume">
                            {item.parentage}
                          </p>
                        </div>
                      )}
                    </Col>
               
                  </Row>
                     
                    <Row>
                    <Col xs="12" sm="12" md="6" lg="5" xl="5">
                      {index == 0 ? (""):(
                        <div>
                          <label className="label_bold2">Portabilidade: </label>
                          <p className="p_text_resume">
                            {item.portability ? "SIM" : "NÃO"}
                          </p>
                        </div>
                      )}
                    </Col>  
                   </Row>
                  <hr style={{width:"75%", margin: '30px auto'}}/>
                </div>
                  ) : ('')
                  )}
              </div>
                ) : ('')
              }
              {/** INICIO CARENCIA*/}
              <div className="modal_resume">
                <div className="resume_title"><span>INFORMAÇÕES DO PLANO</span></div>
                <Row>
                  <Col xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Nome do plano:</label>
                    <p className="p_text_resume">
                      { this.state.planoSelecionado.tradeName || "" }
                    </p>
                    <label className="label_bold2">referência ANS:</label>
                    <p className="p_text_resume">
                      { this.state.planoSelecionado.name }
                    </p>                    
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="2" xl="2">
                    <label className="label_bold2">Valor total:</label>
                    <p style={{fontFamily:"RobotoBold"}} className="p_text_resume">
                      {"R$ " + this.state.value_total}
                    </p>
                   
                  </Col>

                  <Col xs="12" sm="12" md="6" lg="3" xl="3">
                    <label className="label_bold2">Nome da corretora:</label>
                    <p className="p_text_resume">
                    {this.state.nameBroker}
                    </p>
                  </Col>
                  <Col xs="12" sm="12" md="6" lg="4" xl="4">
                    <label className="label_bold2">Nome do vendedor:</label>
                    <p className="p_text_resume">
                      {this.state.nameSalesman}
                    </p>
                  </Col>
                </Row>

                <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>

                <Row>
                  <Col xs="12" sm="12" md="12" lg="12" xl="12"  style={{color:"#d51125",textAlign:"center"}}>
                    <div className="resume_title"><span>TERMO ADITIVO DE REDUÇÃO DE CARÊNCIA</span></div>
                  </Col>
                </Row>
                {/* CARÊNCIA DINAMICA */}
                
{/* Mapeia e exibe a tabela de carência para cada plano único contratado na proposta */}
{this.getPlanosUnicosNaProposta().map((planoItem, planoIndex) => (
  <div key={planoIndex} style={{ marginBottom: '25px' }}>
    <h4 style={{ fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: '10px' }}>
      Plano: {planoItem.tradeName || planoItem.name}
    </h4>
    <Row>
      <Col className="" xs="12" sm="12" md="12" lg="12" xl="12">
        {/* Adicionado style={{ width: '100%', tableLayout: 'fixed' }} na tabela para respeitar as larguras definidas */}
        <table style={{ width: '100%', tableLayout: 'fixed' }}>
          <thead>
            <tr>
              <th style={{ borderTopLeftRadius: 15, width: '70%' }}>COBERTURAS</th>
                { this.state.isServidor ? (
                    <th style={{ borderTopRightRadius: 15, width: '30%' }}>DESCONTO EM FOLHA</th>
                  ) : this.state.payment_plan === 'false' ? (
                    <th style={{ borderTopRightRadius: 15, width: '30%' }}>BOLETO BANCÁRIO</th>
                  ) : (
                    <th style={{ borderTopRightRadius: 15, width: '30%' }}>CARTÃO DE CRÉDITO</th>
                  )
                }
            </tr>
          </thead>
          <tbody>
            { 
              planoItem.carenciaGroups && planoItem.carenciaGroups.length > 0 ? (
                planoItem.carenciaGroups.map((carencia, idx) => {
                  const isLast = idx === planoItem.carenciaGroups.length - 1;
                  const styleLeft = isLast ? { borderBottomLeftRadius: 10, width: '70%' } : { width: '70%' };
                  const styleRight = isLast ? { borderBottomRightRadius: 10, width: '30%' } : { width: '30%' };

                  const textoCarencia = 
                    this.state.isServidor ? carencia.server : this.state.payment_plan == 'true' ? carencia.card : carencia.ticket;

                  return (
                    <tr key={idx}>
                      <td 
                        style={styleLeft} 
                        className={`text_table_family3 ${idx > 0 ? 'td_border_top' : ''}`}
                      >
                        {carencia.name ? carencia.name.toUpperCase() : ''}
                      </td>
                      <td 
                        style={styleRight} 
                        className={`text_table_family3 td_border_left ${idx > 0 ? 'td_border_top' : ''}`}
                      >
                        {textoCarencia || 'Sem informação'}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td style={{ borderBottomLeftRadius: 10, width: '70%' }} className="text_table_family3">
                    Sem informações de cobertura para este plano
                  </td>
                  <td style={{ borderBottomRightRadius: 10, width: '30%' }} className="text_table_family3 td_border_left">--</td>
                </tr>
              )
            }
          </tbody>
        </table>
      </Col>
    </Row>
  </div>
))}

              </div>

              <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>

              {/**********exibe mais informações do resumo - COMPLETO ***************/}
              { this.state.phasesForm == 4 ? (
                <div className="pagebreak">
                    <div className="modal_resume">
                      <div className="resume_title"><span>DOCUMENTOS</span></div>
                      <Row>   
                        {this.state.isServidor && (
                          <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <label className="label_bold2">
                              AUTORIZAÇÃO DE AVERBAÇÃO:
                            </label>
                          <p className="p_text_resume">
                            Em anexo
                          </p>
                          </Col>
                        )}                                          
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">CPF:</label>
                          <p className="p_text_resume">
                          Em anexo
                          </p>
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">RG:</label>
                          <p className="p_text_resume">
                            Em anexo
                          </p>
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">Comprovante de Residência:</label>
                          <p className="p_text_resume">
                            Em anexo
                          </p>
                        </Col>

                      </Row>
                    </div>
                    <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>

                    {/* TERMOS */}
                    <div className="modal_resume">
                        <div className="resume_title">
                          <span>TERMOS</span>
                        </div>

                        <Row style={{ marginBottom: 15 }}>
                          <Col xs="12" sm="12" md="6" lg="6" xl="6">
                              <label className="label_bold2">
                                Li e aceito os termos de contratação
                              </label>
                              <p className="p_text_resume">
                                Sim
                              </p>
                          </Col>
                      </Row>
                    </div>  
                   <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>

                { this.state.isServidor ? (

                    /* SERVIDOR PÚBLICO */

                    <div className="modal_resume">
                      <div className="resume_title">
                        <span>FORMA DE PAGAMENTO</span>
                      </div>

                      <Row style={{ marginBottom: 15 }}>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">
                            Pagamento:
                          </label>

                          <p className="p_text_resume">
                            DESCONTO EM FOLHA
                          </p>
                        </Col>

                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">
                            Data de adesão:
                          </label>

                          <p className="p_text_resume">
                            {this.state.effectiveDate}
                          </p>
                        </Col>

                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">
                            Matrícula:
                          </label>

                          <p className="p_text_resume">
                            {this.state.financialManager.matServidor}
                          </p>
                        </Col>
                      </Row>
                    </div>

                  ) : this.state.payment_plan === "true" ? (

                    /* CARTÃO DE CRÉDITO */

                    <div className="modal_resume">
                      <div className="resume_title">
                        <span>DADOS FINANCEIROS</span>
                      </div>

                      <Row>
                        <Col xs="12" sm="12" md="6" lg="6" xl="6">
                          <label className="label_bold2">
                            Cartão de crédito:
                          </label>

                          <p className="p_text_resume">
                            {this.state.paymentCreditCard.flagCardPayment}
                          </p>
                        </Col>

                        <Col xs="12" sm="12" md="6" lg="6" xl="6">
                          <label className="label_bold2">
                            Final do cartão:
                          </label>

                          <p className="p_text_resume">
                            {"XXXX.XXXX.XXXX." +
                              this.state.paymentCreditCard.cardNumberFourFinal}
                          </p>
                        </Col>
                      </Row>

                      <Row>
                        <Col xs="12" sm="12" md="6" lg="6" xl="6">
                          <label className="label_bold2">
                            Nome do titular do cartão:
                          </label>

                          <p className="p_text_resume">
                            {this.state.paymentCreditCard.cardHolderName}
                          </p>
                        </Col>

                        <Col xs="12" sm="12" md="6" lg="6" xl="6">
                          <label className="label_bold2">
                            Validade do cartão:
                          </label>

                          <p className="p_text_resume">
                            {this.state.paymentCreditCard.cardExpiring}
                          </p>
                        </Col>
                      </Row>

                                          <Row>
                                          <Col xs="12" sm="12" md="6" lg="6" xl="6">
                                            <label className="label_bold2">O lançamento da parcela em sua fatura será todo dia:</label>
                                            <p className="p_text_resume">
                                              {this.state.effectiveDate}
                                            </p>
                                          </Col>
                                          <Col xs="12" sm="12" md="6" lg="6" xl="6">
                                            <label className="label_bold2">Cartão pertencente a algum usuário do plano? </label>
                                            { this.state.habilitaCpfCartao== true ? (
                                              [<p className="p_text_resume">Não</p>,
                                              <label className="label_bold2">CPF do dono do cartão:</label>,
                                              <p className="p_text_resume"> {this.state.financialManager.cpfCard}</p>
                                            ]
                                          
                                            ):(
                                          <p className="p_text_resume">
                                            Sim
                                          </p>
                                            )
                                          }                          
                                          </Col>    
                                                              
                                        </Row>
                                      </div>

                                    ): (//boleto bancario	
                              <div className="modal_resume">
                      <div className="resume_title">
                        <span>FORMA DE PAGAMENTO</span>
                      </div>

                      <Row style={{ marginBottom: 15 }}>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">
                            Pagamento:
                          </label>

                          <p className="p_text_resume">
                            BOLETO BANCÁRIO
                          </p>
                        </Col>

                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                          <label className="label_bold2">
                            Data de adesão:
                          </label>

                          <p className="p_text_resume">
                            {this.state.effectiveDate}
                          </p>
                        </Col>


                      </Row>
                    </div>                      
                )}

                <hr style={{width:"100%", margin: '30px auto', backgroundColor: "#ccc"}}/>

                <div className="modal_resume">
                  <div>
                    <Row>
                      <Col xs="12" sm="12" md="12" lg="12" xl="12">
                        <label className="label_bold2">A combinar:</label>
                        <p className="p_text_resume">
                          Pagamento a combinar com o vendedor...
                        </p>
                      </Col>
                    </Row>
                  </div>
                </div>

                <div style={{ 
                  marginTop: '30px', 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  gap: '10px',
                  paddingBottom: '20px' 
                }}>
                  <hr />
                      <Button  
                              style={{
                                ...Styles.buttonSuccess,
                                fontWeight: 'bold',
                                textTransform: 'none'
                              }} 
                              ref={btn => { this.btn = btn; }}
                              onClick={this.openPDF} >
                                IMPRIMIR
                          </Button>                  
                        {this.state.btnFinishSales == 'enable' ? (
                          
                          <Button  
                              style={{
                                ...Styles.buttonSuccess,
                                fontWeight: 'bold',
                                textTransform: 'none'
                              }} 
                              ref={btn => { this.btn = btn; }}
                              onClick={this.beforeSubmitForm.bind(this)} >
                                FINALIZAR
                          </Button>
 
                        ) : (                          
                            <div className='no-active'>
                              <div className="button_next_panel">ENVIANDO</div>
                            </div>
                          )}

                        <Button
                           style={{
                                  ...Styles.buttonCancel,
                                  backgroundColor: Colors.textLight,
                                  textTransform: 'none'
                            }}
                          onClick={this.handleResumeClose.bind(this)}>
                          FECHAR
                        </Button>
                           


                </div>
              </div>
              
            ):(
                  <div className="pagebreak" >
      
                        <Button  
                           style={{
                            ...Styles.buttonCancel,
                            backgroundColor: Colors.textLight,
                            textTransform: 'none'
                          }}                        
                          onClick={this.handleResumeClose.bind(this)}>
                          FECHAR
                        </Button>
                        {/*
                        <Button  className="button_next_panel" onClick={this.onResumePrint.bind(this)}>
                          IMPRIMIR
                        </Button>
                        */}

                        <Button
                            style={{
                              ...Styles.buttonSuccess,
                              fontWeight: 'bold',
                              textTransform: 'none'
                            }}                        
                         onClick={this.openPDF} >
                              <div >IMPRIMIR</div>
                        </Button> 
                   </div>
                )
              }
            </div>
          </div>              
        </Dialog>
{/* fim do dialog*/}
      </div>
    );

  }
}

FormPlan.defaultProps = {
  onClickFn: null,
  salesmanId: null,
};

FormPlan.propTypes = {
  onClickFn: PropTypes.func,
  salesmanId: PropTypes.string,
};

export default FormPlan;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Form/FormPlan.js
 **/